{
"eventos": [
	{
		"eventoid" : 502,
		"funcid" : 325,
		"desc_es" : "Pasajero no registrado",
		"desc_pt" : "Passageiros não registrada",
		"desc_en" : "Passenger not registered",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 530
	},
	{
		"eventoid" : 503,
		"funcid" : 290,
		"desc_es" : "Partial Shift Print",
		"desc_pt" : "Partial Shift Print",
		"desc_en" : "Partial Shift Print",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 531
	},
	{
		"eventoid" : 42,
		"funcid" : 24,
		"desc_es" : "Apertura de cisterna 2",
		"desc_pt" : "Abertura de cisterna 2",
		"desc_en" : "Tank 2 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 62
	},
	{
		"eventoid" : 504,
		"funcid" : 363,
		"desc_es" : "Detección de Fatiga",
		"desc_pt" : "Detecção de fadiga",
		"desc_en" : "Fatigue detection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 532
	},
	{
		"eventoid" : 505,
		"funcid" : 240,
		"desc_es" : "Descarga autorizada por Huella",
		"desc_pt" : "Baixar autorizada pela impressão",
		"desc_en" : "Download authorized by Footprint",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 533
	},
	{
		"eventoid" : 506,
		"funcid" : 240,
		"desc_es" : "Descarga no autorizada por Huella",
		"desc_pt" : "Baixar não autorizado pela impressão",
		"desc_en" : "Download not authorized by Footprint",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 534
	},
	{
		"eventoid" : 43,
		"funcid" : 24,
		"desc_es" : "Apertura de cisterna 3",
		"desc_pt" : "Abertura da cisterna 3",
		"desc_en" : "Tank 3 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 63
	},
	{
		"eventoid" : 45,
		"funcid" : 24,
		"desc_es" : "Apertura de cisterna 5",
		"desc_pt" : "Abertura de cisterna 5",
		"desc_en" : "Tank 5 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 65
	},
	{
		"eventoid" : 174,
		"funcid" : 24,
		"desc_es" : "Apertura de cisterna 8",
		"desc_pt" : "Abertura de cisterna 8",
		"desc_en" : "Tank 8 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 68
	},
	{
		"eventoid" : 956,
		"funcid" : 500,
		"desc_es" : "Inicio de uso continuo del implemento",
		"desc_pt" : "Inicio de uso continuo do implemento",
		"desc_en" : "Start of continuous use of the implement",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2527
	},
	{
		"eventoid" : 957,
		"funcid" : 500,
		"desc_es" : "Fin de uso continuo del implemento",
		"desc_pt" : "Fim de uso continuo do implemento",
		"desc_en" : "End of continuous use of the implement",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2528
	},
	{
		"eventoid" : 47,
		"funcid" : 24,
		"desc_es" : "Cierre de cisterna 1",
		"desc_pt" : "Cisterna fechada 1",
		"desc_en" : "Tank 1 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 69
	},
	{
		"eventoid" : 60,
		"funcid" : 27,
		"desc_es" : "Volquete arriba",
		"desc_pt" : "Basculante erguido",
		"desc_en" : "Dump truck up",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 187
	},
	{
		"eventoid" : 48,
		"funcid" : 24,
		"desc_es" : "Cierre de cisterna 2",
		"desc_pt" : "Cisterna fechada 2",
		"desc_en" : "Tank 2 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 70
	},
	{
		"eventoid" : 49,
		"funcid" : 24,
		"desc_es" : "Cierre de cisterna 3",
		"desc_pt" : "Cisterna fechada 3",
		"desc_en" : "Tank 3 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 71
	},
	{
		"eventoid" : 50,
		"funcid" : 24,
		"desc_es" : "Cierre de cisterna 4",
		"desc_pt" : "Cisterna fechada 4",
		"desc_en" : "Tank 4 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 72
	},
	{
		"eventoid" : 51,
		"funcid" : 24,
		"desc_es" : "Cierre de cisterna 5",
		"desc_pt" : "Cisterna fechada 5",
		"desc_en" : "Tank 5 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 73
	},
	{
		"eventoid" : 770,
		"funcid" : 434,
		"desc_es" : "Inicio Descenso Autorizado",
		"desc_pt" : "Início Descida Autorizada",
		"desc_en" : "Start Authorized Descent",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2394
	},
	{
		"eventoid" : 958,
		"funcid" : 240,
		"desc_es" : "Inicio de descarga de gas",
		"desc_pt" : "Início de baixar de gás",
		"desc_en" : "Start of gas discharge",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2529
	},
	{
		"eventoid" : 507,
		"funcid" : 240,
		"desc_es" : "Descarga autorizada en Forma Remota",
		"desc_pt" : "Baixar autorizada Remotamente",
		"desc_en" : "Download authorized in Remote Form",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 535
	},
	{
		"eventoid" : 508,
		"funcid" : 240,
		"desc_es" : "Descarga bloqueada en Forma Remota",
		"desc_pt" : "Baixar Trancado Remotamente",
		"desc_en" : "Download blocked in Remote Form",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 536
	},
	{
		"eventoid" : 509,
		"funcid" : 240,
		"desc_es" : "Descarga autorizada por Huella",
		"desc_pt" : "Baixar autorizada pela impressão",
		"desc_en" : "Download authorized by Footprint ",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 537
	},
	{
		"eventoid" : 52,
		"funcid" : 24,
		"desc_es" : "Cierre de cisterna 6",
		"desc_pt" : "Cisterna fechada 6",
		"desc_en" : "Tank 6 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 74
	},
	{
		"eventoid" : 959,
		"funcid" : 240,
		"desc_es" : "Fin de descarga de gas",
		"desc_pt" : "Fim de baixar de gás",
		"desc_en" : "End of gas discharge",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2530
	},
	{
		"eventoid" : 968,
		"funcid" : 439,
		"desc_es" : "Master conectado",
		"desc_pt" : "Mestre conectado",
		"desc_en" : "Connected Master",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2532
	},
	{
		"eventoid" : 1274,
		"funcid" : 265,
		"desc_es" : "Luces encendidas",
		"desc_pt" : "Farol ligado",
		"desc_en" : "Lights on",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2802
	},
	{
		"eventoid" : 175,
		"funcid" : 24,
		"desc_es" : "Cierre de cisterna 7",
		"desc_pt" : "Cisterna fechada 7",
		"desc_en" : "Tank 7 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 75
	},
	{
		"eventoid" : 920,
		"funcid" : 404,
		"desc_es" : "Apertura de Válvula 7",
		"desc_pt" : "Abertura da válvula 7",
		"desc_en" : "Valve 7 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2492
	},
	{
		"eventoid" : 176,
		"funcid" : 24,
		"desc_es" : "Cierre de cisterna 8",
		"desc_pt" : "Cisterna fechada 8",
		"desc_en" : "Tank 8 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 76
	},
	{
		"eventoid" : 299,
		"funcid" : 160,
		"desc_es" : "Fuera de ruta alerta",
		"desc_pt" : "Fora de rota alerta",
		"desc_en" : "Outside route alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1317
	},
	{
		"eventoid" : 372,
		"funcid" : 32,
		"desc_es" : "Activación de Sirena",
		"desc_pt" : "Ativação de Sirene",
		"desc_en" : "Siren Activation",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 380
	},
	{
		"eventoid" : 300,
		"funcid" : 160,
		"desc_es" : "Dentro de ruta alerta",
		"desc_pt" : "Dentro de rota alerta",
		"desc_en" : "Inside route alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1318
	},
	{
		"eventoid" : 511,
		"funcid" : 216,
		"desc_es" : "Incumplimiento de inicio de viaje",
		"desc_pt" : "Violação de horário de início de viagem",
		"desc_en" : "Not complied trip start",
		"eventotablaid" : 3,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1426
	},
	{
		"eventoid" : 435,
		"funcid" : 37,
		"desc_es" : "Puerta liberada",
		"desc_pt" : "Portão liberado",
		"desc_en" : "Door liberated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 465
	},
	{
		"eventoid" : 436,
		"funcid" : 37,
		"desc_es" : "Puerta trabada",
		"desc_pt" : "Porta fechada",
		"desc_en" : "Door locked",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 466
	},
	{
		"eventoid" : 512,
		"funcid" : 216,
		"desc_es" : "Incumplimiento de fin de viaje",
		"desc_pt" : "Violação de horário de fin de viagem",
		"desc_en" : "Not complied trip finish",
		"eventotablaid" : 3,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1427
	},
	{
		"eventoid" : 960,
		"funcid" : 108,
		"desc_es" : "Preaviso conducción continua",
		"desc_pt" : "Visualizar a direção contínua",
		"desc_en" : "Preview continuous driving",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 120
	},
	{
		"eventoid" : 961,
		"funcid" : 316,
		"desc_es" : "Apertura de panel 01",
		"desc_pt" : "Apertura de panel 01",
		"desc_en" : "Apertura de panel 01",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 121
	},
	{
		"eventoid" : 962,
		"funcid" : 316,
		"desc_es" : "Cierre de panel 01",
		"desc_pt" : "Cierre de panel 01",
		"desc_en" : "Cierre de panel 01",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 122
	},
	{
		"eventoid" : 513,
		"funcid" : 283,
		"desc_es" : "Tiempo de conducción continua excedido (4 hs.)",
		"desc_pt" : "Tempo de direção contínua excedido (4 hs.)",
		"desc_en" : "Continuous driving time exceeded (4 hs.)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 538
	},
	{
		"eventoid" : 514,
		"funcid" : 283,
		"desc_es" : "Tiempo de conducción continua excedido (5 hs.)",
		"desc_pt" : "Tempo de direção contínua excedido (5 hs.)",
		"desc_en" : "Continuous driving time exceeded (5 hs.)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 539
	},
	{
		"eventoid" : 301,
		"funcid" : 160,
		"desc_es" : "Cambio de sentido alerta",
		"desc_pt" : "Mudança de sentido alerta",
		"desc_en" : "Way change alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1319
	},
	{
		"eventoid" : 61,
		"funcid" : 27,
		"desc_es" : "Volquete abajo",
		"desc_pt" : "Basculante abaixado",
		"desc_en" : "Dump truck low",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 188
	},
	{
		"eventoid" : 30,
		"funcid" : 16,
		"desc_es" : "Temperatura baja camara 1",
		"desc_pt" : "Temperatura baixa câmara 1",
		"desc_en" : "Low temperature chamber 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1900
	},
	{
		"eventoid" : 375,
		"funcid" : 24,
		"desc_es" : "Apertura caja válvulas",
		"desc_pt" : "Apertura caja válvulas",
		"desc_en" : "Valve box opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 383
	},
	{
		"eventoid" : 376,
		"funcid" : 24,
		"desc_es" : "Cierre caja válvulas",
		"desc_pt" : "Cierre caja válvulas",
		"desc_en" : "Valve box locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 384
	},
	{
		"eventoid" : 377,
		"funcid" : 29,
		"desc_es" : "Partida del Cliente",
		"desc_pt" : "Partida del Cliente",
		"desc_en" : "Client departure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 385
	},
	{
		"eventoid" : 380,
		"funcid" : 263,
		"desc_es" : "Inicio bloqueo señal GPS",
		"desc_pt" : "Inicio bloqueo señal GPS",
		"desc_en" : "GPS signal block start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 388
	},
	{
		"eventoid" : 87,
		"funcid" : 17,
		"desc_es" : "Activación bypass temperatura",
		"desc_pt" : "ByPass de temperatura ativado",
		"desc_en" : "Temperature bypass activation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 204
	},
	{
		"eventoid" : 88,
		"funcid" : 17,
		"desc_es" : "Desactivación bypass temperatura",
		"desc_pt" : "Desativação bypass temperatura",
		"desc_en" : "Temperature bypass deactivation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 205
	},
	{
		"eventoid" : 159,
		"funcid" : 115,
		"desc_es" : "Emergencia",
		"desc_pt" : "Emergência",
		"desc_en" : "Emergency",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 232
	},
	{
		"eventoid" : 177,
		"funcid" : 121,
		"desc_es" : "Macro",
		"desc_pt" : "Macro",
		"desc_en" : "Macro",
		"eventotablaid" : 8,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1031
	},
	{
		"eventoid" : 381,
		"funcid" : 263,
		"desc_es" : "Fin bloqueo señal GPS",
		"desc_pt" : "Fin bloqueo señal GPS",
		"desc_en" : "GPS signal block end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 389
	},
	{
		"eventoid" : 565,
		"funcid" : 107,
		"desc_es" : "Inicio de turno",
		"desc_pt" : "Início turno",
		"desc_en" : "Work shift start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2187
	},
	{
		"eventoid" : 832,
		"funcid" : 182,
		"desc_es" : "Punto activo",
		"desc_pt" : "Punto activo",
		"desc_en" : "Point active",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 390
	},
	{
		"eventoid" : 833,
		"funcid" : 182,
		"desc_es" : "Punto finalizado",
		"desc_pt" : "Punto finalizado",
		"desc_en" : "Point competed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 391
	},
	{
		"eventoid" : 834,
		"funcid" : 182,
		"desc_es" : "Punto no leido, Inactivo",
		"desc_pt" : "Punto no leido, Inactivo",
		"desc_en" : "Point not read, inactive",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 392
	},
	{
		"eventoid" : 835,
		"funcid" : 182,
		"desc_es" : "Punto leido, Inactivo",
		"desc_pt" : "Punto leido, Inactivo",
		"desc_en" : "Point read, inactive",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 393
	},
	{
		"eventoid" : 836,
		"funcid" : 182,
		"desc_es" : "Punto borrado",
		"desc_pt" : "Punto borrado",
		"desc_en" : "Point deleted",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 394
	},
	{
		"eventoid" : 837,
		"funcid" : 182,
		"desc_es" : "Punto arribo estimado",
		"desc_pt" : "Punto arribo estimado",
		"desc_en" : "Point estimated arrival",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 395
	},
	{
		"eventoid" : 838,
		"funcid" : 37,
		"desc_es" : "Destrabe de puertas remoto",
		"desc_pt" : "Destrabe de puertas remoto",
		"desc_en" : "Remote door unlocking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 396
	},
	{
		"eventoid" : 839,
		"funcid" : 37,
		"desc_es" : "Destrabe de puertas local",
		"desc_pt" : "Destrabe de puertas local",
		"desc_en" : "Unlocking local doors",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 396
	},
	{
		"eventoid" : 969,
		"funcid" : 439,
		"desc_es" : "Master desconectado",
		"desc_pt" : "Mestre offline",
		"desc_en" : "Master Offline",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2533
	},
	{
		"eventoid" : 264,
		"funcid" : 166,
		"desc_es" : "Sleep Mode",
		"desc_pt" : "Sleep Mode",
		"desc_en" : "Sleep Mode",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 291
	},
	{
		"eventoid" : 869,
		"funcid" : 124,
		"desc_es" : "Terminal Encendido",
		"desc_pt" : "Terminal Inicializado",
		"desc_en" : "Terminal On",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2246
	},
	{
		"eventoid" : 870,
		"funcid" : 124,
		"desc_es" : "Terminal Apagado",
		"desc_pt" : "Terminal Desligado",
		"desc_en" : "Terminal Off",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2247
	},
	{
		"eventoid" : 423,
		"funcid" : 297,
		"desc_es" : "Botón 1 presionado",
		"desc_pt" : "Botão 1 pressionado",
		"desc_en" : "Button 1 pressed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1453
	},
	{
		"eventoid" : 624,
		"funcid" : 73,
		"desc_es" : "Código de Falla",
		"desc_pt" : "Código de Falha",
		"desc_en" : "Fault Code",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2248
	},
	{
		"eventoid" : 366,
		"funcid" : 259,
		"desc_es" : "Apertura de Domo 1",
		"desc_pt" : "Abertura da cúpula 1",
		"desc_en" : "Dome 1 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 374
	},
	{
		"eventoid" : 367,
		"funcid" : 259,
		"desc_es" : "Cierre de Domo 1",
		"desc_pt" : "Cúpula 1 fechada",
		"desc_en" : "Dome 1 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 375
	},
	{
		"eventoid" : 368,
		"funcid" : 259,
		"desc_es" : "Falla Sensor Domo 1",
		"desc_pt" : "Falha no sensor de cúpula 1",
		"desc_en" : "Dome 1 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 376
	},
	{
		"eventoid" : 921,
		"funcid" : 404,
		"desc_es" : "Cierre de Válvula 7",
		"desc_pt" : "Fechada da válvula 7",
		"desc_en" : "Valve 7 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2493
	},
	{
		"eventoid" : 421,
		"funcid" : 290,
		"desc_es" : "Inicio de Actividad(ECU)",
		"desc_pt" : "Inicio da Atividade(ECU)",
		"desc_en" : "Start of Activity(ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 451
	},
	{
		"eventoid" : 369,
		"funcid" : 260,
		"desc_es" : "Apertura de Domo 2",
		"desc_pt" : "Abertura da cúpula 2",
		"desc_en" : "Dome 2 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 377
	},
	{
		"eventoid" : 370,
		"funcid" : 260,
		"desc_es" : "Cierre de Domo 2",
		"desc_pt" : "Cúpula 2 fechada",
		"desc_en" : "Dome 2 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 378
	},
	{
		"eventoid" : 371,
		"funcid" : 260,
		"desc_es" : "Falla Sensor Domo 2",
		"desc_pt" : "Falha no sensor de cúpula 2",
		"desc_en" : "Dome 2 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 379
	},
	{
		"eventoid" : 515,
		"funcid" : 283,
		"desc_es" : "Falta de marcado",
		"desc_pt" : "Falta de marcação",
		"desc_en" : "Lack of marking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 540
	},
	{
		"eventoid" : 516,
		"funcid" : 367,
		"desc_es" : "Cinturón cerrado",
		"desc_pt" : "Cinto fechado",
		"desc_en" : "Closed belt",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 541
	},
	{
		"eventoid" : 963,
		"funcid" : 317,
		"desc_es" : "Apertura de panel 02",
		"desc_pt" : "Apertura de panel 02",
		"desc_en" : "Apertura de panel 02",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 123
	},
	{
		"eventoid" : 28,
		"funcid" : 16,
		"desc_es" : "Temperatura alta camara 1",
		"desc_pt" : "Temperatura alta câmara 1",
		"desc_en" : "High temperature chamber 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1900
	},
	{
		"eventoid" : 964,
		"funcid" : 316,
		"desc_es" : "Cierre de panel 02",
		"desc_pt" : "Cierre de panel 02",
		"desc_en" : "Cierre de panel 02",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 124
	},
	{
		"eventoid" : 967,
		"funcid" : 439,
		"desc_es" : "Alarma Danger Slave",
		"desc_pt" : "Alarme Danger Escravo",
		"desc_en" : "Slave Failure Alarm",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2533
	},
	{
		"eventoid" : 965,
		"funcid" : 439,
		"desc_es" : "Alarma de Falta de Slave",
		"desc_pt" : "Alarme de Falha Escravo",
		"desc_en" : "Slave Failure Alarm",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2531
	},
	{
		"eventoid" : 966,
		"funcid" : 439,
		"desc_es" : "Alerta Slave Recuperado",
		"desc_pt" : "Alerta de escravo recuperado",
		"desc_en" : "Slave alert recovered",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2532
	},
	{
		"eventoid" : 970,
		"funcid" : 450,
		"desc_es" : "Equipamiento en Movimiento",
		"desc_pt" : "Equipamento em Deslocamento",
		"desc_en" : "Equipment in Motion",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2534
	},
	{
		"eventoid" : 517,
		"funcid" : 367,
		"desc_es" : "Cinturón abierto",
		"desc_pt" : "Abrir belt",
		"desc_en" : "Open belt",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 542
	},
	{
		"eventoid" : 525,
		"funcid" : 375,
		"desc_es" : "Advertencia de hora nocturna",
		"desc_pt" : "Aviso de tempo de noite",
		"desc_en" : "Warning night time",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2163
	},
	{
		"eventoid" : 857,
		"funcid" : 244,
		"desc_es" : "Desconexión sensor de combustible tanque 2",
		"desc_pt" : "Desconexão sensor de combustível tanque 2",
		"desc_en" : "Disconnection fuel sensor tank 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 414
	},
	{
		"eventoid" : 858,
		"funcid" : 244,
		"desc_es" : "Reconexión sensor de combustible tanque 2",
		"desc_pt" : "Reconexão sensor de combustível tanque 2",
		"desc_en" : "Reconnection fuel sensor tank 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 415
	},
	{
		"eventoid" : 556,
		"funcid" : 395,
		"desc_es" : "Bomba Activada",
		"desc_pt" : "Bomba Ativada",
		"desc_en" : "Pump activated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2183
	},
	{
		"eventoid" : 978,
		"funcid" : 481,
		"desc_es" : "Detección de Distracción",
		"desc_pt" : "Detecção de Distração",
		"desc_en" : "Distraction Detection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2541
	},
	{
		"eventoid" : 979,
		"funcid" : 482,
		"desc_es" : "Lona abierta",
		"desc_pt" : "Barraca Coberta Aberta",
		"desc_en" : "Tent Covered Open",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2542
	},
	{
		"eventoid" : 971,
		"funcid" : 450,
		"desc_es" : "Equipamiento Operativo",
		"desc_pt" : "Equipamento Operante",
		"desc_en" : "Operational Equipment",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2535
	},
	{
		"eventoid" : 387,
		"funcid" : 279,
		"desc_es" : "Alarma de Desconexión de Tobillera",
		"desc_pt" : "Desconexão de Alarme de Tornozeleira",
		"desc_en" : "Disconnection of Anklet Alarm",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 421
	},
	{
		"eventoid" : 388,
		"funcid" : 280,
		"desc_es" : "Sabotaje a Sistema de Control",
		"desc_pt" : "Sabotage Sistema de Controle",
		"desc_en" : "Control System Sabotage",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 422
	},
	{
		"eventoid" : 389,
		"funcid" : 280,
		"desc_es" : "Sistema de Control Normal",
		"desc_pt" : "Sistema de Controlo Normal",
		"desc_en" : "Normal Control System",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 423
	},
	{
		"eventoid" : 422,
		"funcid" : 290,
		"desc_es" : "Fin de Actividad(ECU)",
		"desc_pt" : "Final da Atividade(ECU)",
		"desc_en" : "End of Activity(ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 452
	},
	{
		"eventoid" : 363,
		"funcid" : 404,
		"desc_es" : "Apertura de Válvula 2",
		"desc_pt" : "Abertura da válvula 2",
		"desc_en" : "Valve 2 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 371
	},
	{
		"eventoid" : 382,
		"funcid" : 283,
		"desc_es" : "Control Conducción",
		"desc_pt" : "Control Condução",
		"desc_en" : "Drive Control",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 416
	},
	{
		"eventoid" : 753,
		"funcid" : 117,
		"desc_es" : "Contacto ON virtual",
		"desc_pt" : "Contato ON virtual",
		"desc_en" : "Contact ON virtual",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2375
	},
	{
		"eventoid" : 11,
		"funcid" : 6,
		"desc_es" : "Robo",
		"desc_pt" : "Roubo",
		"desc_en" : "Theft",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 20
	},
	{
		"eventoid" : 241,
		"funcid" : 121,
		"desc_es" : "Macro contraseña de contingencia",
		"desc_pt" : "Macro senha do contingência",
		"desc_en" : "Contingency password macro",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1274
	},
	{
		"eventoid" : 242,
		"funcid" : 168,
		"desc_es" : "Rendimiento consulta totales",
		"desc_pt" : "Desempenho da consulta total",
		"desc_en" : "Performance query totals",
		"eventotablaid" : 5,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1275
	},
	{
		"eventoid" : 359,
		"funcid" : 213,
		"desc_es" : "Recupero señal GPS",
		"desc_pt" : "Recupero señal GPS",
		"desc_en" : "GPS signal recovery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 367
	},
	{
		"eventoid" : 32,
		"funcid" : 16,
		"desc_es" : "Temperatura normal camara 2",
		"desc_pt" : "Temperatura normal câmara 2",
		"desc_en" : "Normal temperature chamber 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 183
	},
	{
		"eventoid" : 972,
		"funcid" : 450,
		"desc_es" : "Equipamiento Inoperativo",
		"desc_pt" : "Equipamento Inoperante",
		"desc_en" : "Inoperative Equipment",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2536
	},
	{
		"eventoid" : 69,
		"funcid" : 50,
		"desc_es" : "Bloqueo GPS",
		"desc_pt" : "Bloqueio de GPS",
		"desc_en" : "GPS jamming",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 194
	},
	{
		"eventoid" : 566,
		"funcid" : 107,
		"desc_es" : "Fin de turno",
		"desc_pt" : "Final turno",
		"desc_en" : "Work shift end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2188
	},
	{
		"eventoid" : 137,
		"funcid" : 91,
		"desc_es" : "Entregado",
		"desc_pt" : "Entregue",
		"desc_en" : "Delivered",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1226
	},
	{
		"eventoid" : 378,
		"funcid" : 264,
		"desc_es" : "Inicio de intervención equipo",
		"desc_pt" : "Inicio de intervención equipo",
		"desc_en" : "Device intervention start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1386
	},
	{
		"eventoid" : 383,
		"funcid" : 274,
		"desc_es" : "Giro brusco",
		"desc_pt" : "Giro brusco",
		"desc_en" : "Abrupt turn",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 417
	},
	{
		"eventoid" : 72,
		"funcid" : 53,
		"desc_es" : "Actividad diaria",
		"desc_pt" : "Atividade diária",
		"desc_en" : "Daily activity",
		"eventotablaid" : 4,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1196
	},
	{
		"eventoid" : 92,
		"funcid" : 75,
		"desc_es" : "Radio Baliza",
		"desc_pt" : "Rádio baliza",
		"desc_en" : "Radio beacon",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 206
	},
	{
		"eventoid" : 74,
		"funcid" : 55,
		"desc_es" : "Actividad remota",
		"desc_pt" : "Atividade remota",
		"desc_en" : "Remote activity",
		"eventotablaid" : 4,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1197
	},
	{
		"eventoid" : 110,
		"funcid" : 80,
		"desc_es" : "Reporte de Temperatura por Tiempo",
		"desc_pt" : "Reporte por tempo temperatura",
		"desc_en" : "Temperature report by Time",
		"eventotablaid" : 6,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 212
	},
	{
		"eventoid" : 33,
		"funcid" : 16,
		"desc_es" : "Temperatura baja camara 2",
		"desc_pt" : "Temperatura baixa câmara 2",
		"desc_en" : "Low temperature chamber 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1900
	},
	{
		"eventoid" : 364,
		"funcid" : 404,
		"desc_es" : "Cierre de Válvula 2",
		"desc_pt" : "Válvula 2 fechada",
		"desc_en" : "Valve 2 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 372
	},
	{
		"eventoid" : 139,
		"funcid" : 100,
		"desc_es" : "Desconexión dato a bordo",
		"desc_pt" : "Desconexão de dado a bordo",
		"desc_en" : "On board data disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 228
	},
	{
		"eventoid" : 385,
		"funcid" : 274,
		"desc_es" : "Reconexión acelerómetro",
		"desc_pt" : "Acelerômetro Conectado",
		"desc_en" : "Accelerometer reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 419
	},
	{
		"eventoid" : 138,
		"funcid" : 91,
		"desc_es" : "No entregado",
		"desc_pt" : "Não entregue",
		"desc_en" : "Undelivered",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1227
	},
	{
		"eventoid" : 365,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Válvula 2",
		"desc_pt" : "Falha no sensor de válvula 2",
		"desc_en" : "Valve 2 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 373
	},
	{
		"eventoid" : 761,
		"funcid" : 11,
		"desc_es" : "Enganche Parcial",
		"desc_pt" : "Engate Parcial",
		"desc_en" : "Partial Coupling",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2383
	},
	{
		"eventoid" : 248,
		"funcid" : 200,
		"desc_es" : "GPS Log",
		"desc_pt" : "Data Log",
		"desc_en" : "GPS Log",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 163
	},
	{
		"eventoid" : 844,
		"funcid" : 70,
		"desc_es" : "Desactivación Central de Alarma Local",
		"desc_pt" : "Desactivación Central de Alarma Local",
		"desc_en" : "Local central alarm deactivation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 401
	},
	{
		"eventoid" : 845,
		"funcid" : 70,
		"desc_es" : "Activación Central de Alarma Local",
		"desc_pt" : "Activación Central de Alarma Local",
		"desc_en" : "Local central alarm reactivation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 402
	},
	{
		"eventoid" : 846,
		"funcid" : 70,
		"desc_es" : "Desactivación Central de Alarma Remoto",
		"desc_pt" : "Desactivación Central de Alarma Remoto",
		"desc_en" : "Remote central alarm deactivation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 403
	},
	{
		"eventoid" : 847,
		"funcid" : 70,
		"desc_es" : "Activación Central de Alarma Remoto",
		"desc_pt" : "Activación Central de Alarma Remoto",
		"desc_en" : "Remote central alarm reactivation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 404
	},
	{
		"eventoid" : 974,
		"funcid" : 502,
		"desc_es" : "Inicio de alerta para cambiar el filtro",
		"desc_pt" : "Inicio de alerta para troca de filtro",
		"desc_en" : "Start alert to change the filter",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2537
	},
	{
		"eventoid" : 975,
		"funcid" : 502,
		"desc_es" : "Fin de alerta para cambiar el filtro",
		"desc_pt" : "Fim de alerta para troca de filtro",
		"desc_en" : "End of alert to change the filter",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2538
	},
	{
		"eventoid" : 776,
		"funcid" : 325,
		"desc_es" : "Pasajero en linea incorrecta",
		"desc_pt" : "Passageiro em linha incorreta",
		"desc_en" : "Incorrect online passenger",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2399
	},
	{
		"eventoid" : 777,
		"funcid" : 404,
		"desc_es" : "Reconexión de Válvula 1",
		"desc_pt" : "Reconexão de Válvula 1",
		"desc_en" : "Valve 1 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2400
	},
	{
		"eventoid" : 1343,
		"funcid" : 440,
		"desc_es" : "Falla sensor",
		"desc_pt" : "Falha no sensor",
		"desc_en" : "Sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2868
	},
	{
		"eventoid" : 520,
		"funcid" : 372,
		"desc_es" : "Apertura de Puerta Indebida",
		"desc_pt" : "Indevida Abertura da Porta",
		"desc_en" : "Undue Door Opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 543
	},
	{
		"eventoid" : 976,
		"funcid" : 361,
		"desc_es" : "Reconexión de bluetooth",
		"desc_pt" : "Reconexão de bluetooth",
		"desc_en" : "Reconnect bluetooth",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2539
	},
	{
		"eventoid" : 410,
		"funcid" : 287,
		"desc_es" : "Desconexion de ICAN",
		"desc_pt" : "Desconexão de ICAN",
		"desc_en" : "ICAN disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 444
	},
	{
		"eventoid" : 411,
		"funcid" : 287,
		"desc_es" : "Reconexion de ICAN",
		"desc_pt" : "Reconexão de ICAN",
		"desc_en" : "ICAN reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 445
	},
	{
		"eventoid" : 861,
		"funcid" : 283,
		"desc_es" : "Infracción de sobrevelocidad",
		"desc_pt" : "Infracción de sobrevelocidade",
		"desc_en" : "Overspeed Infraction",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 446
	},
	{
		"eventoid" : 518,
		"funcid" : 368,
		"desc_es" : "Inicio sobrevelocidad en Ruta",
		"desc_pt" : "Início de Excesso de velocidade na rota",
		"desc_en" : "Start of route overspeed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2000
	},
	{
		"eventoid" : 519,
		"funcid" : 368,
		"desc_es" : "Fin sobrevelocidad en Ruta",
		"desc_pt" : "Fim de Excesso de velocidade na rota",
		"desc_en" : "End of route overspeed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2100
	},
	{
		"eventoid" : 200,
		"funcid" : 58,
		"desc_es" : "Parada no autorizada",
		"desc_pt" : "Parada não autorizada",
		"desc_en" : "Unauthorized stop",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 5,
		"esalerta" : "0",
		"orden" : 253
	},
	{
		"eventoid" : 973,
		"funcid" : 439,
		"desc_es" : "Sobrevelocidad-AV 3.0 Vehículo Bloqueado Motor ON (ECU)",
		"desc_pt" : "Overspeed-AV 3.0 Motor do Veículo Bloqueado ON (ECU)",
		"desc_en" : "Slave Failure Alarm",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2534
	},
	{
		"eventoid" : 78,
		"funcid" : 56,
		"desc_es" : "Fuera de Cerca Electrónica",
		"desc_pt" : "Fora de cerca eletrônica",
		"desc_en" : "Out of Electronic Fence",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 3,
		"esalerta" : "0",
		"orden" : 199
	},
	{
		"eventoid" : 865,
		"funcid" : 262,
		"desc_es" : "Activación de Barrera Infrarroja",
		"desc_pt" : "Ativação Barreira Infravermelho",
		"desc_en" : "Activation Infrared Barrier",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1530
	},
	{
		"eventoid" : 79,
		"funcid" : 57,
		"desc_es" : "Dentro de Zona de Riesgo",
		"desc_pt" : "Dentro da zona de risco",
		"desc_en" : "Within Risk Zone",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 4,
		"esalerta" : "0",
		"orden" : 200
	},
	{
		"eventoid" : 526,
		"funcid" : 375,
		"desc_es" : "Fin de Advertencia de hora nocturna",
		"desc_pt" : "Fim Aviso de tempo noite",
		"desc_en" : "End Warning nigh time",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2164
	},
	{
		"eventoid" : 527,
		"funcid" : 375,
		"desc_es" : "Advertencia de hora de atardecer",
		"desc_pt" : "Aviso de Sunset Tempo",
		"desc_en" : "Time Warning of atardecer ",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2165
	},
	{
		"eventoid" : 528,
		"funcid" : 375,
		"desc_es" : "Fin de Advertencia de hora de atardecer",
		"desc_pt" : "Fim Aviso de Sunset Tempo ",
		"desc_en" : "End of Warning time of atardecer",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2166
	},
	{
		"eventoid" : 80,
		"funcid" : 57,
		"desc_es" : "Fuera de Zona de Riesgo",
		"desc_pt" : "Fora de zona de risco",
		"desc_en" : "Out of Risk Zone",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 4,
		"esalerta" : "0",
		"orden" : 201
	},
	{
		"eventoid" : 529,
		"funcid" : 376,
		"desc_es" : "Advertencia de falla interna",
		"desc_pt" : "Aviso de falha interna",
		"desc_en" : "Warning of internal failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2167
	},
	{
		"eventoid" : 374,
		"funcid" : 261,
		"desc_es" : "Reporte faltante alarma (2hr)",
		"desc_pt" : "Reporte faltante alarma (2hr)",
		"desc_en" : "Missing report alarm (2hr)",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1382
	},
	{
		"eventoid" : 530,
		"funcid" : 376,
		"desc_es" : "Fin de Advertencia de falla interna",
		"desc_pt" : "Fim Aviso de falha interna",
		"desc_en" : "End Warning of internal failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2168
	},
	{
		"eventoid" : 531,
		"funcid" : 377,
		"desc_es" : "Advertencia de mantenimiento",
		"desc_pt" : "Aviso de manutenção",
		"desc_en" : "Maintenance Warning",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2169
	},
	{
		"eventoid" : 977,
		"funcid" : 361,
		"desc_es" : "Desconexión de bluetooth",
		"desc_pt" : "Desconexão de bluetooth",
		"desc_en" : "Disconnection bluetooth",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2540
	},
	{
		"eventoid" : 532,
		"funcid" : 377,
		"desc_es" : "Fin de Advertencia de mantenimiento",
		"desc_pt" : "Fim Aviso de manutenção",
		"desc_en" : "End Maintenance warning",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2170
	},
	{
		"eventoid" : 35,
		"funcid" : 28,
		"desc_es" : "Deposito de residuos lleno",
		"desc_pt" : "Caçamba cheia",
		"desc_en" : "Full waste container",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 185
	},
	{
		"eventoid" : 533,
		"funcid" : 378,
		"desc_es" : "Advertencia de error válido",
		"desc_pt" : "Aviso de erro válido",
		"desc_en" : "Warning Valid error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2171
	},
	{
		"eventoid" : 360,
		"funcid" : 404,
		"desc_es" : "Apertura de Válvula 1",
		"desc_pt" : "Abertura da válvula 1",
		"desc_en" : "Valve 1 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 368
	},
	{
		"eventoid" : 36,
		"funcid" : 28,
		"desc_es" : "Deposito de residuos vacio",
		"desc_pt" : "Caçamba vazia",
		"desc_en" : "Empty waste container",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 186
	},
	{
		"eventoid" : 534,
		"funcid" : 378,
		"desc_es" : "Fin de Advertencia de error válido",
		"desc_pt" : "Fim Aviso de erro válido",
		"desc_en" : "End Warning Valid error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2172
	},
	{
		"eventoid" : 210,
		"funcid" : 126,
		"desc_es" : "Mantenimiento programado",
		"desc_pt" : "Odometro",
		"desc_en" : "Programed maintenance",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1258
	},
	{
		"eventoid" : 217,
		"funcid" : 162,
		"desc_es" : "Exceso de velocidad",
		"desc_pt" : "Excesso de velocidade",
		"desc_en" : "Overspeed",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 12,
		"esalerta" : "0",
		"orden" : 261
	},
	{
		"eventoid" : 437,
		"funcid" : 311,
		"desc_es" : "Foto Capturada",
		"desc_pt" : "Foto Capturada",
		"desc_en" : "Photo Captured",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 467
	},
	{
		"eventoid" : 438,
		"funcid" : 290,
		"desc_es" : "SD Ok",
		"desc_pt" : "SD Ok",
		"desc_en" : "SD Ok",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 468
	},
	{
		"eventoid" : 980,
		"funcid" : 482,
		"desc_es" : "Lona cerrada",
		"desc_pt" : "Barraca Coberta Fechar",
		"desc_en" : "Tent Covered Close",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2543
	},
	{
		"eventoid" : 439,
		"funcid" : 290,
		"desc_es" : "SD Error",
		"desc_pt" : "SD Error",
		"desc_en" : "SD Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 468
	},
	{
		"eventoid" : 535,
		"funcid" : 379,
		"desc_es" : "Advertencia de bloqueo de cámara",
		"desc_pt" : "Aviso de câmara de bloqueio",
		"desc_en" : "Warning Lock camera",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2173
	},
	{
		"eventoid" : 536,
		"funcid" : 379,
		"desc_es" : "Fin de Advertencia de bloqueo de cámara",
		"desc_pt" : "Fim Aviso de câmara de bloqueio",
		"desc_en" : "End Warning lock camera",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2174
	},
	{
		"eventoid" : 412,
		"funcid" : 25,
		"desc_es" : "Consumo por contacto",
		"desc_pt" : "Consumo por contacto",
		"desc_en" : "Consumption by contact",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 428
	},
	{
		"eventoid" : 414,
		"funcid" : 291,
		"desc_es" : "Inicio exceso detenido con contacto",
		"desc_pt" : "Inicio exceso detenido con contacto",
		"desc_en" : "Stop time with contact excess start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 428
	},
	{
		"eventoid" : 103,
		"funcid" : 77,
		"desc_es" : "Consumo diario",
		"desc_pt" : "Consumo diário",
		"desc_en" : "Daily consumption",
		"eventotablaid" : 5,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 210
	},
	{
		"eventoid" : 104,
		"funcid" : 78,
		"desc_es" : "Consumo remoto",
		"desc_pt" : "Consumo remoto",
		"desc_en" : "Remote consumption",
		"eventotablaid" : 5,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 211
	},
	{
		"eventoid" : 111,
		"funcid" : 81,
		"desc_es" : "Reporte de Temperatura por Consulta",
		"desc_pt" : "Reporte por consulta de temperatura",
		"desc_en" : "Temperature report by Request",
		"eventotablaid" : 6,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 213
	},
	{
		"eventoid" : 112,
		"funcid" : 82,
		"desc_es" : "Reporte de Temperatura por Evento",
		"desc_pt" : "Reporte por evento temperatura",
		"desc_en" : "Temperature report by Event",
		"eventotablaid" : 6,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 214
	},
	{
		"eventoid" : 117,
		"funcid" : 84,
		"desc_es" : "Temperatura normal camara 2",
		"desc_pt" : "Temperatura normal câmara 2",
		"desc_en" : "Normal temperature chamber 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 215
	},
	{
		"eventoid" : 119,
		"funcid" : 85,
		"desc_es" : "Temperatura máxima camara 3",
		"desc_pt" : "Temperatura máxima câmara 3",
		"desc_en" : "Maximum temperature chamber 3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 216
	},
	{
		"eventoid" : 120,
		"funcid" : 85,
		"desc_es" : "Temperatura normal camara 3",
		"desc_pt" : "Temperatura normal câmara 3",
		"desc_en" : "Normal temperature chamber 3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 217
	},
	{
		"eventoid" : 121,
		"funcid" : 85,
		"desc_es" : "Temperatura mínima camara 3",
		"desc_pt" : "Temperatura mínima câmara 3",
		"desc_en" : "Minimum temperature chamber 3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 218
	},
	{
		"eventoid" : 538,
		"funcid" : 381,
		"desc_es" : "Bloqueo motor",
		"desc_pt" : "Bloqueio de Motor",
		"desc_en" : "Motor block",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 550
	},
	{
		"eventoid" : 415,
		"funcid" : 291,
		"desc_es" : "Fin exceso detenido con contacto",
		"desc_pt" : "Fin exceso detenido con contacto",
		"desc_en" : "Stop time with contact excess end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 429
	},
	{
		"eventoid" : 218,
		"funcid" : 162,
		"desc_es" : "Contramano",
		"desc_pt" : "Contra-mão",
		"desc_en" : "Wrong way",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 12,
		"esalerta" : "0",
		"orden" : 262
	},
	{
		"eventoid" : 201,
		"funcid" : 29,
		"desc_es" : "Llegada al Cliente",
		"desc_pt" : "Chegada no Cliente",
		"desc_en" : "Customer Arrival",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 254
	},
	{
		"eventoid" : 416,
		"funcid" : 292,
		"desc_es" : "Desconexión MobileEye",
		"desc_pt" : "Desconexión MobileEye",
		"desc_en" : "Mobileye disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1428
	},
	{
		"eventoid" : 203,
		"funcid" : 29,
		"desc_es" : "Entrega al Cliente\/Reinicio de Viaje",
		"desc_pt" : "Entrega no Cliente\/Reinício de Viagem",
		"desc_en" : "Customer Delivery\/Reset Trip",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 256
	},
	{
		"eventoid" : 205,
		"funcid" : 129,
		"desc_es" : "Cierre de panel",
		"desc_pt" : "Fechamento de painel",
		"desc_en" : "Device panel locking ",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 257
	},
	{
		"eventoid" : 413,
		"funcid" : 94,
		"desc_es" : "Power Off",
		"desc_pt" : "Power Off",
		"desc_en" : "Power Off",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1429
	},
	{
		"eventoid" : 521,
		"funcid" : 249,
		"desc_es" : "Inicio RPM",
		"desc_pt" : "Inicio RPM",
		"desc_en" : "RPM start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 544
	},
	{
		"eventoid" : 863,
		"funcid" : 312,
		"desc_es" : "Reporte de Volumen",
		"desc_pt" : "Reporte de Volumen",
		"desc_en" : "Volume report",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 452
	},
	{
		"eventoid" : 261,
		"funcid" : 210,
		"desc_es" : "Temperatura máxima camara 4",
		"desc_pt" : "Temperatura máxima câmara 4",
		"desc_en" : "Maximum temperature chamber 4",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 288
	},
	{
		"eventoid" : 262,
		"funcid" : 210,
		"desc_es" : "Temperatura normal camara 4",
		"desc_pt" : "Temperatura normal câmara 4",
		"desc_en" : "Normal temperature chamber 4",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 289
	},
	{
		"eventoid" : 263,
		"funcid" : 210,
		"desc_es" : "Temperatura mínima camara 4",
		"desc_pt" : "Temperatura mínima câmara 4",
		"desc_en" : "Minimum temperature chamber 4",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 290
	},
	{
		"eventoid" : 424,
		"funcid" : 298,
		"desc_es" : "Botón 2 presionado",
		"desc_pt" : "Botão 2 pressionado",
		"desc_en" : "Button 2 pressed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1454
	},
	{
		"eventoid" : 425,
		"funcid" : 299,
		"desc_es" : "Botón 3 presionado",
		"desc_pt" : "Botão 3 pressionado",
		"desc_en" : "Button 3 pressed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1455
	},
	{
		"eventoid" : 981,
		"funcid" : 483,
		"desc_es" : "Cono en base",
		"desc_pt" : "Cone de trânsito na base",
		"desc_en" : "Transit cone in base",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2544
	},
	{
		"eventoid" : 982,
		"funcid" : 483,
		"desc_es" : "Cono fuera de base",
		"desc_pt" : "Base do cone de trânsito",
		"desc_en" : "Transit cone off base",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2545
	},
	{
		"eventoid" : 561,
		"funcid" : 401,
		"desc_es" : "PTO Activo",
		"desc_pt" : "PTO Activo",
		"desc_en" : "PTO activated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2187
	},
	{
		"eventoid" : 523,
		"funcid" : 374,
		"desc_es" : "Inicio Conducción en Neutro",
		"desc_pt" : "Início de Banguela",
		"desc_en" : "Start Driving on Neutral",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 546
	},
	{
		"eventoid" : 524,
		"funcid" : 374,
		"desc_es" : "Fin Conducción en Neutro",
		"desc_pt" : "Fim de Banguela",
		"desc_en" : "End Driving on Neutral",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 547
	},
	{
		"eventoid" : 397,
		"funcid" : 282,
		"desc_es" : "BUS 1 OK",
		"desc_pt" : "BUS 1 OK",
		"desc_en" : "BUS 1 OK",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 431
	},
	{
		"eventoid" : 398,
		"funcid" : 282,
		"desc_es" : "BUS 1 en Corto",
		"desc_pt" : "BUS 1 em curto",
		"desc_en" : "BUS 1 in Short",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 432
	},
	{
		"eventoid" : 1227,
		"funcid" : 363,
		"desc_es" : "Exceso de presión de combustible",
		"desc_pt" : "Excesso de Pressão do Combustível",
		"desc_en" : "Excess fuel pressure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2755
	},
	{
		"eventoid" : 399,
		"funcid" : 282,
		"desc_es" : "BUS 2 OK",
		"desc_pt" : "BUS 2 OK",
		"desc_en" : "BUS 2 OK",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 433
	},
	{
		"eventoid" : 400,
		"funcid" : 282,
		"desc_es" : "BUS 2 en Corto",
		"desc_pt" : "BUS 2 em curto",
		"desc_en" : "BUS 2 in Short",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 434
	},
	{
		"eventoid" : 401,
		"funcid" : 257,
		"desc_es" : "Desconexión sensor Válvula 1",
		"desc_pt" : "Desligue o sensor da válvula 1",
		"desc_en" : "Disconnect sensor Valve 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 435
	},
	{
		"eventoid" : 402,
		"funcid" : 257,
		"desc_es" : "Reconexión sensor Válvula 1",
		"desc_pt" : "Reconectar válvula sensor 1",
		"desc_en" : "Reconnect sensor Valve 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 436
	},
	{
		"eventoid" : 403,
		"funcid" : 258,
		"desc_es" : "Desconexión sensor Válvula 2",
		"desc_pt" : "Desligue o sensor da válvula 2",
		"desc_en" : "Disconnect sensor Valve 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 437
	},
	{
		"eventoid" : 404,
		"funcid" : 258,
		"desc_es" : "Reconexión sensor Válvula 2",
		"desc_pt" : "Reconectar válvula sensor 2",
		"desc_en" : "Reconnect sensor Valve 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 438
	},
	{
		"eventoid" : 405,
		"funcid" : 259,
		"desc_es" : "Desconexión sensor Domo 1",
		"desc_pt" : "Desligue o sensor Dome 1",
		"desc_en" : "Disconnect sensor Dome 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 439
	},
	{
		"eventoid" : 406,
		"funcid" : 259,
		"desc_es" : "Reconexión sensor Domo 1",
		"desc_pt" : "Reconectar Dome sensor 1",
		"desc_en" : "Reconnect sensor Dome 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 440
	},
	{
		"eventoid" : 407,
		"funcid" : 260,
		"desc_es" : "Desconexión sensor Domo 2",
		"desc_pt" : "Desligue o sensor Dome 2",
		"desc_en" : "Disconnect sensor Dome 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 441
	},
	{
		"eventoid" : 408,
		"funcid" : 260,
		"desc_es" : "Reconexión sensor Domo 2",
		"desc_pt" : "Reconectar Dome sensor 2",
		"desc_en" : "Reconnect sensor Dome 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 442
	},
	{
		"eventoid" : 542,
		"funcid" : 381,
		"desc_es" : "Desbloqueo motor",
		"desc_pt" : "Liberação do motor",
		"desc_en" : "Unblocked motor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 554
	},
	{
		"eventoid" : 1228,
		"funcid" : 363,
		"desc_es" : "Informe de exceso de presión de combustible",
		"desc_pt" : "Excesso de Pressão do Combustível Relatório",
		"desc_en" : "Report of excess fuel pressure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2756
	},
	{
		"eventoid" : 539,
		"funcid" : 382,
		"desc_es" : "Exceso peso",
		"desc_pt" : "Excesso de peso",
		"desc_en" : "Excess weight",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 551
	},
	{
		"eventoid" : 446,
		"funcid" : 73,
		"desc_es" : "Perfil de RPM",
		"desc_pt" : "Perfil RPM",
		"desc_en" : "RPM Profile",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 475
	},
	{
		"eventoid" : 447,
		"funcid" : 73,
		"desc_es" : "Perfil de RPM(Descarga)",
		"desc_pt" : "Perfil RPM(Descarga)",
		"desc_en" : "RPM(Discharge) Profile",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 476
	},
	{
		"eventoid" : 448,
		"funcid" : 73,
		"desc_es" : "Perfil de Velocidad",
		"desc_pt" : "perfil de velocidade",
		"desc_en" : "Speed Profile",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 477
	},
	{
		"eventoid" : 449,
		"funcid" : 73,
		"desc_es" : "Perfil de Tempertaura",
		"desc_pt" : "perfil de temperatura",
		"desc_en" : "Temperture Profile",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 478
	},
	{
		"eventoid" : 450,
		"funcid" : 73,
		"desc_es" : "Perfil de Frenada",
		"desc_pt" : "perfil de travagem",
		"desc_en" : "Braking Profile",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 479
	},
	{
		"eventoid" : 451,
		"funcid" : 73,
		"desc_es" : "Perfil de Torque",
		"desc_pt" : "perfil de torque",
		"desc_en" : "Torque Profile",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 480
	},
	{
		"eventoid" : 452,
		"funcid" : 73,
		"desc_es" : "Perfil de Aceleración",
		"desc_pt" : "perfil de aceleração",
		"desc_en" : "Acceleration Profile",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 481
	},
	{
		"eventoid" : 453,
		"funcid" : 288,
		"desc_es" : "Backlog GPS",
		"desc_pt" : "Backlog GPS",
		"desc_en" : "Backlog GPS",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 482
	},
	{
		"eventoid" : 454,
		"funcid" : 290,
		"desc_es" : "Shift Print",
		"desc_pt" : "Shift Print",
		"desc_en" : "Shift Print",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 483
	},
	{
		"eventoid" : 455,
		"funcid" : 318,
		"desc_es" : "Apertura de baúl equipaje evento",
		"desc_pt" : "Evento de abertura bagagem tronco",
		"desc_en" : "Luggage trunk opening event",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 484
	},
	{
		"eventoid" : 456,
		"funcid" : 318,
		"desc_es" : "Cierre de baúl equipaje evento",
		"desc_pt" : "Evento bagagem tronco fechamento",
		"desc_en" : "Luggage trunk closing event",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 485
	},
	{
		"eventoid" : 540,
		"funcid" : 380,
		"desc_es" : "Colisión media",
		"desc_pt" : "Colisão média",
		"desc_en" : "Collision medium",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 552
	},
	{
		"eventoid" : 494,
		"funcid" : 28,
		"desc_es" : "Contenedor Arriba",
		"desc_pt" : "Recipiente acima",
		"desc_en" : "Container up",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 522
	},
	{
		"eventoid" : 457,
		"funcid" : 73,
		"desc_es" : "Informe de Exceso de RPM",
		"desc_pt" : "Excesso RPM Relatório",
		"desc_en" : "RPM Report Excess",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 486
	},
	{
		"eventoid" : 537,
		"funcid" : 380,
		"desc_es" : "Colisión leve",
		"desc_pt" : "Colisão leve",
		"desc_en" : "Collision slight",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 548
	},
	{
		"eventoid" : 484,
		"funcid" : 325,
		"desc_es" : "Ascenso pasajero",
		"desc_pt" : "Embarque de passageiro",
		"desc_en" : "Passenger rise",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 512
	},
	{
		"eventoid" : 460,
		"funcid" : 73,
		"desc_es" : "Informe de Exceso de Presión de Aceite",
		"desc_pt" : "Excesso de Pressão de Óleo Relatório",
		"desc_en" : "Oil Pressure Report Excess",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 489
	},
	{
		"eventoid" : 394,
		"funcid" : 11,
		"desc_es" : "Enganche de Tonel 1",
		"desc_pt" : "Barril engate 1",
		"desc_en" : "Tonel hitch 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1428
	},
	{
		"eventoid" : 541,
		"funcid" : 380,
		"desc_es" : "Colisión grave",
		"desc_pt" : "Colisão grave",
		"desc_en" : "Collision severe",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 553
	},
	{
		"eventoid" : 427,
		"funcid" : 300,
		"desc_es" : "Conexion sensor de temperatura camara 1",
		"desc_pt" : "Conecte a câmera sensor de temperatura 1",
		"desc_en" : "Connect temperature sensor camera 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1457
	},
	{
		"eventoid" : 984,
		"funcid" : 280,
		"desc_es" : "Nivel bajo de adblue",
		"desc_pt" : "Baixo nível de aditivo adblue",
		"desc_en" : "Low level of adblue additive",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2547
	},
	{
		"eventoid" : 71,
		"funcid" : 52,
		"desc_es" : "Dentro de Ruta",
		"desc_pt" : "Dentro da rota",
		"desc_en" : "Within Route",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 2,
		"esalerta" : "0",
		"orden" : 195
	},
	{
		"eventoid" : 77,
		"funcid" : 56,
		"desc_es" : "Dentro de Cerca Electrónica",
		"desc_pt" : "Dentro de cerca eletrônica",
		"desc_en" : "Within Electronic Fence",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 3,
		"esalerta" : "0",
		"orden" : 198
	},
	{
		"eventoid" : 81,
		"funcid" : 58,
		"desc_es" : "Dentro de Zona Segura",
		"desc_pt" : "Dentro da zona segura",
		"desc_en" : "Within Safe Zone",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 5,
		"esalerta" : "0",
		"orden" : 202
	},
	{
		"eventoid" : 82,
		"funcid" : 58,
		"desc_es" : "Fuera de Zona Segura",
		"desc_pt" : "Fora de zona segura",
		"desc_en" : "Out of Safe Zone",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 5,
		"esalerta" : "0",
		"orden" : 203
	},
	{
		"eventoid" : 123,
		"funcid" : 89,
		"desc_es" : "Dentro de Zona de Descanso",
		"desc_pt" : "Dentro da zona da descanso",
		"desc_en" : "Within Break Zone",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 9,
		"esalerta" : "0",
		"orden" : 219
	},
	{
		"eventoid" : 124,
		"funcid" : 89,
		"desc_es" : "Fuera de Zona de Descanso",
		"desc_pt" : "Fora da zona da descanso",
		"desc_en" : "Out of rest zone",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 9,
		"esalerta" : "0",
		"orden" : 220
	},
	{
		"eventoid" : 128,
		"funcid" : 90,
		"desc_es" : "Dentro de Zona de Descarga",
		"desc_pt" : "Dentro da zona da descarga",
		"desc_en" : "Within Unloading Zone",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 10,
		"esalerta" : "0",
		"orden" : 221
	},
	{
		"eventoid" : 129,
		"funcid" : 90,
		"desc_es" : "Fuera de Zona de Descarga",
		"desc_pt" : "Fuera da zona da descarga",
		"desc_en" : "Out of Unloading Zone",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 10,
		"esalerta" : "0",
		"orden" : 222
	},
	{
		"eventoid" : 140,
		"funcid" : 98,
		"desc_es" : "Dentro de Zona de Veda",
		"desc_pt" : "Dentro de zona de veda",
		"desc_en" : "Within Prohibited Fishing Zone",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 11,
		"esalerta" : "0",
		"orden" : 229
	},
	{
		"eventoid" : 141,
		"funcid" : 98,
		"desc_es" : "Fuera de Zona de Veda",
		"desc_pt" : "Fora de zona de veda",
		"desc_en" : "Out of Prohibited Fishing Zone",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 11,
		"esalerta" : "0",
		"orden" : 230
	},
	{
		"eventoid" : 222,
		"funcid" : 160,
		"desc_es" : "Dentro de Ruta",
		"desc_pt" : "Dentro da rota",
		"desc_en" : "Within Route",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 263
	},
	{
		"eventoid" : 392,
		"funcid" : 281,
		"desc_es" : "Sin detención en zona",
		"desc_pt" : "Área de detenção",
		"desc_en" : "No stop in zone",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 426
	},
	{
		"eventoid" : 562,
		"funcid" : 401,
		"desc_es" : "PTO Inactivo",
		"desc_pt" : "PTO Inactivo",
		"desc_en" : "PTO deactivated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2188
	},
	{
		"eventoid" : 985,
		"funcid" : 280,
		"desc_es" : "Inicio alta temperatura de refrigerante",
		"desc_pt" : "Alta temperatura da água",
		"desc_en" : "High water temperature",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2548
	},
	{
		"eventoid" : 543,
		"funcid" : 107,
		"desc_es" : "Nível de combustible bajo",
		"desc_pt" : "Nível de combustível baixo",
		"desc_en" : "Low fuel level",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 555
	},
	{
		"eventoid" : 428,
		"funcid" : 300,
		"desc_es" : "Conexion sensor de temperatura camara 2",
		"desc_pt" : "Conecte a câmera sensor de temperatura 2",
		"desc_en" : "Connect temperature sensor camera 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1458
	},
	{
		"eventoid" : 445,
		"funcid" : 314,
		"desc_es" : "Fin de Advertencia de distancia de frenado insuficiente",
		"desc_pt" : "Fim Aviso de distância de travagem insuficiente",
		"desc_en" : "End Warning of insufficient braking distance",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1474
	},
	{
		"eventoid" : 866,
		"funcid" : 193,
		"desc_es" : "Limpiaparabrisas Activado",
		"desc_pt" : "Limpador de para-brisa Ligado",
		"desc_en" : "Wiper Activated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2175
	},
	{
		"eventoid" : 867,
		"funcid" : 193,
		"desc_es" : "Limpiaparabrisas Desactivado",
		"desc_pt" : "Limpador de para-brisa desligado",
		"desc_en" : "Wipers off",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2176
	},
	{
		"eventoid" : 544,
		"funcid" : 390,
		"desc_es" : "Inicio Sin Movimiento con Motor Encendido",
		"desc_pt" : "Inicio Tempo Parado com Motor Ligado",
		"desc_en" : "Start Unmoving Engine Start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 556
	},
	{
		"eventoid" : 545,
		"funcid" : 390,
		"desc_es" : "Fin Sin Movimiento con Motor Encendido",
		"desc_pt" : "Fim Tempo Parado com Motor Ligado",
		"desc_en" : "End Unmoving Engine Start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 557
	},
	{
		"eventoid" : 225,
		"funcid" : 160,
		"desc_es" : "Cambio de Sentido",
		"desc_pt" : "Mudança de sentido",
		"desc_en" : "Way change",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 264
	},
	{
		"eventoid" : 1219,
		"funcid" : 363,
		"desc_es" : "Deteccion de bostezo",
		"desc_pt" : "Detecção de bocejo",
		"desc_en" : "Yawn Detection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2747
	},
	{
		"eventoid" : 165,
		"funcid" : 6,
		"desc_es" : "Robo alerta",
		"desc_pt" : "Roubo alerta",
		"desc_en" : "Theft alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1233
	},
	{
		"eventoid" : 166,
		"funcid" : 13,
		"desc_es" : "Apertura de puerta de carga alerta",
		"desc_pt" : "Abertura de porta de carga alerta",
		"desc_en" : "Cargo door opening alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1234
	},
	{
		"eventoid" : 167,
		"funcid" : 13,
		"desc_es" : "Cierre de puerta de carga alerta",
		"desc_pt" : "Fechamento de porta de carga alerta",
		"desc_en" : "Load door locking (alert)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1235
	},
	{
		"eventoid" : 572,
		"funcid" : 404,
		"desc_es" : "Apertura de Tapa 5",
		"desc_pt" : "Abertura da cobertura 5",
		"desc_en" : "Cover 5 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2194
	},
	{
		"eventoid" : 169,
		"funcid" : 14,
		"desc_es" : "Cierre de puerta de cabina alerta",
		"desc_pt" : "Fechamento de porta de motorista alerta",
		"desc_en" : "Cab door locking (alert)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1236
	},
	{
		"eventoid" : 987,
		"funcid" : 280,
		"desc_es" : "Alerta bajo nivel de combustible",
		"desc_pt" : "Alerta de baixo consumo de combustível",
		"desc_en" : "Low fuel level alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2550
	},
	{
		"eventoid" : 988,
		"funcid" : 280,
		"desc_es" : "Reporte de temperatura de motor",
		"desc_pt" : "Relatório de temperatura do motor",
		"desc_en" : "Engine temperature report",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2551
	},
	{
		"eventoid" : 1085,
		"funcid" : 280,
		"desc_es" : "Tolva arriba",
		"desc_pt" : "Hopper up",
		"desc_en" : "Hopper up",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2645
	},
	{
		"eventoid" : 990,
		"funcid" : 280,
		"desc_es" : "Estado tercer eje",
		"desc_pt" : "Estado do terceiro eixo",
		"desc_en" : "State third axis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2553
	},
	{
		"eventoid" : 172,
		"funcid" : 118,
		"desc_es" : "Apertura de puerta de pasajero alerta",
		"desc_pt" : "Abertura de porta de passageiro alerta",
		"desc_en" : "passenger door opening alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1169
	},
	{
		"eventoid" : 993,
		"funcid" : 367,
		"desc_es" : "Cinturón Conductor Desabrochado",
		"desc_pt" : "Cinturón Conductor Desabrochado",
		"desc_en" : "Cinturón Conductor Desabrochado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2556
	},
	{
		"eventoid" : 1275,
		"funcid" : 265,
		"desc_es" : "Luces apagadas",
		"desc_pt" : "Farol desligado",
		"desc_en" : "Lights off",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2803
	},
	{
		"eventoid" : 994,
		"funcid" : 367,
		"desc_es" : "Cinturón Conductor Abrochado",
		"desc_pt" : "Cinturón Conductor Abrochado",
		"desc_en" : "Cinturón Conductor Abrochado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2557
	},
	{
		"eventoid" : 393,
		"funcid" : 11,
		"desc_es" : "Desenganche de Tonel 1",
		"desc_pt" : "Liberação Barril 1",
		"desc_en" : "Tonel release 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1427
	},
	{
		"eventoid" : 1229,
		"funcid" : 363,
		"desc_es" : "Baja presión de combustible",
		"desc_pt" : "Baixa Pressão de Combustível",
		"desc_en" : "Low fuel pressure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2757
	},
	{
		"eventoid" : 395,
		"funcid" : 11,
		"desc_es" : "Desenganche de Tonel 2",
		"desc_pt" : "Liberação Barril 2",
		"desc_en" : "Tonel release 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1429
	},
	{
		"eventoid" : 396,
		"funcid" : 11,
		"desc_es" : "Enganche de Tonel 2",
		"desc_pt" : "Barril engate 2",
		"desc_en" : "Tonel hitch 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1430
	},
	{
		"eventoid" : 1276,
		"funcid" : 125,
		"desc_es" : "Fin sesión automático",
		"desc_pt" : "Fim de sessão automática",
		"desc_en" : "Automatic session end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2803
	},
	{
		"eventoid" : 321,
		"funcid" : 235,
		"desc_es" : "Fin de Carga",
		"desc_pt" : "Final de Carregamento",
		"desc_en" : "Charge end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 107
	},
	{
		"eventoid" : 482,
		"funcid" : 348,
		"desc_es" : "Compresor Encendido",
		"desc_pt" : "Compressor ignição",
		"desc_en" : "Compressor on",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 510
	},
	{
		"eventoid" : 551,
		"funcid" : 391,
		"desc_es" : "Fin marcha atras",
		"desc_pt" : "Fim de Ré",
		"desc_en" : "Reverse end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2178
	},
	{
		"eventoid" : 458,
		"funcid" : 73,
		"desc_es" : "Informe de Exceso de Velocidad",
		"desc_pt" : "Excesso Velocidade Relatório",
		"desc_en" : "Speed Report Excess",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 487
	},
	{
		"eventoid" : 459,
		"funcid" : 73,
		"desc_es" : "Informe de Exceso de Temperatura",
		"desc_pt" : "Excesso Temperatura Relatório",
		"desc_en" : "Temperature Report Excess",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 488
	},
	{
		"eventoid" : 868,
		"funcid" : 261,
		"desc_es" : "Reporte faltante alarma (30min)",
		"desc_pt" : "Reporte faltante alarma (30min)",
		"desc_en" : "Missing report alarm (30min)",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1381
	},
	{
		"eventoid" : 876,
		"funcid" : 435,
		"desc_es" : "Apertura Puerta de Bóveda",
		"desc_pt" : "Apertura Puerta de Bóveda",
		"desc_en" : "Vault door opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2264
	},
	{
		"eventoid" : 470,
		"funcid" : 303,
		"desc_es" : "Temperatura máxima camara 5",
		"desc_pt" : "Temperatura máxima camara 5",
		"desc_en" : "Maximum temperature chamber 5",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 498
	},
	{
		"eventoid" : 471,
		"funcid" : 303,
		"desc_es" : "Temperatura mínima camara 5",
		"desc_pt" : "Temperatura mínima camara 5",
		"desc_en" : "Minimum temperature chamber 5",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 499
	},
	{
		"eventoid" : 472,
		"funcid" : 303,
		"desc_es" : "Temperatura normal camara 5",
		"desc_pt" : "Temperatura normal camara 5",
		"desc_en" : "Normal temperature chamber 5",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 500
	},
	{
		"eventoid" : 473,
		"funcid" : 303,
		"desc_es" : "Temperatura máxima camara 6",
		"desc_pt" : "Temperatura máxima camara 6",
		"desc_en" : "Maximum temperature chamber 6",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 501
	},
	{
		"eventoid" : 474,
		"funcid" : 303,
		"desc_es" : "Temperatura mínima camara 6",
		"desc_pt" : "Temperatura mínima camara 6",
		"desc_en" : "Minimum temperature chamber 6",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 502
	},
	{
		"eventoid" : 475,
		"funcid" : 303,
		"desc_es" : "Temperatura normal camara 6",
		"desc_pt" : "Temperatura normal camara 6",
		"desc_en" : "Normal temperature chamber 6",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 503
	},
	{
		"eventoid" : 476,
		"funcid" : 303,
		"desc_es" : "Temperatura máxima camara 7",
		"desc_pt" : "Temperatura máxima camara 7",
		"desc_en" : "Maximum temperature chamber 7",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 504
	},
	{
		"eventoid" : 477,
		"funcid" : 303,
		"desc_es" : "Temperatura mínima camara 7",
		"desc_pt" : "Temperatura mínima camara 7",
		"desc_en" : "Minimum temperature chamber 7",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 505
	},
	{
		"eventoid" : 478,
		"funcid" : 303,
		"desc_es" : "Temperatura normal camara 7",
		"desc_pt" : "Temperatura normal camara 7",
		"desc_en" : "Normal temperature chamber 7",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 506
	},
	{
		"eventoid" : 479,
		"funcid" : 303,
		"desc_es" : "Temperatura máxima camara 8",
		"desc_pt" : "Temperatura máxima camara 8",
		"desc_en" : "Maximum temperature chamber 8",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 507
	},
	{
		"eventoid" : 555,
		"funcid" : 393,
		"desc_es" : "Tiempo de elevación",
		"desc_pt" : "Tempo de uso do implemento",
		"desc_en" : "Elevation time",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2182
	},
	{
		"eventoid" : 480,
		"funcid" : 303,
		"desc_es" : "Temperatura mínima camara 8",
		"desc_pt" : "Temperatura mínima camara 8",
		"desc_en" : "Minimum temperature chamber 8",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 508
	},
	{
		"eventoid" : 481,
		"funcid" : 303,
		"desc_es" : "Temperatura normal camara 8",
		"desc_pt" : "Temperatura normal camara 8",
		"desc_en" : "Normal temperature chamber 8",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 509
	},
	{
		"eventoid" : 483,
		"funcid" : 348,
		"desc_es" : "Compresor Apagado",
		"desc_pt" : "Compressor fora",
		"desc_en" : "Compressor off",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 511
	},
	{
		"eventoid" : 485,
		"funcid" : 325,
		"desc_es" : "Descenso pasajero",
		"desc_pt" : "Desembarque de passageiro",
		"desc_en" : "Passenger drop",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 513
	},
	{
		"eventoid" : 488,
		"funcid" : 353,
		"desc_es" : "Desconexión sensor de nivel tanque 1",
		"desc_pt" : "Desconexão sensor de nível tanque 1",
		"desc_en" : "Disconnection level sensor tank 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 516
	},
	{
		"eventoid" : 489,
		"funcid" : 353,
		"desc_es" : "Reconexión sensor de nivel tanque 1",
		"desc_pt" : "Reconexão sensor de nível tanque 1",
		"desc_en" : "Reconnection level sensor tank 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 517
	},
	{
		"eventoid" : 490,
		"funcid" : 353,
		"desc_es" : "Desconexión sensor de nivel tanque 2",
		"desc_pt" : "Desconexão sensor de nível tanque 2",
		"desc_en" : "Disconnection level sensor tank 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 518
	},
	{
		"eventoid" : 491,
		"funcid" : 353,
		"desc_es" : "Reconexión sensor de nivel tanque 2",
		"desc_pt" : "Reconexão sensor de nível tanque 2",
		"desc_en" : "Reconnection level sensor tank 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 519
	},
	{
		"eventoid" : 492,
		"funcid" : 353,
		"desc_es" : "Desconexión sensor de nivel tanque 3",
		"desc_pt" : "Desconexão sensor de nível tanque 3",
		"desc_en" : "Disconnection level sensor tank 3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 520
	},
	{
		"eventoid" : 493,
		"funcid" : 353,
		"desc_es" : "Reconexión sensor de nivel tanque 3",
		"desc_pt" : "Reconexão sensor de nível tanque 3",
		"desc_en" : "Reconnection level sensor tank 3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 521
	},
	{
		"eventoid" : 495,
		"funcid" : 28,
		"desc_es" : "Contenedor Abajo",
		"desc_pt" : "Recipiente abaixo",
		"desc_en" : "Container below",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 523
	},
	{
		"eventoid" : 2,
		"funcid" : 3,
		"desc_es" : "Reporte por tiempo",
		"desc_pt" : "Reporte por tempo",
		"desc_en" : "Report by time",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1
	},
	{
		"eventoid" : 496,
		"funcid" : 73,
		"desc_es" : "Perfil de Combustible",
		"desc_pt" : "Perfil de combustível",
		"desc_en" : "Fuel Profile",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 524
	},
	{
		"eventoid" : 922,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Válvula 7",
		"desc_pt" : "Falha sensor válvula 7",
		"desc_en" : "Valve 7 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2493
	},
	{
		"eventoid" : 498,
		"funcid" : 356,
		"desc_es" : "Calibrador Activado",
		"desc_pt" : "Medidor No",
		"desc_en" : "Gauge On",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1526
	},
	{
		"eventoid" : 552,
		"funcid" : 392,
		"desc_es" : "Inicio de tracción",
		"desc_pt" : "Início de Tração",
		"desc_en" : "Traction start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2179
	},
	{
		"eventoid" : 553,
		"funcid" : 392,
		"desc_es" : "Fin de tracción",
		"desc_pt" : "Fim de Tração",
		"desc_en" : "Traction end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2180
	},
	{
		"eventoid" : 499,
		"funcid" : 356,
		"desc_es" : "Calibrador Desactivado",
		"desc_pt" : "Calibre Off",
		"desc_en" : "Gauge Off",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1527
	},
	{
		"eventoid" : 557,
		"funcid" : 395,
		"desc_es" : "Bomba Desactivada",
		"desc_pt" : "Bomba Desativada",
		"desc_en" : "Pump deactivated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2183
	},
	{
		"eventoid" : 500,
		"funcid" : 357,
		"desc_es" : "Tiempo de Calibración Excedido",
		"desc_pt" : "Calibração Tempo excedido",
		"desc_en" : "Calibration Time Exceeded",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1528
	},
	{
		"eventoid" : 501,
		"funcid" : 358,
		"desc_es" : "Tiempro de frenado",
		"desc_pt" : "Travagem Tiempro",
		"desc_en" : "Braking Time",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1529
	},
	{
		"eventoid" : 267,
		"funcid" : 125,
		"desc_es" : "Chofer sin identificar",
		"desc_pt" : "Motorista não identificou-se",
		"desc_en" : "Unidentified driver",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 57
	},
	{
		"eventoid" : 390,
		"funcid" : 244,
		"desc_es" : "Carga de Combustible",
		"desc_pt" : "Abastecimento de Combustível",
		"desc_en" : "Fuel load",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 424
	},
	{
		"eventoid" : 391,
		"funcid" : 244,
		"desc_es" : "Descarga de Combustible",
		"desc_pt" : "Retirada de Combustível",
		"desc_en" : "Fuel download",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 425
	},
	{
		"eventoid" : 560,
		"funcid" : 107,
		"desc_es" : "Cuentalitros extendido",
		"desc_pt" : "Cuentalitros extendido",
		"desc_en" : "Extended fuel gauge",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2186
	},
	{
		"eventoid" : 234,
		"funcid" : 184,
		"desc_es" : "Salida de zona PPA",
		"desc_pt" : "Saída de zona PPA",
		"desc_en" : "PPA zone exit",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1270
	},
	{
		"eventoid" : 41,
		"funcid" : 24,
		"desc_es" : "Apertura de cisterna 1",
		"desc_pt" : "Abertura de cisterna 1",
		"desc_en" : "Tank 1 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 61
	},
	{
		"eventoid" : 44,
		"funcid" : 24,
		"desc_es" : "Apertura de cisterna 4",
		"desc_pt" : "Abertura de cisterna 4",
		"desc_en" : "Tank 4 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 64
	},
	{
		"eventoid" : 46,
		"funcid" : 24,
		"desc_es" : "Apertura de cisterna 6",
		"desc_pt" : "Abertura de cisterna 6",
		"desc_en" : "Tank 6 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 66
	},
	{
		"eventoid" : 53,
		"funcid" : 24,
		"desc_es" : "Cajon violado",
		"desc_pt" : "Caixa violada",
		"desc_en" : "Violated box",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 77
	},
	{
		"eventoid" : 283,
		"funcid" : 218,
		"desc_es" : "Cambio de curso",
		"desc_pt" : "Mudança de curso",
		"desc_en" : "Course change",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 39
	},
	{
		"eventoid" : 1410,
		"funcid" : 653,
		"desc_es" : "Unidad ocupada",
		"desc_pt" : "Unidade ocupada",
		"desc_en" : "Occupied unit",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2935
	},
	{
		"eventoid" : 57,
		"funcid" : 24,
		"desc_es" : "Accionamiento de caja de válvulas",
		"desc_pt" : "Acionamento da caixa de válvulas",
		"desc_en" : "Valve box activation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 78
	},
	{
		"eventoid" : 461,
		"funcid" : 325,
		"desc_es" : "Identificación pasajero",
		"desc_pt" : "Identificação passageiro",
		"desc_en" : "Passenger identification",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 490
	},
	{
		"eventoid" : 373,
		"funcid" : 261,
		"desc_es" : "Reporte faltante alarma (24hr)",
		"desc_pt" : "Reporte faltante alarma (24hr)",
		"desc_en" : "Missing report alarm (24hr)",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1384
	},
	{
		"eventoid" : 206,
		"funcid" : 101,
		"desc_es" : "Batería baja",
		"desc_pt" : "Bateria de backup descarregada",
		"desc_en" : "Low Battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 28
	},
	{
		"eventoid" : 547,
		"funcid" : 125,
		"desc_es" : "Check List rapido",
		"desc_pt" : "Checklist rápido",
		"desc_en" : "Ckeck List Quick",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 558
	},
	{
		"eventoid" : 991,
		"funcid" : 280,
		"desc_es" : "Carga de adblue",
		"desc_pt" : "Carga do adblue",
		"desc_en" : "Adblue load",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2554
	},
	{
		"eventoid" : 992,
		"funcid" : 280,
		"desc_es" : "Descarga de adblue",
		"desc_pt" : "Download do Adblue",
		"desc_en" : "Adblue download",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2555
	},
	{
		"eventoid" : 995,
		"funcid" : 367,
		"desc_es" : "Cinturón Copiloto 1 Desabrochado",
		"desc_pt" : "Cinturón Copiloto 1 Desabrochado",
		"desc_en" : "Cinturón Copiloto 1 Desabrochado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2558
	},
	{
		"eventoid" : 558,
		"funcid" : 398,
		"desc_es" : "Apertura de puerta de carga lateral",
		"desc_pt" : "Abertura de porta lateral de carga",
		"desc_en" : "Load side door opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2184
	},
	{
		"eventoid" : 550,
		"funcid" : 391,
		"desc_es" : "Inicio marcha atrás",
		"desc_pt" : "Início de Ré",
		"desc_en" : "Reverse start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2177
	},
	{
		"eventoid" : 1412,
		"funcid" : 274,
		"desc_es" : "Giro brusco a la izquierda",
		"desc_pt" : "Giro brusco a esquerda",
		"desc_en" : "Abrupt left turn",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2937
	},
	{
		"eventoid" : 996,
		"funcid" : 367,
		"desc_es" : "Cinturón Copiloto 1 Abrochado",
		"desc_pt" : "Cinturón Copiloto 1 Abrochado",
		"desc_en" : "Cinturón Copiloto 1 Abrochado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2559
	},
	{
		"eventoid" : 1413,
		"funcid" : 274,
		"desc_es" : "Giro brusco a la derecha",
		"desc_pt" : "Giro brusco a direita",
		"desc_en" : "Abrupt right turn",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2938
	},
	{
		"eventoid" : 91,
		"funcid" : 72,
		"desc_es" : "Desconexión de TSS",
		"desc_pt" : "Desconexão TSS",
		"desc_en" : "TSS disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 30
	},
	{
		"eventoid" : 19,
		"funcid" : 14,
		"desc_es" : "Apertura de puerta de cabina",
		"desc_pt" : "Abertura de porta de motorista",
		"desc_en" : "Cab door opening",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 32
	},
	{
		"eventoid" : 142,
		"funcid" : 101,
		"desc_es" : "Batería Backup baja",
		"desc_pt" : "Bateria de backup descarregada",
		"desc_en" : "Low Backup Battery ",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 35
	},
	{
		"eventoid" : 771,
		"funcid" : 434,
		"desc_es" : "Fin Descenso Autorizado",
		"desc_pt" : "Fim Descida Autorizada",
		"desc_en" : "End Authorized Descent",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2395
	},
	{
		"eventoid" : 997,
		"funcid" : 367,
		"desc_es" : "Cinturón Copiloto 2 Desabrochado",
		"desc_pt" : "Cinturón Copiloto 2 Desabrochado",
		"desc_en" : "Cinturón Copiloto 2 Desabrochado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2560
	},
	{
		"eventoid" : 90,
		"funcid" : 72,
		"desc_es" : "Reconexión de TSS",
		"desc_pt" : "Reconexão TSS",
		"desc_en" : "TSS reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 40
	},
	{
		"eventoid" : 923,
		"funcid" : 404,
		"desc_es" : "Desarme de Válvula 7",
		"desc_pt" : "Desmontagem da válvula 7",
		"desc_en" : "Valve 7 diasamble",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2494
	},
	{
		"eventoid" : 26,
		"funcid" : 11,
		"desc_es" : "Desenganche de semirremolque evento",
		"desc_pt" : "Desengate de carreta evento",
		"desc_en" : "Semitrailer uncoupling event",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 44
	},
	{
		"eventoid" : 998,
		"funcid" : 367,
		"desc_es" : "Cinturón Copiloto 2 Abrochado",
		"desc_pt" : "Cinturón Copiloto 2 Abrochado",
		"desc_en" : "Cinturón Copiloto 2 Abrochado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2561
	},
	{
		"eventoid" : 999,
		"funcid" : 280,
		"desc_es" : "Fin alta temperatura de refrigerante",
		"desc_pt" : "Extremidade de alta temperatura do líquido de refrigeração",
		"desc_en" : "High end coolant temperature",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2562
	},
	{
		"eventoid" : 1000,
		"funcid" : 280,
		"desc_es" : "Fin alta temperatura de aceite",
		"desc_pt" : "Termine a alta temperatura do óleo",
		"desc_en" : "End high oil temperature",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2563
	},
	{
		"eventoid" : 155,
		"funcid" : 111,
		"desc_es" : "Descanso nocturno insuficiente",
		"desc_pt" : "Descanso noturno insuficiente",
		"desc_en" : "Insufficient night rest",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 50
	},
	{
		"eventoid" : 199,
		"funcid" : 20,
		"desc_es" : "Mensaje Libre Posicion",
		"desc_pt" : "Mensagem livre posição",
		"desc_en" : "Customised message position",
		"eventotablaid" : 2,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 51
	},
	{
		"eventoid" : 1001,
		"funcid" : 280,
		"desc_es" : "Inicio de exceso de presión de acelerador",
		"desc_pt" : "Início da pressão excessiva do acelerador",
		"desc_en" : "Start of excess throttle pressure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2564
	},
	{
		"eventoid" : 548,
		"funcid" : 125,
		"desc_es" : "Check List lento",
		"desc_pt" : "Checklist lento",
		"desc_en" : "Ckeck List Slow",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 559
	},
	{
		"eventoid" : 227,
		"funcid" : 168,
		"desc_es" : "Rendimiento consulta",
		"desc_pt" : "Desempenho da consulta",
		"desc_en" : "Performance query",
		"eventotablaid" : 5,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1091
	},
	{
		"eventoid" : 148,
		"funcid" : 107,
		"desc_es" : "Cuentalitros",
		"desc_pt" : "Cuentalitros",
		"desc_en" : "Fuel gauge",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 58
	},
	{
		"eventoid" : 122,
		"funcid" : 86,
		"desc_es" : "Desconexión  sensor temperatura",
		"desc_pt" : "Desconexão sensor de temperatura",
		"desc_en" : "Temperature sensor disconnected",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 59
	},
	{
		"eventoid" : 144,
		"funcid" : 105,
		"desc_es" : "Apertura de gabinete equipo",
		"desc_pt" : "Abertura de painel",
		"desc_en" : "Device cabinet opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1036
	},
	{
		"eventoid" : 230,
		"funcid" : 180,
		"desc_es" : "Alarma de Remolque",
		"desc_pt" : "Alarme de reboque",
		"desc_en" : "Trailer alarm",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 33
	},
	{
		"eventoid" : 239,
		"funcid" : 187,
		"desc_es" : "Apertura de puerta de chofer evento",
		"desc_pt" : "Abertura porta de motorista evento",
		"desc_en" : "Driver door opening event",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 56
	},
	{
		"eventoid" : 567,
		"funcid" : 292,
		"desc_es" : "Reconexión MobileEye",
		"desc_pt" : "Reconexión MobileEye",
		"desc_en" : "Mobileye reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2189
	},
	{
		"eventoid" : 86,
		"funcid" : 70,
		"desc_es" : "Activación Central de Alarma",
		"desc_pt" : "Central de alarme ativada",
		"desc_en" : "Alarm central activation",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 95
	},
	{
		"eventoid" : 293,
		"funcid" : 217,
		"desc_es" : "Inicio ahorro de energía",
		"desc_pt" : "Início economia de energia",
		"desc_en" : "Energy saving start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 94
	},
	{
		"eventoid" : 245,
		"funcid" : 197,
		"desc_es" : "Equipo ON",
		"desc_pt" : "Equipe ON",
		"desc_en" : "Equipment ON",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 97
	},
	{
		"eventoid" : 145,
		"funcid" : 105,
		"desc_es" : "Cierre de gabinete equipo",
		"desc_pt" : "Fechamento de painel",
		"desc_en" : "Device cabinet locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1041
	},
	{
		"eventoid" : 294,
		"funcid" : 217,
		"desc_es" : "Fin ahorro de energía",
		"desc_pt" : "Economia de energia final",
		"desc_en" : "Energy saving end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 54
	},
	{
		"eventoid" : 170,
		"funcid" : 11,
		"desc_es" : "Desenganche de semirremolque alerta",
		"desc_pt" : "Desengate de carreta alerta",
		"desc_en" : "Semitrailer uncoupling alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1237
	},
	{
		"eventoid" : 171,
		"funcid" : 22,
		"desc_es" : "Desconexión de alimentación externa alerta",
		"desc_pt" : "Desconexão de bateria alerta",
		"desc_en" : "External supply disconnection (alert)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1238
	},
	{
		"eventoid" : 417,
		"funcid" : 294,
		"desc_es" : "Desconexión Easycan",
		"desc_pt" : "Desconexão Easycan",
		"desc_en" : "Disconnection Easycan",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1447
	},
	{
		"eventoid" : 418,
		"funcid" : 294,
		"desc_es" : "Reconexión Easycan",
		"desc_pt" : "Reconexão Easycan",
		"desc_en" : "Reconnection Easycan",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1448
	},
	{
		"eventoid" : 426,
		"funcid" : 300,
		"desc_es" : "Botón 4 presionado",
		"desc_pt" : "Botão 4 pressionado",
		"desc_en" : "Button 4 pressed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1456
	},
	{
		"eventoid" : 429,
		"funcid" : 300,
		"desc_es" : "Conexion sensor de temperatura camara 3",
		"desc_pt" : "Conecte a câmera sensor de temperatura 3",
		"desc_en" : "Connect temperature sensor camera 3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1459
	},
	{
		"eventoid" : 430,
		"funcid" : 300,
		"desc_es" : "Conexion sensor de temperatura camara 4",
		"desc_pt" : "Conecte a câmera sensor de temperatura 4",
		"desc_en" : "Connect temperature sensor camera 4",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1460
	},
	{
		"eventoid" : 431,
		"funcid" : 300,
		"desc_es" : "Desconexión sensor de temperatura camara 1",
		"desc_pt" : "Desconecte a câmera sensor de temperatura 1",
		"desc_en" : "Disconnect temperature sensor camera 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1461
	},
	{
		"eventoid" : 432,
		"funcid" : 300,
		"desc_es" : "Desconexión sensor de temperatura camara 2",
		"desc_pt" : "Desconecte a câmera sensor de temperatura 2",
		"desc_en" : "Disconnect temperature sensor camera 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1462
	},
	{
		"eventoid" : 433,
		"funcid" : 300,
		"desc_es" : "Desconexión sensor de temperatura camara 3",
		"desc_pt" : "Desconecte a câmera sensor de temperatura 3",
		"desc_en" : "Disconnect temperature sensor camera 3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1463
	},
	{
		"eventoid" : 434,
		"funcid" : 300,
		"desc_es" : "Desconexión sensor de temperatura camara 4",
		"desc_pt" : "Desconecte a câmera sensor de temperatura 4",
		"desc_en" : "Disconnect temperature sensor camera 4",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1464
	},
	{
		"eventoid" : 5,
		"funcid" : 40,
		"desc_es" : "Reporte por distancia en zona",
		"desc_pt" : "Reporte por distância em zona",
		"desc_en" : "Report by distance in zone",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1034
	},
	{
		"eventoid" : 3,
		"funcid" : 40,
		"desc_es" : "Reporte por tiempo en zona",
		"desc_pt" : "Reporte por tempo em zona",
		"desc_en" : "Report by time in zone",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1045
	},
	{
		"eventoid" : 73,
		"funcid" : 54,
		"desc_es" : "Actividad local",
		"desc_pt" : "Atividade local",
		"desc_en" : "Local activity",
		"eventotablaid" : 4,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1098
	},
	{
		"eventoid" : 268,
		"funcid" : 94,
		"desc_es" : "Power Up",
		"desc_pt" : "Power Up",
		"desc_en" : "Power Up",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1046
	},
	{
		"eventoid" : 463,
		"funcid" : 300,
		"desc_es" : "Conexion sensor de temperatura camara 6",
		"desc_pt" : "Conecte a câmera sensor de temperatura 6",
		"desc_en" : "Connect temperature sensor camera 6",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1491
	},
	{
		"eventoid" : 464,
		"funcid" : 300,
		"desc_es" : "Conexion sensor de temperatura camara 7",
		"desc_pt" : "Conecte a câmera sensor de temperatura 7",
		"desc_en" : "Connect temperature sensor camera 7",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1492
	},
	{
		"eventoid" : 465,
		"funcid" : 300,
		"desc_es" : "Conexion sensor de temperatura camara 8",
		"desc_pt" : "Conecte a câmera sensor de temperatura 8",
		"desc_en" : "Connect temperature sensor camera 8",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1493
	},
	{
		"eventoid" : 466,
		"funcid" : 300,
		"desc_es" : "Desconexión sensor de temperatura camara 5",
		"desc_pt" : "Desconecte a câmera sensor de temperatura 5",
		"desc_en" : "Disconnect temperature sensor camera 5",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1494
	},
	{
		"eventoid" : 467,
		"funcid" : 300,
		"desc_es" : "Desconexión sensor de temperatura camara 6",
		"desc_pt" : "Desconecte a câmera sensor de temperatura 6",
		"desc_en" : "Disconnect temperature sensor camera 6",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1495
	},
	{
		"eventoid" : 468,
		"funcid" : 300,
		"desc_es" : "Desconexión sensor de temperatura camara 7",
		"desc_pt" : "Desconecte a câmera sensor de temperatura 7",
		"desc_en" : "Disconnect temperature sensor camera 7",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1496
	},
	{
		"eventoid" : 469,
		"funcid" : 300,
		"desc_es" : "Desconexión sensor de temperatura camara 8",
		"desc_pt" : "Desconecte a câmera sensor de temperatura 8",
		"desc_en" : "Disconnect temperature sensor camera 8",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1497
	},
	{
		"eventoid" : 462,
		"funcid" : 300,
		"desc_es" : "Conexion sensor de temperatura camara 5",
		"desc_pt" : "Conecte a câmera sensor de temperatura 5",
		"desc_en" : "Connect temperature sensor camera 5",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1490
	},
	{
		"eventoid" : 1002,
		"funcid" : 280,
		"desc_es" : "Fin de exceso de presión de acelerador",
		"desc_pt" : "Pressão excessiva no fim do acelerador",
		"desc_en" : "End of excess throttle pressure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2565
	},
	{
		"eventoid" : 1086,
		"funcid" : 280,
		"desc_es" : "Tolva medio",
		"desc_pt" : "Tremonha média",
		"desc_en" : "Medium hopper",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2646
	},
	{
		"eventoid" : 986,
		"funcid" : 280,
		"desc_es" : "Inicio alta temperatura de aceite",
		"desc_pt" : "Alta temperatura do óleo",
		"desc_en" : "High oil temperature",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2549
	},
	{
		"eventoid" : 1010,
		"funcid" : 450,
		"desc_es" : "Evidencia multimedia",
		"desc_pt" : "Evidência multimídia",
		"desc_en" : "Multimedia evidence",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2572
	},
	{
		"eventoid" : 1230,
		"funcid" : 363,
		"desc_es" : "Informe de baja presión de combustible",
		"desc_pt" : "Baixa Pressão de Combustível Relatório",
		"desc_en" : "Low fuel pressure report",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2758
	},
	{
		"eventoid" : 66,
		"funcid" : 35,
		"desc_es" : "Aceleración Brusca",
		"desc_pt" : "Aceleração brusca",
		"desc_en" : "Sudden acceleration",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1191
	},
	{
		"eventoid" : 67,
		"funcid" : 35,
		"desc_es" : "Frenada Brusca",
		"desc_pt" : "Freada brusca",
		"desc_en" : "Sudden Brake",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1192
	},
	{
		"eventoid" : 68,
		"funcid" : 36,
		"desc_es" : "Aviso de accidente",
		"desc_pt" : "Aviso de acidente",
		"desc_en" : "Accident notice",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1193
	},
	{
		"eventoid" : 1009,
		"funcid" : 488,
		"desc_es" : "Detección de uso de telefono",
		"desc_pt" : "Detecção de uso do telefone",
		"desc_en" : "Phone usage detection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2571
	},
	{
		"eventoid" : 1008,
		"funcid" : 487,
		"desc_es" : "Conductor no visible",
		"desc_pt" : "Motorista não visível",
		"desc_en" : "Not visible driver",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2570
	},
	{
		"eventoid" : 1011,
		"funcid" : 489,
		"desc_es" : "Conductor fumando",
		"desc_pt" : "Motorista fumando",
		"desc_en" : "Smoking driver",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2573
	},
	{
		"eventoid" : 1394,
		"funcid" : 290,
		"desc_es" : "Batería baja en repetidor",
		"desc_pt" : "Bateria baixa no repetidor",
		"desc_en" : "Low battery in repeater",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2919
	},
	{
		"eventoid" : 1249,
		"funcid" : 57,
		"desc_es" : "Inicio de Exceso de tiempo en zona de Riesgo",
		"desc_pt" : "Inicio de Excesso de Tempo em Zona de Risco",
		"desc_en" : "Start of Excess time in Risk zone",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2777
	},
	{
		"eventoid" : 442,
		"funcid" : 237,
		"desc_es" : "Fin de Advertencia de salida de carril izquierdo",
		"desc_pt" : "Fim Aviso de Saída de pista da esquerda",
		"desc_en" : "End Warning Departure Lane Left",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1471
	},
	{
		"eventoid" : 131,
		"funcid" : 93,
		"desc_es" : "Distress",
		"desc_pt" : "Distress",
		"desc_en" : "Distress",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1223
	},
	{
		"eventoid" : 754,
		"funcid" : 117,
		"desc_es" : "Contacto OFF virtual",
		"desc_pt" : "Contato OFF virtual",
		"desc_en" : "Contact OFF virtual",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2376
	},
	{
		"eventoid" : 136,
		"funcid" : 91,
		"desc_es" : "Entregado fuera de zona",
		"desc_pt" : "Entregue fora da zona",
		"desc_en" : "Delivered outside of zone",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1225
	},
	{
		"eventoid" : 143,
		"funcid" : 96,
		"desc_es" : "Zarpe Ilegal",
		"desc_pt" : "Zarpe Ilegal",
		"desc_en" : "Ilegal departure",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 11,
		"esalerta" : "0",
		"orden" : 1231
	},
	{
		"eventoid" : 443,
		"funcid" : 237,
		"desc_es" : "Fin de Advertencia de salida de carril derecho",
		"desc_pt" : "Fim Aviso de Saída de pista dereita",
		"desc_en" : "End Warning Departure Lane Right",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1472
	},
	{
		"eventoid" : 132,
		"funcid" : 94,
		"desc_es" : "Power Up",
		"desc_pt" : "Power Up",
		"desc_en" : "Power Up",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1111
	},
	{
		"eventoid" : 1256,
		"funcid" : 382,
		"desc_es" : "Reporte de peso por eje",
		"desc_pt" : "Relatório de peso do eixo",
		"desc_en" : "Axle Weight Report",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2784
	},
	{
		"eventoid" : 329,
		"funcid" : 238,
		"desc_es" : "Advertencia y Monitoreo frontal",
		"desc_pt" : "Monitoramento e Alerta de Headway",
		"desc_en" : "Headway Monitoring and Warning",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1341
	},
	{
		"eventoid" : 327,
		"funcid" : 237,
		"desc_es" : "Advertencia de salida de carril izquierdo",
		"desc_pt" : "Aviso de Saída de pista da esquerda",
		"desc_en" : "Lane Departure Warning Left",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1339
	},
	{
		"eventoid" : 328,
		"funcid" : 237,
		"desc_es" : "Advertencia de salida de carril derecho",
		"desc_pt" : "A pista direita Aviso de Saída",
		"desc_en" : "Lane Departure Warning Right",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1340
	},
	{
		"eventoid" : 773,
		"funcid" : 290,
		"desc_es" : "Fin de actividad diferido",
		"desc_pt" : "Fim da atividade diferida",
		"desc_en" : "End of deferred activity",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2397
	},
	{
		"eventoid" : 862,
		"funcid" : 302,
		"desc_es" : "Alarma hacia Ente de Seguridad",
		"desc_pt" : "Alarme para Ente de Segurança",
		"desc_en" : "Alarm to Security Agency",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1451
	},
	{
		"eventoid" : 841,
		"funcid" : 266,
		"desc_es" : "Reconexión de impresora",
		"desc_pt" : "Reconexión de impresora",
		"desc_en" : "Printer reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1398
	},
	{
		"eventoid" : 851,
		"funcid" : 270,
		"desc_es" : "Exceso de tiempo en base",
		"desc_pt" : "Exceso de tiempo en base",
		"desc_en" : "Time on base excess",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1408
	},
	{
		"eventoid" : 361,
		"funcid" : 404,
		"desc_es" : "Cierre de Válvula 1",
		"desc_pt" : "Válvula 1 fechada",
		"desc_en" : "Valve 1 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 369
	},
	{
		"eventoid" : 362,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Válvula 1",
		"desc_pt" : "Falha no sensor de válvula 1",
		"desc_en" : "Valve 1 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 370
	},
	{
		"eventoid" : 586,
		"funcid" : 404,
		"desc_es" : "Desconexión de Tapa 1",
		"desc_pt" : "Desconexão da cobertura 1",
		"desc_en" : "Cover 1 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2208
	},
	{
		"eventoid" : 106,
		"funcid" : 408,
		"desc_es" : "Router de conexión (WIFI)",
		"desc_pt" : "Conexão em roteador (WIFI)",
		"desc_en" : "Router connection (WIFI)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2249
	},
	{
		"eventoid" : 625,
		"funcid" : 404,
		"desc_es" : "Reset Normal",
		"desc_pt" : "Reset Normal",
		"desc_en" : "Reset Normal",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2249
	},
	{
		"eventoid" : 559,
		"funcid" : 398,
		"desc_es" : "Cierre de puerta de carga lateral",
		"desc_pt" : "Fechamento de porta lateral de carga",
		"desc_en" : "Load side door locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2185
	},
	{
		"eventoid" : 213,
		"funcid" : 157,
		"desc_es" : "Aceleración Brusca Taip",
		"desc_pt" : "Aceleração brusca taip",
		"desc_en" : "Abrupt aceleration taip",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1259
	},
	{
		"eventoid" : 214,
		"funcid" : 158,
		"desc_es" : "Frenada Brusca Taip",
		"desc_pt" : "Freada brusca taip",
		"desc_en" : "Abrupt braking taip",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1260
	},
	{
		"eventoid" : 277,
		"funcid" : 216,
		"desc_es" : "Turno terminado antes de tiempo",
		"desc_pt" : "Turno terminado antes de tiempo",
		"desc_en" : "Shift finished before time",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1302
	},
	{
		"eventoid" : 278,
		"funcid" : 216,
		"desc_es" : "Camión sin gas incorrecto",
		"desc_pt" : "Camión sin gas incorrecto",
		"desc_en" : "Truck without gas",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1303
	},
	{
		"eventoid" : 281,
		"funcid" : 216,
		"desc_es" : "Evento Inválido",
		"desc_pt" : "Evento Inválido",
		"desc_en" : "Invalid event",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1306
	},
	{
		"eventoid" : 315,
		"funcid" : 216,
		"desc_es" : "Permanencia en zona",
		"desc_pt" : "Permanencia en zona",
		"desc_en" : "Zone overtime",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1331
	},
	{
		"eventoid" : 379,
		"funcid" : 264,
		"desc_es" : "Fin de intervención equipo",
		"desc_pt" : "Fin de intervención equipo",
		"desc_en" : "Device intervention end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1387
	},
	{
		"eventoid" : 563,
		"funcid" : 261,
		"desc_es" : "Reporte faltante alarma (4hr)",
		"desc_pt" : "Reporte faltante alarma (4hr)",
		"desc_en" : "Missing report alarm (4hr)",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1383
	},
	{
		"eventoid" : 564,
		"funcid" : 261,
		"desc_es" : "Reporte faltante alarma (7días)",
		"desc_pt" : "Reporte faltante alarma (7días)",
		"desc_en" : "Missing report alarm (7days)",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1386
	},
	{
		"eventoid" : 840,
		"funcid" : 266,
		"desc_es" : "Desconexión de impresora",
		"desc_pt" : "Desconexión de impresora",
		"desc_en" : "Printer disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1397
	},
	{
		"eventoid" : 853,
		"funcid" : 272,
		"desc_es" : "Exceso de timepo en zona de descarga",
		"desc_pt" : "Exceso de timepo en zona de descarga",
		"desc_en" : "Time on download area excess",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1410
	},
	{
		"eventoid" : 854,
		"funcid" : 273,
		"desc_es" : "Exceso de tiempo en zona de detenciones",
		"desc_pt" : "Exceso de tiempo en zona de detenciones",
		"desc_en" : "Time on detention area excess",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1411
	},
	{
		"eventoid" : 859,
		"funcid" : 216,
		"desc_es" : "Faltante de litros liquidados",
		"desc_pt" : "Faltante de litros liquidados",
		"desc_en" : "Liquidated liters missing",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1426
	},
	{
		"eventoid" : 860,
		"funcid" : 216,
		"desc_es" : "Litros liquidados no coincidentes",
		"desc_pt" : "Litros liquidados no coincidentes",
		"desc_en" : "Liquidated liters not matching",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1427
	},
	{
		"eventoid" : 864,
		"funcid" : 261,
		"desc_es" : "Reporte faltante alarma (72hr)",
		"desc_pt" : "Reporte faltante alarma (72hr)",
		"desc_en" : "Missing report alarm (72hr)",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1385
	},
	{
		"eventoid" : 1012,
		"funcid" : 125,
		"desc_es" : "En movimiento sin hacer checklist",
		"desc_pt" : "Movimentação sem fazer checklist",
		"desc_en" : "On the move without checklist",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2573
	},
	{
		"eventoid" : 1,
		"funcid" : 1,
		"desc_es" : "Respuesta a pedido de posición",
		"desc_pt" : "Resposta ao pedido de posição",
		"desc_en" : "Response to location request",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 9
	},
	{
		"eventoid" : 330,
		"funcid" : 113,
		"desc_es" : "Conexion Antena GPS",
		"desc_pt" : "Conexion Antena GPS",
		"desc_en" : "GPS antenna connetion",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 13
	},
	{
		"eventoid" : 1054,
		"funcid" : 391,
		"desc_es" : "Fin de retroceso",
		"desc_pt" : "Fim do recuo",
		"desc_en" : "End of recoil",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2614
	},
	{
		"eventoid" : 568,
		"funcid" : 404,
		"desc_es" : "Apertura de Tapa 1",
		"desc_pt" : "Abertura da cobertura 1",
		"desc_en" : "Cover 1 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2190
	},
	{
		"eventoid" : 569,
		"funcid" : 404,
		"desc_es" : "Apertura de Tapa 2",
		"desc_pt" : "Abertura da cobertura 2",
		"desc_en" : "Cover 2 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2191
	},
	{
		"eventoid" : 570,
		"funcid" : 404,
		"desc_es" : "Apertura de Tapa 3",
		"desc_pt" : "Abertura da cobertura 3",
		"desc_en" : "Cover 3 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2192
	},
	{
		"eventoid" : 571,
		"funcid" : 404,
		"desc_es" : "Apertura de Tapa 4",
		"desc_pt" : "Abertura da cobertura 4",
		"desc_en" : "Cover 4 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2193
	},
	{
		"eventoid" : 573,
		"funcid" : 404,
		"desc_es" : "Apertura de Tapa 6",
		"desc_pt" : "Abertura da cobertura 6",
		"desc_en" : "Cover 6 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2195
	},
	{
		"eventoid" : 574,
		"funcid" : 404,
		"desc_es" : "Cierre de Tapa 1",
		"desc_pt" : "Fechada da cobertura 1",
		"desc_en" : "Cover 1 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2196
	},
	{
		"eventoid" : 575,
		"funcid" : 404,
		"desc_es" : "Cierre de Tapa 2",
		"desc_pt" : "Fechada da cobertura 2",
		"desc_en" : "Cover 2 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2197
	},
	{
		"eventoid" : 576,
		"funcid" : 404,
		"desc_es" : "Cierre de Tapa 3",
		"desc_pt" : "Fechada da cobertura 3",
		"desc_en" : "Cover 3 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2198
	},
	{
		"eventoid" : 577,
		"funcid" : 404,
		"desc_es" : "Cierre de Tapa 4",
		"desc_pt" : "Fechada da cobertura 4",
		"desc_en" : "Cover 4 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2199
	},
	{
		"eventoid" : 578,
		"funcid" : 404,
		"desc_es" : "Cierre de Tapa 5",
		"desc_pt" : "Fechada da cobertura 5",
		"desc_en" : "Cover 5 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2200
	},
	{
		"eventoid" : 579,
		"funcid" : 404,
		"desc_es" : "Cierre de Tapa 6",
		"desc_pt" : "Fechada da cobertura 6",
		"desc_en" : "Cover 6 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2201
	},
	{
		"eventoid" : 580,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Tapa 1",
		"desc_pt" : "Falha sensor da cobertura 1",
		"desc_en" : "Cover 1 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2202
	},
	{
		"eventoid" : 581,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Tapa 2",
		"desc_pt" : "Falha sensor da cobertura 2",
		"desc_en" : "Cover 2 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2203
	},
	{
		"eventoid" : 582,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Tapa 3",
		"desc_pt" : "Falha sensor da cobertura 3",
		"desc_en" : "Cover 3 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2204
	},
	{
		"eventoid" : 583,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Tapa 4",
		"desc_pt" : "Falha sensor da cobertura 4",
		"desc_en" : "Cover 4 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2205
	},
	{
		"eventoid" : 584,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Tapa 5",
		"desc_pt" : "Falha sensor da cobertura 5",
		"desc_en" : "Cover 5 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2206
	},
	{
		"eventoid" : 585,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Tapa 6",
		"desc_pt" : "Falha sensor da cobertura 6",
		"desc_en" : "Cover 6 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2207
	},
	{
		"eventoid" : 592,
		"funcid" : 404,
		"desc_es" : "Apertura de Válvula 3",
		"desc_pt" : "Abertura da válvula 3",
		"desc_en" : "Valve 3 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2214
	},
	{
		"eventoid" : 593,
		"funcid" : 404,
		"desc_es" : "Apertura de Válvula 4",
		"desc_pt" : "Abertura da válvula 4",
		"desc_en" : "Valve 4 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2215
	},
	{
		"eventoid" : 594,
		"funcid" : 404,
		"desc_es" : "Apertura de Válvula 5",
		"desc_pt" : "Abertura da válvula 5",
		"desc_en" : "Valve 5 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2216
	},
	{
		"eventoid" : 595,
		"funcid" : 404,
		"desc_es" : "Apertura de Válvula 6",
		"desc_pt" : "Abertura da válvula 6",
		"desc_en" : "Valve 6 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2217
	},
	{
		"eventoid" : 596,
		"funcid" : 404,
		"desc_es" : "Cierre de Válvula 3",
		"desc_pt" : "Fechada da válvula 3",
		"desc_en" : "Valve 3 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2218
	},
	{
		"eventoid" : 597,
		"funcid" : 404,
		"desc_es" : "Cierre de Válvula 4",
		"desc_pt" : "Fechada da válvula 4",
		"desc_en" : "Valve 4 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2219
	},
	{
		"eventoid" : 598,
		"funcid" : 404,
		"desc_es" : "Cierre de Válvula 5",
		"desc_pt" : "Fechada da válvula 5",
		"desc_en" : "Valve 5 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2220
	},
	{
		"eventoid" : 599,
		"funcid" : 404,
		"desc_es" : "Cierre de Válvula 6",
		"desc_pt" : "Fechada da válvula 6",
		"desc_en" : "Valve 6 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2221
	},
	{
		"eventoid" : 600,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Válvula 3",
		"desc_pt" : "Falha sensor válvula 3",
		"desc_en" : "Valve 3 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2222
	},
	{
		"eventoid" : 601,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Válvula 4",
		"desc_pt" : "Falha sensor válvula 4",
		"desc_en" : "Valve 4 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2223
	},
	{
		"eventoid" : 602,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Válvula 5",
		"desc_pt" : "Falha sensor válvula 5",
		"desc_en" : "Valve 5 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2224
	},
	{
		"eventoid" : 603,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Válvula 6",
		"desc_pt" : "Falha sensor válvula 6",
		"desc_en" : "Valve 6 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2225
	},
	{
		"eventoid" : 604,
		"funcid" : 404,
		"desc_es" : "Desarme de Válvula 1",
		"desc_pt" : "Desmontagem da válvula 1",
		"desc_en" : "Valve 1 diasamble",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2226
	},
	{
		"eventoid" : 605,
		"funcid" : 404,
		"desc_es" : "Desarme de Válvula 2",
		"desc_pt" : "Desmontagem da válvula 2",
		"desc_en" : "Valve 2 diasamble",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2227
	},
	{
		"eventoid" : 606,
		"funcid" : 404,
		"desc_es" : "Desarme de Válvula 3",
		"desc_pt" : "Desmontagem da válvula 3",
		"desc_en" : "Valve 3 diasamble",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2228
	},
	{
		"eventoid" : 607,
		"funcid" : 404,
		"desc_es" : "Desarme de Válvula 4",
		"desc_pt" : "Desmontagem da válvula 4",
		"desc_en" : "Valve 4 diasamble",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2229
	},
	{
		"eventoid" : 608,
		"funcid" : 404,
		"desc_es" : "Desarme de Válvula 5",
		"desc_pt" : "Desmontagem da válvula 5",
		"desc_en" : "Valve 5 diasamble",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2230
	},
	{
		"eventoid" : 609,
		"funcid" : 404,
		"desc_es" : "Desarme de Válvula 6",
		"desc_pt" : "Desmontagem da válvula 6",
		"desc_en" : "Valve 6 diasamble",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2231
	},
	{
		"eventoid" : 4,
		"funcid" : 2,
		"desc_es" : "Reporte por distancia",
		"desc_pt" : "Reporte por distância",
		"desc_en" : "Report by distance",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2
	},
	{
		"eventoid" : 1015,
		"funcid" : 109,
		"desc_es" : "Preaviso de conducción diaria",
		"desc_pt" : "Aviso de condução diária",
		"desc_en" : "Daily driving notice",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2576
	},
	{
		"eventoid" : 163,
		"funcid" : 117,
		"desc_es" : "Contacto ON",
		"desc_pt" : "Contato ON",
		"desc_en" : "Contact ON",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 5
	},
	{
		"eventoid" : 164,
		"funcid" : 117,
		"desc_es" : "Contacto OFF",
		"desc_pt" : "Contato OFF",
		"desc_en" : "Contact OFF",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 6
	},
	{
		"eventoid" : 1014,
		"funcid" : 1,
		"desc_es" : "Evento no implementado",
		"desc_pt" : "Evento não implementado",
		"desc_en" : "Not implemented method",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2575
	},
	{
		"eventoid" : 1019,
		"funcid" : 290,
		"desc_es" : "Inicio de uso de freno de servicio",
		"desc_pt" : "Início do uso do freio de serviço",
		"desc_en" : "Start of service brake use",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2579
	},
	{
		"eventoid" : 39,
		"funcid" : 22,
		"desc_es" : "Desconexión de alimentación externa",
		"desc_pt" : "Desconexão de alimentação externa",
		"desc_en" : "External supply disconnection",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 10
	},
	{
		"eventoid" : 40,
		"funcid" : 23,
		"desc_es" : "Reconexión de alimentación externa",
		"desc_pt" : "Reconexão de alimentação externa",
		"desc_en" : "External supply reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 11
	},
	{
		"eventoid" : 1017,
		"funcid" : 12,
		"desc_es" : "Frenada",
		"desc_pt" : "Travagem",
		"desc_en" : "Braking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2578
	},
	{
		"eventoid" : 21,
		"funcid" : 14,
		"desc_es" : "Apertura de puerta de cabina evento",
		"desc_pt" : "Abertura de porta de motorista evento",
		"desc_en" : "Cab door opening event",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 14
	},
	{
		"eventoid" : 1018,
		"funcid" : 490,
		"desc_es" : "Logger OFF",
		"desc_pt" : "Logger OFF",
		"desc_en" : "Logger OFF",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2579
	},
	{
		"eventoid" : 54,
		"funcid" : 20,
		"desc_es" : "Mensaje Libre",
		"desc_pt" : "Mensagem livre",
		"desc_en" : "Customised message",
		"eventotablaid" : 2,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 16
	},
	{
		"eventoid" : 55,
		"funcid" : 20,
		"desc_es" : "Mensaje Fijo",
		"desc_pt" : "Mensagem fixa",
		"desc_en" : "Predetermined message",
		"eventotablaid" : 2,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 17
	},
	{
		"eventoid" : 1053,
		"funcid" : 391,
		"desc_es" : "En retroceso",
		"desc_pt" : "Ao contrário",
		"desc_en" : "In reverse",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2613
	},
	{
		"eventoid" : 616,
		"funcid" : 404,
		"desc_es" : "Apertura de Cajón de Válvulas 1",
		"desc_pt" : "Abertura de gaveta da válvula 1",
		"desc_en" : "Valve 1 box opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2238
	},
	{
		"eventoid" : 617,
		"funcid" : 404,
		"desc_es" : "Cierre de Cajón de Válvulas 1",
		"desc_pt" : "Fechada de gaveta da válvula 2",
		"desc_en" : "Valve 1 box locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2239
	},
	{
		"eventoid" : 587,
		"funcid" : 404,
		"desc_es" : "Desconexión de Tapa 2",
		"desc_pt" : "Desconexão da cobertura 2",
		"desc_en" : "Cover 2 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2209
	},
	{
		"eventoid" : 588,
		"funcid" : 404,
		"desc_es" : "Desconexión de Tapa 3",
		"desc_pt" : "Desconexão da cobertura 3",
		"desc_en" : "Cover 3 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2210
	},
	{
		"eventoid" : 589,
		"funcid" : 404,
		"desc_es" : "Desconexión de Tapa 4",
		"desc_pt" : "Desconexão da cobertura 4",
		"desc_en" : "Cover 4 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2211
	},
	{
		"eventoid" : 590,
		"funcid" : 404,
		"desc_es" : "Desconexión de Tapa 5",
		"desc_pt" : "Desconexão da cobertura 5",
		"desc_en" : "Cover 5 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2212
	},
	{
		"eventoid" : 591,
		"funcid" : 404,
		"desc_es" : "Desconexión de Tapa 6",
		"desc_pt" : "Desconexão da cobertura 6",
		"desc_en" : "Cover 6 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2213
	},
	{
		"eventoid" : 610,
		"funcid" : 404,
		"desc_es" : "Desconexión de Válvula 1",
		"desc_pt" : "Desconexão da válvula 1",
		"desc_en" : "Valve 1 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2232
	},
	{
		"eventoid" : 611,
		"funcid" : 404,
		"desc_es" : "Desconexión de Válvula 2",
		"desc_pt" : "Desconexão da válvula 2",
		"desc_en" : "Valve 2 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2233
	},
	{
		"eventoid" : 612,
		"funcid" : 404,
		"desc_es" : "Desconexión de Válvula 3",
		"desc_pt" : "Desconexão da válvula 3",
		"desc_en" : "Valve 3 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2234
	},
	{
		"eventoid" : 613,
		"funcid" : 404,
		"desc_es" : "Desconexión de Válvula 4",
		"desc_pt" : "Desconexão da válvula 4",
		"desc_en" : "Valve 4 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2235
	},
	{
		"eventoid" : 614,
		"funcid" : 404,
		"desc_es" : "Desconexión de Válvula 5",
		"desc_pt" : "Desconexão da válvula 5",
		"desc_en" : "Valve 5 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2236
	},
	{
		"eventoid" : 615,
		"funcid" : 404,
		"desc_es" : "Desconexión de Válvula 6",
		"desc_pt" : "Desconexão da válvula 6",
		"desc_en" : "Valve 6 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2237
	},
	{
		"eventoid" : 1020,
		"funcid" : 503,
		"desc_es" : "Inicio hoja de ruta",
		"desc_pt" : "Começar folha da rota",
		"desc_en" : "Route sheet start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2580
	},
	{
		"eventoid" : 24,
		"funcid" : 11,
		"desc_es" : "Desenganche de semirremolque",
		"desc_pt" : "Desengate de carreta",
		"desc_en" : "Semitrailer uncoupling",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 22
	},
	{
		"eventoid" : 23,
		"funcid" : 11,
		"desc_es" : "Enganche de semiremolque evento",
		"desc_pt" : "Engate de carreta evento",
		"desc_en" : "Semitrailer coupling (event)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 23
	},
	{
		"eventoid" : 151,
		"funcid" : 22,
		"desc_es" : "Desconexión de alimentación externa evento",
		"desc_pt" : "Desconexão de alimentação externa logado",
		"desc_en" : "External supply disconnection (event)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 24
	},
	{
		"eventoid" : 1021,
		"funcid" : 503,
		"desc_es" : "Inspección",
		"desc_pt" : "Inspeção",
		"desc_en" : "Inspection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2581
	},
	{
		"eventoid" : 1024,
		"funcid" : 503,
		"desc_es" : "Conducción a taller",
		"desc_pt" : "Condução para a oficina",
		"desc_en" : "Driving to workshop",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2584
	},
	{
		"eventoid" : 1025,
		"funcid" : 503,
		"desc_es" : "Conducción a base",
		"desc_pt" : "Condução para a base",
		"desc_en" : "Driving to base",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2585
	},
	{
		"eventoid" : 875,
		"funcid" : 54,
		"desc_es" : "Tiempo de Actividad",
		"desc_pt" : "Tempo de Atividade",
		"desc_en" : "Activity Time",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2263
	},
	{
		"eventoid" : 1026,
		"funcid" : 503,
		"desc_es" : "Conducción a revisión",
		"desc_pt" : "Condução para a revisão",
		"desc_en" : "Driving to review",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2586
	},
	{
		"eventoid" : 1027,
		"funcid" : 503,
		"desc_es" : "Mantenimiento en ruta",
		"desc_pt" : "Mantenimiento en ruta",
		"desc_en" : "Maintenance on road",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2587
	},
	{
		"eventoid" : 1016,
		"funcid" : 290,
		"desc_es" : "Fin de uso de freno de servicio",
		"desc_pt" : "Fim do uso do freio de serviço",
		"desc_en" : "End of use of service brake",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2577
	},
	{
		"eventoid" : 1029,
		"funcid" : 503,
		"desc_es" : "Fin de carga de producto",
		"desc_pt" : "Fim de carregamento",
		"desc_en" : "Load end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2589
	},
	{
		"eventoid" : 1031,
		"funcid" : 503,
		"desc_es" : "Fin de descarga de producto",
		"desc_pt" : "Fim do baixar",
		"desc_en" : "Discharge end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2591
	},
	{
		"eventoid" : 1032,
		"funcid" : 503,
		"desc_es" : "Espera",
		"desc_pt" : "Espera",
		"desc_en" : "Wait",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2592
	},
	{
		"eventoid" : 288,
		"funcid" : 224,
		"desc_es" : "Help",
		"desc_pt" : "Help",
		"desc_en" : "Help",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 308
	},
	{
		"eventoid" : 290,
		"funcid" : 224,
		"desc_es" : "S.O.S.",
		"desc_pt" : "S.O.S.",
		"desc_en" : "S.O.S.",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 310
	},
	{
		"eventoid" : 1034,
		"funcid" : 503,
		"desc_es" : "Descanso en tierra",
		"desc_pt" : "Descanso na terra",
		"desc_en" : "Rest on land",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2594
	},
	{
		"eventoid" : 208,
		"funcid" : 155,
		"desc_es" : "Presión de aceite de motor baja",
		"desc_pt" : "Baixa pressão do óleo",
		"desc_en" : "Engine oil pressure low",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 116
	},
	{
		"eventoid" : 209,
		"funcid" : 156,
		"desc_es" : "Reporte por tiempo contacto",
		"desc_pt" : "Reporte por tempo com contato",
		"desc_en" : "Report by time contact on",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 21
	},
	{
		"eventoid" : 286,
		"funcid" : 224,
		"desc_es" : "Track",
		"desc_pt" : "Track",
		"desc_en" : "Track",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 307
	},
	{
		"eventoid" : 289,
		"funcid" : 224,
		"desc_es" : "Help Cancel",
		"desc_pt" : "Help Cancel",
		"desc_en" : "Help Cancel",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 309
	},
	{
		"eventoid" : 291,
		"funcid" : 224,
		"desc_es" : "911 Cancel",
		"desc_pt" : "911 Cancel",
		"desc_en" : "911 Cancel",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 311
	},
	{
		"eventoid" : 640,
		"funcid" : 244,
		"desc_es" : "Carga de combustible facturada",
		"desc_pt" : "Abastecimento de combustível faturado",
		"desc_en" : "Invoiced fuel charge",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2263
	},
	{
		"eventoid" : 1037,
		"funcid" : 503,
		"desc_es" : "Pesaje",
		"desc_pt" : "Pesagem",
		"desc_en" : "Weighing",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2597
	},
	{
		"eventoid" : 618,
		"funcid" : 404,
		"desc_es" : "Apertura de Cajón de Válvulas 2",
		"desc_pt" : "Abertura da gaveta do válvula 3",
		"desc_en" : "Valve 2 box opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2240
	},
	{
		"eventoid" : 619,
		"funcid" : 404,
		"desc_es" : "Cierre de Cajón de Válvulas 2",
		"desc_pt" : "Fechada da gaveta do válvula 3",
		"desc_en" : "Valve 2 box locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2241
	},
	{
		"eventoid" : 246,
		"funcid" : 197,
		"desc_es" : "Equipo OFF",
		"desc_pt" : "Equipe OFF",
		"desc_en" : "Equipment OFF",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 106
	},
	{
		"eventoid" : 620,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Cajón de Válvulas 1",
		"desc_pt" : "Falha sensor gaveta da válvula 1",
		"desc_en" : "Valve 1 box sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2242
	},
	{
		"eventoid" : 56,
		"funcid" : 20,
		"desc_es" : "Mensaje Libre Paquete",
		"desc_pt" : "Pacote de mensagem livre",
		"desc_en" : "Customised Message Packages",
		"eventotablaid" : 2,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 109
	},
	{
		"eventoid" : 1038,
		"funcid" : 503,
		"desc_es" : "Fin hoja de ruta",
		"desc_pt" : "Fim folha da rota",
		"desc_en" : "Route sheet end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2598
	},
	{
		"eventoid" : 621,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Cajón de Válvulas 2",
		"desc_pt" : "Falha sensor gaveta da válvula 2",
		"desc_en" : "Valve 2 box sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2243
	},
	{
		"eventoid" : 1022,
		"funcid" : 503,
		"desc_es" : "Conducción",
		"desc_pt" : "Condução operacional",
		"desc_en" : "Operational driving",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2582
	},
	{
		"eventoid" : 622,
		"funcid" : 404,
		"desc_es" : "Desconexión Sensor Cajón de Válvulas 1",
		"desc_pt" : "Desconexão sensor de gaveta da válvula 1",
		"desc_en" : "Valve 1 box sensor disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2244
	},
	{
		"eventoid" : 623,
		"funcid" : 404,
		"desc_es" : "Desconexión Sensor Cajón de Válvulas 2",
		"desc_pt" : "Desconexão sensor de gaveta da válvula 2",
		"desc_en" : "Valve 2 box sensor disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2245
	},
	{
		"eventoid" : 871,
		"funcid" : 392,
		"desc_es" : "Tiempo de desplazamiento",
		"desc_pt" : "Tempo de Deslocamento",
		"desc_en" : "Displacement Time",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2248
	},
	{
		"eventoid" : 1013,
		"funcid" : 363,
		"desc_es" : "Detección de Cansancio",
		"desc_pt" : "Detecção de Cansaço",
		"desc_en" : "Tiredness Detection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2574
	},
	{
		"eventoid" : 204,
		"funcid" : 129,
		"desc_es" : "Apertura de panel",
		"desc_pt" : "Abertura de painel",
		"desc_en" : "Device panel opening",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 121
	},
	{
		"eventoid" : 1028,
		"funcid" : 503,
		"desc_es" : "Carga",
		"desc_pt" : "Início de carregamento",
		"desc_en" : "Load start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2588
	},
	{
		"eventoid" : 872,
		"funcid" : 392,
		"desc_es" : "Tiempo de Produccion",
		"desc_pt" : "Tempo de produção",
		"desc_en" : "Production Time",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2249
	},
	{
		"eventoid" : 1030,
		"funcid" : 503,
		"desc_es" : "Inicia Descarga",
		"desc_pt" : "Início do baixar",
		"desc_en" : "Discharge start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2590
	},
	{
		"eventoid" : 34,
		"funcid" : 26,
		"desc_es" : "Tercer eje abajo",
		"desc_pt" : "Terceiro eixo abaixado",
		"desc_en" : "Third axis down",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 127
	},
	{
		"eventoid" : 247,
		"funcid" : 199,
		"desc_es" : "Exceso de Detenido",
		"desc_pt" : "Excesso Parada",
		"desc_en" : "Excess of Stopped",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 128
	},
	{
		"eventoid" : 113,
		"funcid" : 83,
		"desc_es" : "Temperatura máxima camara 1",
		"desc_pt" : "Temperatura máxima câmara 1",
		"desc_en" : "Maximum temperature chamber 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 130
	},
	{
		"eventoid" : 309,
		"funcid" : 231,
		"desc_es" : "Reconexión Alimentación de TSS",
		"desc_pt" : "Reconexão Alimentação TSS",
		"desc_en" : "TSS Power Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 131
	},
	{
		"eventoid" : 1033,
		"funcid" : 503,
		"desc_es" : "Descanso a bordo camión",
		"desc_pt" : "Descanso a bordo",
		"desc_en" : "Rest on board",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2593
	},
	{
		"eventoid" : 1035,
		"funcid" : 503,
		"desc_es" : "Base TSM",
		"desc_pt" : "Na Base",
		"desc_en" : "In Base",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2595
	},
	{
		"eventoid" : 1036,
		"funcid" : 503,
		"desc_es" : "Otras tareas auxiliares",
		"desc_pt" : "Tarefa auxiliar",
		"desc_en" : "Auxiliary task",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2596
	},
	{
		"eventoid" : 215,
		"funcid" : 161,
		"desc_es" : "Tamper ON",
		"desc_pt" : "Tamper ON",
		"desc_en" : "Tamper ON",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 132
	},
	{
		"eventoid" : 1023,
		"funcid" : 503,
		"desc_es" : "Conducción a Cliente",
		"desc_pt" : "Condução para a cliente",
		"desc_en" : "Driving to client",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2583
	},
	{
		"eventoid" : 1041,
		"funcid" : 504,
		"desc_es" : "Presión alta de neumático",
		"desc_pt" : "Pressão alta do pneu",
		"desc_en" : "High pressure for tyre",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2601
	},
	{
		"eventoid" : 1042,
		"funcid" : 504,
		"desc_es" : "Presión baja de neumático",
		"desc_pt" : "Pressão baixa do pneu",
		"desc_en" : "Low pressure for tyre",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2602
	},
	{
		"eventoid" : 1043,
		"funcid" : 440,
		"desc_es" : "Medición",
		"desc_pt" : "Medição",
		"desc_en" : "Measure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2603
	},
	{
		"eventoid" : 1044,
		"funcid" : 440,
		"desc_es" : "Alarma nivel bajo",
		"desc_pt" : "Alarme de nível baixo",
		"desc_en" : "Low level alarm",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2604
	},
	{
		"eventoid" : 1045,
		"funcid" : 440,
		"desc_es" : "Alarma nivel alto",
		"desc_pt" : "Alarme de alto nível",
		"desc_en" : "High level alarm",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2605
	},
	{
		"eventoid" : 147,
		"funcid" : 106,
		"desc_es" : "Cierre de gabinete cuentalitros",
		"desc_pt" : "Gabinete cuentalitros fechado",
		"desc_en" : "Fuel gauge cabinet locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1113
	},
	{
		"eventoid" : 1046,
		"funcid" : 440,
		"desc_es" : "Error en la medicion",
		"desc_pt" : "Erro de medição",
		"desc_en" : "Measurement error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2606
	},
	{
		"eventoid" : 1056,
		"funcid" : 262,
		"desc_es" : "Inicio de video Sensor1",
		"desc_pt" : "Vídeo iniciar Sensor1",
		"desc_en" : "Video start Sensor1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2616
	},
	{
		"eventoid" : 1072,
		"funcid" : 4,
		"desc_es" : "Alarma RPMs",
		"desc_pt" : "Alarme RPMs",
		"desc_en" : "RPMs Alarm",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2632
	},
	{
		"eventoid" : 134,
		"funcid" : 96,
		"desc_es" : "Entrada a puerto",
		"desc_pt" : "Entrada no porto",
		"desc_en" : "Entry into port",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1124
	},
	{
		"eventoid" : 232,
		"funcid" : 185,
		"desc_es" : "Wake up",
		"desc_pt" : "Wake up",
		"desc_en" : "Wake up",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 125
	},
	{
		"eventoid" : 626,
		"funcid" : 404,
		"desc_es" : "Reset por Comando",
		"desc_pt" : "Reset por Comando",
		"desc_en" : "Command Reset",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2250
	},
	{
		"eventoid" : 627,
		"funcid" : 404,
		"desc_es" : "Reset",
		"desc_pt" : "Reset",
		"desc_en" : "Reset",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2251
	},
	{
		"eventoid" : 629,
		"funcid" : 404,
		"desc_es" : "Cierre de Gabinete",
		"desc_pt" : "Fechada da Gabinete",
		"desc_en" : "Cabinet Locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2253
	},
	{
		"eventoid" : 243,
		"funcid" : 193,
		"desc_es" : "Sensor de lluvia activado",
		"desc_pt" : "Sensor de chuva ativado",
		"desc_en" : "Rain sensor activated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 129
	},
	{
		"eventoid" : 249,
		"funcid" : 204,
		"desc_es" : "AutoStart Desactivado",
		"desc_pt" : "AutoStart Desativado",
		"desc_en" : "Autostart deactivated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1276
	},
	{
		"eventoid" : 252,
		"funcid" : 205,
		"desc_es" : "Ignición Manual en OFF",
		"desc_pt" : "Ignição manual em OFF",
		"desc_en" : "Manual ignition OFF",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1279
	},
	{
		"eventoid" : 253,
		"funcid" : 206,
		"desc_es" : "Electroválvula de acelerador sin tensión",
		"desc_pt" : "Eletroválvula de acelerador sem tensão",
		"desc_en" : "Throttle solenoid valve without tension",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1280
	},
	{
		"eventoid" : 255,
		"funcid" : 206,
		"desc_es" : "Evento Fallido",
		"desc_pt" : "Falha evento",
		"desc_en" : "Failed event",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1282
	},
	{
		"eventoid" : 114,
		"funcid" : 83,
		"desc_es" : "Temperatura normal camara 1",
		"desc_pt" : "Temperatura normal câmara 1",
		"desc_en" : "Normal temperature chamber 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 134
	},
	{
		"eventoid" : 116,
		"funcid" : 84,
		"desc_es" : "Temperatura máxima camara 2",
		"desc_pt" : "Temperatura máxima câmara 2",
		"desc_en" : "Maximum temperature chamber 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 135
	},
	{
		"eventoid" : 63,
		"funcid" : 29,
		"desc_es" : "No entregado",
		"desc_pt" : "Não entregue",
		"desc_en" : "Undelivered",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 137
	},
	{
		"eventoid" : 62,
		"funcid" : 29,
		"desc_es" : "Entregado",
		"desc_pt" : "Entregue",
		"desc_en" : "Delivered",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 138
	},
	{
		"eventoid" : 893,
		"funcid" : 259,
		"desc_es" : "Reconexión sensor",
		"desc_pt" : "Reconectar sensor",
		"desc_en" : "Reconnect sensor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2465
	},
	{
		"eventoid" : 115,
		"funcid" : 83,
		"desc_es" : "Temperatura mínima camara 1",
		"desc_pt" : "Temperatura mínima câmara 1",
		"desc_en" : "Minimum temperature chamber 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 143
	},
	{
		"eventoid" : 907,
		"funcid" : 448,
		"desc_es" : "Humedad normal camara 1",
		"desc_pt" : "Humedad normal câmara 1",
		"desc_en" : "Normal Humidity chamber 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2479
	},
	{
		"eventoid" : 284,
		"funcid" : 73,
		"desc_es" : "Computadora abordo",
		"desc_pt" : "Computador a bordo",
		"desc_en" : "On board computer",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 146
	},
	{
		"eventoid" : 1039,
		"funcid" : 283,
		"desc_es" : "Fin de Control Crucero",
		"desc_pt" : "Fim do Controle de Cruzeiro",
		"desc_en" : "Cruise Control End",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2599
	},
	{
		"eventoid" : 310,
		"funcid" : 231,
		"desc_es" : "Desconexión Alimentación de TSS",
		"desc_pt" : "Desconexão Alimentação TSS",
		"desc_en" : "TSS Power disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 148
	},
	{
		"eventoid" : 27,
		"funcid" : 25,
		"desc_es" : "Consumo de combustible",
		"desc_pt" : "Consumo de combustível",
		"desc_en" : "Fuel consumption",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 149
	},
	{
		"eventoid" : 221,
		"funcid" : 160,
		"desc_es" : "Fuera de Ruta",
		"desc_pt" : "Fora de rota",
		"desc_en" : "Out of Route",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 151
	},
	{
		"eventoid" : 1277,
		"funcid" : 20,
		"desc_es" : "Rotura Tablet\/celular",
		"desc_pt" : "ruptura de tablet\/celular",
		"desc_en" : "Tablet\/cell phone breakage",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2804
	},
	{
		"eventoid" : 1047,
		"funcid" : 440,
		"desc_es" : "Sensor conectado",
		"desc_pt" : "Sensor conectado",
		"desc_en" : "Sensor connected",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2607
	},
	{
		"eventoid" : 1040,
		"funcid" : 283,
		"desc_es" : "Inicio de Control Crucero",
		"desc_pt" : "Início do Controle de Cruzeiro",
		"desc_en" : "Cruise Control Start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2600
	},
	{
		"eventoid" : 285,
		"funcid" : 73,
		"desc_es" : "Telemetria",
		"desc_pt" : "Telemetria",
		"desc_en" : "Telemetry",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 161
	},
	{
		"eventoid" : 168,
		"funcid" : 14,
		"desc_es" : "Apertura de puerta de cabina alerta",
		"desc_pt" : "Abertura de porta de motorista alerta",
		"desc_en" : "Cab door opening alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1139
	},
	{
		"eventoid" : 118,
		"funcid" : 84,
		"desc_es" : "Temperatura mínima camara 2",
		"desc_pt" : "Temperatura mínima câmara 2",
		"desc_en" : "Minimum temperature chamber 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 164
	},
	{
		"eventoid" : 319,
		"funcid" : 128,
		"desc_es" : "Reporte odómetro diario",
		"desc_pt" : "Relatório hodômetro diário",
		"desc_en" : "Report daily odometer",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 168
	},
	{
		"eventoid" : 207,
		"funcid" : 154,
		"desc_es" : "Exceso temperatura de motor",
		"desc_pt" : "Excesso de temperatura do motor",
		"desc_en" : "Engine temperature excess",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 144
	},
	{
		"eventoid" : 158,
		"funcid" : 119,
		"desc_es" : "Envío de posición",
		"desc_pt" : "Envio de posição",
		"desc_en" : "Location delivery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 170
	},
	{
		"eventoid" : 287,
		"funcid" : 224,
		"desc_es" : "Ok",
		"desc_pt" : "Ok",
		"desc_en" : "Ok",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 171
	},
	{
		"eventoid" : 774,
		"funcid" : 392,
		"desc_es" : "Reversión en movimiento",
		"desc_pt" : "Reversão em movimento",
		"desc_en" : "Reversal in movement",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2398
	},
	{
		"eventoid" : 29,
		"funcid" : 16,
		"desc_es" : "Temperatura normal camara 1",
		"desc_pt" : "Temperatura normal câmara 1",
		"desc_en" : "Normal temperature chamber 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 173
	},
	{
		"eventoid" : 336,
		"funcid" : 244,
		"desc_es" : "Desconexión sensor de combustible tanque 1",
		"desc_pt" : "Desconexão sensor de combustível tanque 1",
		"desc_en" : "Disconnection fuel sensor tank 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 158
	},
	{
		"eventoid" : 59,
		"funcid" : 26,
		"desc_es" : "Tercer eje arriba",
		"desc_pt" : "Terceiro eixo à cima",
		"desc_en" : "Third axis up",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 175
	},
	{
		"eventoid" : 312,
		"funcid" : 189,
		"desc_es" : "Trabe de plato",
		"desc_pt" : "Placa de bloqueio de liberação",
		"desc_en" : "Release locking plate",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 328
	},
	{
		"eventoid" : 313,
		"funcid" : 189,
		"desc_es" : "Destrabe de plato local",
		"desc_pt" : "Placa de liberação local desbloqueado",
		"desc_en" : "Local release plate unlocked",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 329
	},
	{
		"eventoid" : 314,
		"funcid" : 189,
		"desc_es" : "Destrabe de plato remoto",
		"desc_pt" : "Prato de liberação remota desbloqueado",
		"desc_en" : "Dish remote unlocked release",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 330
	},
	{
		"eventoid" : 756,
		"funcid" : 438,
		"desc_es" : "Curva Peligrosa",
		"desc_pt" : "Curva Perigosa",
		"desc_en" : "Dangerous Curve",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2378
	},
	{
		"eventoid" : 316,
		"funcid" : 10,
		"desc_es" : "Corte de combustible",
		"desc_pt" : "Corte de combustível",
		"desc_en" : "Fuel cut",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 332
	},
	{
		"eventoid" : 317,
		"funcid" : 10,
		"desc_es" : "Liberación de combustible",
		"desc_pt" : "Liberação de combustível",
		"desc_en" : "Fuel release",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 333
	},
	{
		"eventoid" : 322,
		"funcid" : 235,
		"desc_es" : "Reconexión de alimentación",
		"desc_pt" : "Reconexão de alimentação",
		"desc_en" : "Supply reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 334
	},
	{
		"eventoid" : 323,
		"funcid" : 235,
		"desc_es" : "Desconexión de alimentación",
		"desc_pt" : "Desconexão de alimentação",
		"desc_en" : "Supply disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 335
	},
	{
		"eventoid" : 632,
		"funcid" : 6,
		"desc_es" : "Robo confirmado",
		"desc_pt" : "Roubo confirmada",
		"desc_en" : "Confirmed theft",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2256
	},
	{
		"eventoid" : 633,
		"funcid" : 1,
		"desc_es" : "Alarma",
		"desc_pt" : "Alarme",
		"desc_en" : "Alarm",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2257
	},
	{
		"eventoid" : 1259,
		"funcid" : 423,
		"desc_es" : "Falla traba de caja",
		"desc_pt" : "Falla traba de caja",
		"desc_en" : "Falla traba de caja",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2787
	},
	{
		"eventoid" : 335,
		"funcid" : 244,
		"desc_es" : "Reporte sensor de combustible",
		"desc_pt" : "Reporte sensor de combustível",
		"desc_en" : "Report fuel sensor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 344
	},
	{
		"eventoid" : 338,
		"funcid" : 245,
		"desc_es" : "Aceleración brusca (ECU)",
		"desc_pt" : "Aceleração brusca (ECU)",
		"desc_en" : "Sudden acceleration (ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 346
	},
	{
		"eventoid" : 339,
		"funcid" : 246,
		"desc_es" : "Frenada brusca (ECU)",
		"desc_pt" : "Freada brusca (ECU)",
		"desc_en" : "Sudden Brake (ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 347
	},
	{
		"eventoid" : 340,
		"funcid" : 247,
		"desc_es" : "Motor ON (ECU)",
		"desc_pt" : "Motor ON (ECU)",
		"desc_en" : "Motor ON (ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 348
	},
	{
		"eventoid" : 341,
		"funcid" : 247,
		"desc_es" : "Motor OFF (ECU)",
		"desc_pt" : "Motor OFF (ECU)",
		"desc_en" : "Motor OFF (ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 349
	},
	{
		"eventoid" : 173,
		"funcid" : 24,
		"desc_es" : "Apertura de cisterna 7",
		"desc_pt" : "Abertura de cisterna 7",
		"desc_en" : "Tank 7 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 67
	},
	{
		"eventoid" : 337,
		"funcid" : 244,
		"desc_es" : "Reconexión sensor de combustible tanque 1",
		"desc_pt" : "Reconexão sensor de combustível tanque 1",
		"desc_en" : "Reconnection fuel sensor tank 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 345
	},
	{
		"eventoid" : 70,
		"funcid" : 52,
		"desc_es" : "Fuera de Ruta",
		"desc_pt" : "Fora de rota",
		"desc_en" : "Out of Route",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 2,
		"esalerta" : "0",
		"orden" : 166
	},
	{
		"eventoid" : 31,
		"funcid" : 16,
		"desc_es" : "Temperatura alta camara 2",
		"desc_pt" : "Temperatura alta câmara 2",
		"desc_en" : "High temperature chamber 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1900
	},
	{
		"eventoid" : 634,
		"funcid" : 127,
		"desc_es" : "Detección de inhibición celular",
		"desc_pt" : "Detenção de inibição de celular",
		"desc_en" : "Detection of cellular inhibition",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2258
	},
	{
		"eventoid" : 12,
		"funcid" : 6,
		"desc_es" : "Robo logueado",
		"desc_pt" : "Roubo armazenado",
		"desc_en" : "Logged theft",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1150
	},
	{
		"eventoid" : 216,
		"funcid" : 161,
		"desc_es" : "Tamper OFF",
		"desc_pt" : "Tamper OFF",
		"desc_en" : "Tamper OFF",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 155
	},
	{
		"eventoid" : 135,
		"funcid" : 96,
		"desc_es" : "Salida  de puerto",
		"desc_pt" : "Saída do porto",
		"desc_en" : "Departure from port",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1142
	},
	{
		"eventoid" : 630,
		"funcid" : 125,
		"desc_es" : "Inicio sesión",
		"desc_pt" : "Início de sessão",
		"desc_en" : "Login",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2254
	},
	{
		"eventoid" : 1369,
		"funcid" : 125,
		"desc_es" : "Circulación sin prueba de alcoholemia",
		"desc_pt" : "Movimento sem testar bafômetro",
		"desc_en" : "Driving without a breathalyzer test",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2894
	},
	{
		"eventoid" : 635,
		"funcid" : 393,
		"desc_es" : "Alerta de elevación en movimiento",
		"desc_pt" : "Alerta de elevação em movimento",
		"desc_en" : "Moving elevation alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2259
	},
	{
		"eventoid" : 636,
		"funcid" : 22,
		"desc_es" : "Desconexión de alimentación con vehículo encendido",
		"desc_pt" : "Desconexão de alimentação com veiculo ligado",
		"desc_en" : "Supply disconnection with vehicle on",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2260
	},
	{
		"eventoid" : 637,
		"funcid" : 231,
		"desc_es" : "Error de inicialización",
		"desc_pt" : "Erro de inicialização",
		"desc_en" : "Initialisation error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2261
	},
	{
		"eventoid" : 244,
		"funcid" : 193,
		"desc_es" : "Sensor de lluvia desactivado",
		"desc_pt" : "Sensor de chuva desativado",
		"desc_en" : "Rain sensor deactivated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 165
	},
	{
		"eventoid" : 320,
		"funcid" : 235,
		"desc_es" : "Comienzo de Carga",
		"desc_pt" : "Carregamento Início",
		"desc_en" : "Charge start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 157
	},
	{
		"eventoid" : 331,
		"funcid" : 241,
		"desc_es" : "Detenido sin contacto",
		"desc_pt" : "Detenido sin contacto",
		"desc_en" : "Stoped without contact",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 152
	},
	{
		"eventoid" : 332,
		"funcid" : 241,
		"desc_es" : "Detenido con contacto",
		"desc_pt" : "Detenido con contacto",
		"desc_en" : "Stoped with contact",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 342
	},
	{
		"eventoid" : 873,
		"funcid" : 261,
		"desc_es" : "Reporte faltante alarma (1mes)",
		"desc_pt" : "Reporte faltante alarma (1mes)",
		"desc_en" : "Missing report alarm (1mon)",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2261
	},
	{
		"eventoid" : 874,
		"funcid" : 261,
		"desc_es" : "Reporte faltante alarma (12hr)",
		"desc_pt" : "Reporte faltante alarma (12hr)",
		"desc_en" : "Missing report alarm (12hr)",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2262
	},
	{
		"eventoid" : 1057,
		"funcid" : 262,
		"desc_es" : "Fin de video Sensor1",
		"desc_pt" : "Fim do vídeo Sensor1",
		"desc_en" : "End of video Sensor1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2617
	},
	{
		"eventoid" : 1058,
		"funcid" : 262,
		"desc_es" : "Inicio de video Sensor2",
		"desc_pt" : "Vídeo iniciar Sensor2",
		"desc_en" : "Video start Sensor2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2618
	},
	{
		"eventoid" : 343,
		"funcid" : 249,
		"desc_es" : "RPM Máxima (ECU)",
		"desc_pt" : "RPM Máxima (ECU)",
		"desc_en" : "Maximum RPM (ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 351
	},
	{
		"eventoid" : 344,
		"funcid" : 250,
		"desc_es" : "Temperatura motor maxima (ECU)",
		"desc_pt" : "Temperatura máxima do motor (ECU)",
		"desc_en" : "Maximum engine temperature (ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 352
	},
	{
		"eventoid" : 345,
		"funcid" : 251,
		"desc_es" : "Inicio de sobrevelocidad (ECU)",
		"desc_pt" : "Início de excesso de velocidade (ECU)",
		"desc_en" : "Start of overspeed (ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 353
	},
	{
		"eventoid" : 346,
		"funcid" : 251,
		"desc_es" : "Fin de sobrevelocidad (ECU)",
		"desc_pt" : "Fim de excesso de velocidade (ECU)",
		"desc_en" : "End of overspeed (ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 354
	},
	{
		"eventoid" : 347,
		"funcid" : 253,
		"desc_es" : "Presión aceite deficiente (ECU)",
		"desc_pt" : "Baixa pressão de óleo (ECU)",
		"desc_en" : "Low oil pressure (ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 355
	},
	{
		"eventoid" : 348,
		"funcid" : 254,
		"desc_es" : "Detección agua en combustible (ECU)",
		"desc_pt" : "Detecção de água no combustível (ECU)",
		"desc_en" : "Detecting water in fuel (ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 356
	},
	{
		"eventoid" : 349,
		"funcid" : 252,
		"desc_es" : "Tensión batería baja (ECU)",
		"desc_pt" : "Baixa tensão da bateria (ECU)",
		"desc_en" : "Low battery voltage (ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 357
	},
	{
		"eventoid" : 1048,
		"funcid" : 262,
		"desc_es" : "Conexión MDVR",
		"desc_pt" : "Conexão MDVR",
		"desc_en" : "MDVR Connection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2608
	},
	{
		"eventoid" : 351,
		"funcid" : 233,
		"desc_es" : "Desconexión lector de huella",
		"desc_pt" : "Desconexão leitor de impressão digital",
		"desc_en" : "Disconnecting fingerprint reader",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 359
	},
	{
		"eventoid" : 1393,
		"funcid" : 290,
		"desc_es" : "Batería baja en sensor",
		"desc_pt" : "Bateria baixa no sensor",
		"desc_en" : "Low battery in sensor",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2918
	},
	{
		"eventoid" : 1392,
		"funcid" : 290,
		"desc_es" : "Reconexión de repetidor",
		"desc_pt" : "Reconexão do repetidor",
		"desc_en" : "Repeater reconnection",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2917
	},
	{
		"eventoid" : 352,
		"funcid" : 233,
		"desc_es" : "Reconexión lector de huella",
		"desc_pt" : "Reconexão leitor de impressão digital",
		"desc_en" : "Reconnection fingerprint reader",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 360
	},
	{
		"eventoid" : 353,
		"funcid" : 240,
		"desc_es" : "Descarga autorizada por BlueTooth",
		"desc_pt" : "Descarga autorizada por BlueTooth",
		"desc_en" : "Discharge authorized by BlueTooth",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 361
	},
	{
		"eventoid" : 354,
		"funcid" : 240,
		"desc_es" : "Descarga bloqueada por BlueTooth",
		"desc_pt" : "Descarga bloqueado por BlueTooth",
		"desc_en" : "Discharge blocked by BlueTooth",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 362
	},
	{
		"eventoid" : 355,
		"funcid" : 162,
		"desc_es" : "Cambio de estado",
		"desc_pt" : "Mudança de estado",
		"desc_en" : "State Change",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 363
	},
	{
		"eventoid" : 1049,
		"funcid" : 262,
		"desc_es" : "Desconexión MDVR",
		"desc_pt" : "Desconexão MDVR",
		"desc_en" : "MDVR Disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2609
	},
	{
		"eventoid" : 1050,
		"funcid" : 435,
		"desc_es" : "Conexión Traba Bóveda",
		"desc_pt" : "Conexão de bloqueio de cofre",
		"desc_en" : "Vault Lock Connection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2610
	},
	{
		"eventoid" : 1051,
		"funcid" : 435,
		"desc_es" : "Desconexión Traba Bóveda",
		"desc_pt" : "Desconexão de bloqueio de cofre",
		"desc_en" : "Vault Lock Disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2611
	},
	{
		"eventoid" : 643,
		"funcid" : 124,
		"desc_es" : "Desconexión Alimentación Terminal",
		"desc_pt" : "Desconexão Alimentação Terminal",
		"desc_en" : "Terminal power disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2266
	},
	{
		"eventoid" : 644,
		"funcid" : 124,
		"desc_es" : "Reconexión Alimentación Terminal",
		"desc_pt" : "Reconexão Alimentação Terminal",
		"desc_en" : "Terminal power reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2267
	},
	{
		"eventoid" : 645,
		"funcid" : 393,
		"desc_es" : "Alerta de Movimento com Garfo Alto",
		"desc_pt" : "Alerta de Movimento com Garfo Alto",
		"desc_en" : "Movement alert with high garfo",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2268
	},
	{
		"eventoid" : 342,
		"funcid" : 248,
		"desc_es" : "Tiempo ralenti excedido (ECU)",
		"desc_pt" : "Tempo ocioso ultrapassado (ECU)",
		"desc_en" : "Idle time exceeded (ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 350
	},
	{
		"eventoid" : 638,
		"funcid" : 423,
		"desc_es" : "Apertura caja recaudadora",
		"desc_pt" : "Abertura caixa coleta",
		"desc_en" : "Opening collecting box",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2261
	},
	{
		"eventoid" : 639,
		"funcid" : 423,
		"desc_es" : "Cierre caja recaudadora",
		"desc_pt" : "Encerramento caixa coleta",
		"desc_en" : "Closing collecting box",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2261
	},
	{
		"eventoid" : 778,
		"funcid" : 404,
		"desc_es" : "Reconexión de Válvula 2",
		"desc_pt" : "Reconexão de Válvula 2",
		"desc_en" : "Valve 2 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2401
	},
	{
		"eventoid" : 641,
		"funcid" : 425,
		"desc_es" : "Motor ON",
		"desc_pt" : "Motor ON",
		"desc_en" : "Motor ON",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2264
	},
	{
		"eventoid" : 642,
		"funcid" : 425,
		"desc_es" : "Motor OFF",
		"desc_pt" : "Motor OFF",
		"desc_en" : "Motor OFF",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2265
	},
	{
		"eventoid" : 646,
		"funcid" : 428,
		"desc_es" : "Inicio de Parcela",
		"desc_pt" : "Inicio de Talhão",
		"desc_en" : "Start of Parcel",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2269
	},
	{
		"eventoid" : 647,
		"funcid" : 428,
		"desc_es" : "Fin de Parcela",
		"desc_pt" : "Fim de Talhão",
		"desc_en" : "End of Parcel",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2270
	},
	{
		"eventoid" : 130,
		"funcid" : 91,
		"desc_es" : "Código de Barra",
		"desc_pt" : "Código de Barra",
		"desc_en" : "Bar Code",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1153
	},
	{
		"eventoid" : 265,
		"funcid" : 213,
		"desc_es" : "Perdida señal GPS",
		"desc_pt" : "Perda sinal GPS",
		"desc_en" : "Lost gps signal",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 292
	},
	{
		"eventoid" : 649,
		"funcid" : 393,
		"desc_es" : "Inicio de elevación",
		"desc_pt" : "Início de elevação",
		"desc_en" : "Elevation start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2272
	},
	{
		"eventoid" : 1052,
		"funcid" : 29,
		"desc_es" : "Actualización de viaje",
		"desc_pt" : "Atualização de viagem",
		"desc_en" : "Trip update",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2612
	},
	{
		"eventoid" : 729,
		"funcid" : 404,
		"desc_es" : "Cajón abierto",
		"desc_pt" : "Gaveta Aberto",
		"desc_en" : "Open Drawer",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2351
	},
	{
		"eventoid" : 730,
		"funcid" : 404,
		"desc_es" : "Cajón cerrado",
		"desc_pt" : "Gaveta Fechada",
		"desc_en" : "Closed Drawer",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2352
	},
	{
		"eventoid" : 653,
		"funcid" : 1,
		"desc_es" : "Test Satelital",
		"desc_pt" : "Test Satelital",
		"desc_en" : "Test Satelital",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2275
	},
	{
		"eventoid" : 654,
		"funcid" : 382,
		"desc_es" : "Peso",
		"desc_pt" : "Peso",
		"desc_en" : "Weight",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2276
	},
	{
		"eventoid" : 1101,
		"funcid" : 492,
		"desc_es" : "Desconexión accesorio CAN",
		"desc_pt" : "Desconexão de acessório CAN",
		"desc_en" : "CAN accessory disconnect",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2661
	},
	{
		"eventoid" : 1102,
		"funcid" : 492,
		"desc_es" : "Reconexión accesorio CAN",
		"desc_pt" : "Reconexão de acessório CAN",
		"desc_en" : "CAN accessory reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2662
	},
	{
		"eventoid" : 658,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Tapa 1",
		"desc_pt" : "(log) Abertura da cobertura 1",
		"desc_en" : "(log) Cover 1 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2280
	},
	{
		"eventoid" : 659,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Tapa 2",
		"desc_pt" : "(log) Abertura da cobertura 2",
		"desc_en" : "(log) Cover 2 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2281
	},
	{
		"eventoid" : 660,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Tapa 3",
		"desc_pt" : "(log) Abertura da cobertura 3",
		"desc_en" : "(log) Cover 3 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2282
	},
	{
		"eventoid" : 661,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Tapa 4",
		"desc_pt" : "(log) Abertura da cobertura 4",
		"desc_en" : "(log) Cover 4 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2283
	},
	{
		"eventoid" : 662,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Tapa 5",
		"desc_pt" : "(log) Abertura da cobertura 5",
		"desc_en" : "(log) Cover 5 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2284
	},
	{
		"eventoid" : 663,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Tapa 6",
		"desc_pt" : "(log) Abertura da cobertura 6",
		"desc_en" : "(log) Cover 6 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2285
	},
	{
		"eventoid" : 664,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Tapa 1",
		"desc_pt" : "(log) Fechada da cobertura 1",
		"desc_en" : "(log) Cover 1 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2286
	},
	{
		"eventoid" : 665,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Tapa 2",
		"desc_pt" : "(log) Fechada da cobertura 2",
		"desc_en" : "(log) Cover 2 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2287
	},
	{
		"eventoid" : 666,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Tapa 3",
		"desc_pt" : "(log) Fechada da cobertura 3",
		"desc_en" : "(log) Cover 3 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2288
	},
	{
		"eventoid" : 667,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Tapa 4",
		"desc_pt" : "(log) Fechada da cobertura 4",
		"desc_en" : "(log) Cover 4 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2289
	},
	{
		"eventoid" : 668,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Tapa 5",
		"desc_pt" : "(log) Fechada da cobertura 5",
		"desc_en" : "(log) Cover 5 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2290
	},
	{
		"eventoid" : 669,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Tapa 6",
		"desc_pt" : "(log) Fechada da cobertura 6",
		"desc_en" : "(log) Cover 6 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2291
	},
	{
		"eventoid" : 670,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Tapa 1",
		"desc_pt" : "(log) Falha sensor da cobertura 1",
		"desc_en" : "(log) Cover 1 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2292
	},
	{
		"eventoid" : 671,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Tapa 2",
		"desc_pt" : "(log) Falha sensor da cobertura 2",
		"desc_en" : "(log) Cover 2 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2293
	},
	{
		"eventoid" : 672,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Tapa 3",
		"desc_pt" : "(log) Falha sensor da cobertura 3",
		"desc_en" : "(log) Cover 3 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2294
	},
	{
		"eventoid" : 673,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Tapa 4",
		"desc_pt" : "(log) Falha sensor da cobertura 4",
		"desc_en" : "(log) Cover 4 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2295
	},
	{
		"eventoid" : 674,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Tapa 5",
		"desc_pt" : "(log) Falha sensor da cobertura 5",
		"desc_en" : "(log) Cover 5 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2296
	},
	{
		"eventoid" : 675,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Tapa 6",
		"desc_pt" : "(log) Falha sensor da cobertura 6",
		"desc_en" : "(log) Cover 6 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2297
	},
	{
		"eventoid" : 676,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión de Tapa 1",
		"desc_pt" : "(log) Desconexão da cobertura 1",
		"desc_en" : "(log) Cover 1 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2298
	},
	{
		"eventoid" : 677,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión de Tapa 2",
		"desc_pt" : "(log) Desconexão da cobertura 2",
		"desc_en" : "(log) Cover 2 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2299
	},
	{
		"eventoid" : 678,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión de Tapa 3",
		"desc_pt" : "(log) Desconexão da cobertura 3",
		"desc_en" : "(log) Cover 3 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2300
	},
	{
		"eventoid" : 679,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión de Tapa 4",
		"desc_pt" : "(log) Desconexão da cobertura 4",
		"desc_en" : "(log) Cover 4 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2301
	},
	{
		"eventoid" : 680,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión de Tapa 5",
		"desc_pt" : "(log) Desconexão da cobertura 5",
		"desc_en" : "(log) Cover 5 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2302
	},
	{
		"eventoid" : 650,
		"funcid" : 393,
		"desc_es" : "Fin de elevación",
		"desc_pt" : "Fim de elevação",
		"desc_en" : "Elevation end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2272
	},
	{
		"eventoid" : 1061,
		"funcid" : 262,
		"desc_es" : "Fin de video contacto off",
		"desc_pt" : "Fim do vídeo Sensor3",
		"desc_en" : "End of video Sensor3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2621
	},
	{
		"eventoid" : 681,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión de Tapa 6",
		"desc_pt" : "(log) Desconexão da cobertura 6",
		"desc_en" : "(log) Cover 6 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2303
	},
	{
		"eventoid" : 682,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Válvula 1",
		"desc_pt" : "(log) Abertura da válvula 1",
		"desc_en" : "(log) Valve 1 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2304
	},
	{
		"eventoid" : 683,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Válvula 2",
		"desc_pt" : "(log) Abertura da válvula 2",
		"desc_en" : "(log) Valve 2 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2305
	},
	{
		"eventoid" : 684,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Válvula 3",
		"desc_pt" : "(log) Abertura da válvula 3",
		"desc_en" : "(log) Valve 3 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2306
	},
	{
		"eventoid" : 685,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Válvula 4",
		"desc_pt" : "(log) Abertura da válvula 4",
		"desc_en" : "(log) Valve 4 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2307
	},
	{
		"eventoid" : 686,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Válvula 5",
		"desc_pt" : "(log) Abertura da válvula 5",
		"desc_en" : "(log) Valve 5 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2308
	},
	{
		"eventoid" : 687,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Válvula 6",
		"desc_pt" : "(log) Abertura da válvula 6",
		"desc_en" : "(log) Valve 6 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2309
	},
	{
		"eventoid" : 688,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Válvula 1",
		"desc_pt" : "(log) Válvula 1 fechada",
		"desc_en" : "(log) Valve 1 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2310
	},
	{
		"eventoid" : 689,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Válvula 2",
		"desc_pt" : "(log) Válvula 2 fechada",
		"desc_en" : "(log) Valve 2 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2311
	},
	{
		"eventoid" : 1347,
		"funcid" : 614,
		"desc_es" : "Lectura de TAG",
		"desc_pt" : "Leitura de TAG",
		"desc_en" : "TAG reading",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2872
	},
	{
		"eventoid" : 690,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Válvula 3",
		"desc_pt" : "(log) Válvula 3 fechada",
		"desc_en" : "(log) Valve 3 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2312
	},
	{
		"eventoid" : 691,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Válvula 4",
		"desc_pt" : "(log) Válvula 4 fechada",
		"desc_en" : "(log) Valve 4 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2313
	},
	{
		"eventoid" : 692,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Válvula 5",
		"desc_pt" : "(log) Válvula 5 fechada",
		"desc_en" : "(log) Valve 5 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2314
	},
	{
		"eventoid" : 693,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Válvula 6",
		"desc_pt" : "(log) Válvula 6 fechada",
		"desc_en" : "(log) Valve 6 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2315
	},
	{
		"eventoid" : 694,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Válvula 1",
		"desc_pt" : "(log) Falha sensor válvula 1",
		"desc_en" : "(log) Valve 1 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2316
	},
	{
		"eventoid" : 695,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Válvula 2",
		"desc_pt" : "(log) Falha sensor válvula 2",
		"desc_en" : "(log) Valve 2 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2317
	},
	{
		"eventoid" : 696,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Válvula 3",
		"desc_pt" : "(log) Falha sensor válvula 3",
		"desc_en" : "(log) Valve 3 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2318
	},
	{
		"eventoid" : 697,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Válvula 4",
		"desc_pt" : "(log) Falha sensor válvula 4",
		"desc_en" : "(log) Valve 4 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2319
	},
	{
		"eventoid" : 698,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Válvula 5",
		"desc_pt" : "(log) Falha sensor válvula 5",
		"desc_en" : "(log) Valve 5 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2320
	},
	{
		"eventoid" : 699,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Válvula 6",
		"desc_pt" : "(log) Falha sensor válvula 6",
		"desc_en" : "(log) Valve 6 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2321
	},
	{
		"eventoid" : 700,
		"funcid" : 404,
		"desc_es" : "(log) Desarme de Válvula 1",
		"desc_pt" : "(log) Desmontagem da válvula 1",
		"desc_en" : "(log) Valve 1 diasamble",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2322
	},
	{
		"eventoid" : 701,
		"funcid" : 404,
		"desc_es" : "(log) Desarme de Válvula 2",
		"desc_pt" : "(log) Desmontagem da válvula 2",
		"desc_en" : "(log) Valve 2 diasamble",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2323
	},
	{
		"eventoid" : 702,
		"funcid" : 404,
		"desc_es" : "(log) Desarme de Válvula 3",
		"desc_pt" : "(log) Desmontagem da válvula 3",
		"desc_en" : "(log) Valve 3 diasamble",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2324
	},
	{
		"eventoid" : 703,
		"funcid" : 404,
		"desc_es" : "(log) Desarme de Válvula 4",
		"desc_pt" : "(log) Desmontagem da válvula 4",
		"desc_en" : "(log) Valve 4 diasamble",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2325
	},
	{
		"eventoid" : 704,
		"funcid" : 404,
		"desc_es" : "(log) Desarme de Válvula 5",
		"desc_pt" : "(log) Desmontagem da válvula 5",
		"desc_en" : "(log) Valve 5 diasamble",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2326
	},
	{
		"eventoid" : 705,
		"funcid" : 404,
		"desc_es" : "(log) Desarme de Válvula 6",
		"desc_pt" : "(log) Desmontagem da válvula 6",
		"desc_en" : "(log) Valve 6 diasamble",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2327
	},
	{
		"eventoid" : 706,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión de Válvula 1",
		"desc_pt" : "(log) Desconexão da válvula 1",
		"desc_en" : "(log) Valve 1 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2328
	},
	{
		"eventoid" : 707,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión de Válvula 2",
		"desc_pt" : "(log) Desconexão da válvula 2",
		"desc_en" : "(log) Valve 2 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2329
	},
	{
		"eventoid" : 708,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión de Válvula 3",
		"desc_pt" : "(log) Desconexão da válvula 3",
		"desc_en" : "(log) Valve 3 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2330
	},
	{
		"eventoid" : 709,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión de Válvula 4",
		"desc_pt" : "(log) Desconexão da válvula 4",
		"desc_en" : "(log) Valve 4 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2331
	},
	{
		"eventoid" : 710,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión de Válvula 5",
		"desc_pt" : "(log) Desconexão da válvula 5",
		"desc_en" : "(log) Valve 5 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2332
	},
	{
		"eventoid" : 711,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión de Válvula 6",
		"desc_pt" : "(log) Desconexão da válvula 6",
		"desc_en" : "(log) Valve 6 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2333
	},
	{
		"eventoid" : 712,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Cajón de Válvulas 1",
		"desc_pt" : "(log) Abertura de gaveta da válvula 1",
		"desc_en" : "(log) Valve 1 box opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2334
	},
	{
		"eventoid" : 713,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Cajón de Válvulas 1",
		"desc_pt" : "(log) Fechada de gaveta da válvula 2",
		"desc_en" : "(log) Valve 1 box locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2335
	},
	{
		"eventoid" : 714,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Cajón de Válvulas 2",
		"desc_pt" : "(log) Abertura da gaveta do válvula 3",
		"desc_en" : "(log) Valve 2 box opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2336
	},
	{
		"eventoid" : 715,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Cajón de Válvulas 2",
		"desc_pt" : "(log) Fechada da gaveta do válvula 3",
		"desc_en" : "(log) Valve 2 box locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2337
	},
	{
		"eventoid" : 716,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Cajón de Válvulas 1",
		"desc_pt" : "(log) Falha sensor gaveta da válvula 1",
		"desc_en" : "(log) Valve 1 box sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2338
	},
	{
		"eventoid" : 717,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Cajón de Válvulas 2",
		"desc_pt" : "(log) Falha sensor gaveta da válvula 2",
		"desc_en" : "(log) Valve 2 box sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2339
	},
	{
		"eventoid" : 718,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión Sensor Cajón de Válvulas 1",
		"desc_pt" : "(log) Desconexão sensor de gaveta da válvula 1",
		"desc_en" : "(log) Valve 1 box sensor disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2340
	},
	{
		"eventoid" : 719,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión Sensor Cajón de Válvulas 2",
		"desc_pt" : "(log) Desconexão sensor de gaveta da válvula 2",
		"desc_en" : "(log) Valve 2 box sensor disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2341
	},
	{
		"eventoid" : 720,
		"funcid" : 404,
		"desc_es" : "(log) Código de Falla",
		"desc_pt" : "(log) Código de Falha",
		"desc_en" : "(log) Fault Code",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2342
	},
	{
		"eventoid" : 721,
		"funcid" : 404,
		"desc_es" : "(log) Reset Normal",
		"desc_pt" : "(log) Reset Normal",
		"desc_en" : "(log) Reset Normal",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2343
	},
	{
		"eventoid" : 722,
		"funcid" : 404,
		"desc_es" : "(log) Reset por Comando",
		"desc_pt" : "(log) Reset por Comando",
		"desc_en" : "(log) Command Reset",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2344
	},
	{
		"eventoid" : 723,
		"funcid" : 404,
		"desc_es" : "(log) Reset",
		"desc_pt" : "(log) Reset",
		"desc_en" : "(log) Reset",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2345
	},
	{
		"eventoid" : 725,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Gabinete",
		"desc_pt" : "(log) Fechada da Gabinete",
		"desc_en" : "(log) Cabinet Locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2347
	},
	{
		"eventoid" : 726,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión Alimentación de TSS",
		"desc_pt" : "(log) Desconexão Alimentação TSS",
		"desc_en" : "(log) TSS Power disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2348
	},
	{
		"eventoid" : 727,
		"funcid" : 404,
		"desc_es" : "(log) Batería Backup baja",
		"desc_pt" : "(log) Bateria de backup descarregada",
		"desc_en" : "(log) Low Backup Battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2349
	},
	{
		"eventoid" : 728,
		"funcid" : 404,
		"desc_es" : "(log) Error de inicialización",
		"desc_pt" : "(log) Erro de inicialização",
		"desc_en" : "(log) Initialisation error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2350
	},
	{
		"eventoid" : 1419,
		"funcid" : 670,
		"desc_es" : "Descanso en zona cumplido",
		"desc_pt" : "Descanso na zona cumprido",
		"desc_en" : "Rest in area completed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2944
	},
	{
		"eventoid" : 762,
		"funcid" : 440,
		"desc_es" : "Alarma de nivel máximo",
		"desc_pt" : "Alarme de nível máximo",
		"desc_en" : "Alarm of maximum level",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2384
	},
	{
		"eventoid" : 731,
		"funcid" : 404,
		"desc_es" : "Error en bus del sensor",
		"desc_pt" : "Sensor de erro de bus",
		"desc_en" : "Sensor bus error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2353
	},
	{
		"eventoid" : 732,
		"funcid" : 404,
		"desc_es" : "Tamper del sensor de trabajo abierto",
		"desc_pt" : "Trabalho sensor aberto adulteração",
		"desc_en" : "Tamper of open working sensor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2354
	},
	{
		"eventoid" : 733,
		"funcid" : 404,
		"desc_es" : "Tamper del sensor de trabajo cerrado",
		"desc_pt" : "Trabalho sensor fechada adulteração",
		"desc_en" : "Closed working sensor tamper",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2355
	},
	{
		"eventoid" : 734,
		"funcid" : 404,
		"desc_es" : "Tamper del sensor de referencia abierto",
		"desc_pt" : "Referência sensor de violação aberta",
		"desc_en" : "Open reference sensor tamper",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2356
	},
	{
		"eventoid" : 735,
		"funcid" : 404,
		"desc_es" : "Tamper del sensor de referencia cerrado",
		"desc_pt" : "Referência sensor de violação fechada",
		"desc_en" : "Closed reference sensor tamper",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2357
	},
	{
		"eventoid" : 736,
		"funcid" : 404,
		"desc_es" : "Reset por baja tensión",
		"desc_pt" : "Reset Baixa Tensão",
		"desc_en" : "Low Voltage Reset",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2358
	},
	{
		"eventoid" : 737,
		"funcid" : 404,
		"desc_es" : "Reset por watchdog-timer",
		"desc_pt" : "Reset por watchdog-timer",
		"desc_en" : "Reset por watchdog-timer",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2359
	},
	{
		"eventoid" : 738,
		"funcid" : 404,
		"desc_es" : "Reset por software",
		"desc_pt" : "Reset por software",
		"desc_en" : "Reset por software",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2360
	},
	{
		"eventoid" : 739,
		"funcid" : 404,
		"desc_es" : "Sensor calibrado",
		"desc_pt" : "Sensor calibração",
		"desc_en" : "Calibrated sensor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2361
	},
	{
		"eventoid" : 740,
		"funcid" : 404,
		"desc_es" : "Sensor no calibrado",
		"desc_pt" : "Sensor não calibrado",
		"desc_en" : "Sensor not Calibrated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2362
	},
	{
		"eventoid" : 741,
		"funcid" : 404,
		"desc_es" : "Configuración del sensor por defecto",
		"desc_pt" : "Sensor configurações padrão",
		"desc_en" : "Default Sensor Configuration",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2363
	},
	{
		"eventoid" : 742,
		"funcid" : 404,
		"desc_es" : "Serial de hardware del sensor no leido",
		"desc_pt" : "Série de Hardware do sensor não lê",
		"desc_en" : "Unread sensor hardware serial",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2364
	},
	{
		"eventoid" : 743,
		"funcid" : 404,
		"desc_es" : "Reconexión Sensor Cajón de Válvulas 1",
		"desc_pt" : "Reconexão sensor de gaveta da válvula 1",
		"desc_en" : "Valve 1 box sensor reconnect",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2365
	},
	{
		"eventoid" : 744,
		"funcid" : 404,
		"desc_es" : "(log) Cajón abierto",
		"desc_pt" : "(log) Gaveta Aberto",
		"desc_en" : "(log) Open Drawer",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2366
	},
	{
		"eventoid" : 745,
		"funcid" : 404,
		"desc_es" : "(log) Cajón cerrado",
		"desc_pt" : "(log) Gaveta Fechada",
		"desc_en" : "(log) Closed Drawer",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2367
	},
	{
		"eventoid" : 746,
		"funcid" : 404,
		"desc_es" : "(log) Tamper del sensor de trabajo abierto",
		"desc_pt" : "(log) Trabalho sensor aberto adulteração",
		"desc_en" : "(log) Tamper of open working sensor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2368
	},
	{
		"eventoid" : 747,
		"funcid" : 404,
		"desc_es" : "(log) Tamper del sensor de trabajo cerrado",
		"desc_pt" : "(log) Trabalho sensor fechada adulteração",
		"desc_en" : "(log) Closed working sensor tamper",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2369
	},
	{
		"eventoid" : 748,
		"funcid" : 404,
		"desc_es" : "(log) Tamper del sensor de referencia abierto",
		"desc_pt" : "(log) Referência sensor de violação aberta",
		"desc_en" : "(log) Open reference sensor tamper",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2370
	},
	{
		"eventoid" : 749,
		"funcid" : 404,
		"desc_es" : "(log) Tamper del sensor de referencia cerrado",
		"desc_pt" : "(log) Referência sensor de violação fechada",
		"desc_en" : "(log) Closed reference sensor tamper",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2371
	},
	{
		"eventoid" : 750,
		"funcid" : 404,
		"desc_es" : "(log) Batería baja",
		"desc_pt" : "(log) Bateria descarregada",
		"desc_en" : "(log) Low Battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2372
	},
	{
		"eventoid" : 546,
		"funcid" : 216,
		"desc_es" : "Incumplimiento de horario de llegada",
		"desc_pt" : "Violação de horário de chegada",
		"desc_en" : "Not complied arrival time",
		"eventotablaid" : 3,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1301
	},
	{
		"eventoid" : 924,
		"funcid" : 404,
		"desc_es" : "Desconexión de Válvula 7",
		"desc_pt" : "Desconexão da válvula 7",
		"desc_en" : "Valve 7 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2495
	},
	{
		"eventoid" : 755,
		"funcid" : 244,
		"desc_es" : "Presencia de agua en combustible",
		"desc_pt" : "Detecção de água no combustível",
		"desc_en" : "Detecting water in fuel",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2377
	},
	{
		"eventoid" : 757,
		"funcid" : 438,
		"desc_es" : "Frenada y Curva Peligrosa",
		"desc_pt" : "Frenagem e Curva Perigosa",
		"desc_en" : "Braking and Dangerous Curve",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2379
	},
	{
		"eventoid" : 758,
		"funcid" : 438,
		"desc_es" : "Aceleración y Curva Peligrosa",
		"desc_pt" : "Aceleração e Curva Perigosa",
		"desc_en" : "Acceleration and Dangerous Curve",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2380
	},
	{
		"eventoid" : 759,
		"funcid" : 438,
		"desc_es" : "Conducción Peligrosa",
		"desc_pt" : "Condução Perigosa",
		"desc_en" : "Driving Hazardous",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2381
	},
	{
		"eventoid" : 760,
		"funcid" : 283,
		"desc_es" : "Alerta de Conducción",
		"desc_pt" : "Alerta de Condução",
		"desc_en" : "Driving Alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2382
	},
	{
		"eventoid" : 1059,
		"funcid" : 262,
		"desc_es" : "Fin de video Sensor2",
		"desc_pt" : "Fim do vídeo Sensor2",
		"desc_en" : "End of video Sensor2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2619
	},
	{
		"eventoid" : 877,
		"funcid" : 435,
		"desc_es" : "Cierre Puerta de Bóveda",
		"desc_pt" : "Cierre Puerta de Bóveda",
		"desc_en" : "Vault door locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2265
	},
	{
		"eventoid" : 764,
		"funcid" : 440,
		"desc_es" : "Alarma variación de nivel",
		"desc_pt" : "Variação do nível de alarme",
		"desc_en" : "Alarm level variation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2386
	},
	{
		"eventoid" : 763,
		"funcid" : 440,
		"desc_es" : "Alarma de nivel mínimo",
		"desc_pt" : "Alarme de nível mínimo",
		"desc_en" : "Alarm of minimum level",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2385
	},
	{
		"eventoid" : 765,
		"funcid" : 440,
		"desc_es" : "Alarma de nivel mínimo",
		"desc_pt" : "Alarme de nível mínimo",
		"desc_en" : "Alarm of minimum level",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2387
	},
	{
		"eventoid" : 767,
		"funcid" : 290,
		"desc_es" : "Cambio de Marcha",
		"desc_pt" : "Troca de Marcha",
		"desc_en" : "Change of March",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2389
	},
	{
		"eventoid" : 1105,
		"funcid" : 404,
		"desc_es" : "Apertura de Tapa 8",
		"desc_pt" : "Abertura da cobertura 8",
		"desc_en" : "Cover 8 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2663
	},
	{
		"eventoid" : 1064,
		"funcid" : 262,
		"desc_es" : "Excepción de almacenamiento",
		"desc_pt" : "Exceção de armazenamento",
		"desc_en" : "Excepción de almacenamiento",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2624
	},
	{
		"eventoid" : 1065,
		"funcid" : 262,
		"desc_es" : "Grabación vehículo detenido",
		"desc_pt" : "Gravar veículo parado",
		"desc_en" : "Recording stopped vehicle",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2625
	},
	{
		"eventoid" : 752,
		"funcid" : 392,
		"desc_es" : "Tiempo de tracción con carga",
		"desc_pt" : "Tempo movimentação com carga",
		"desc_en" : "Traction time with load",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2374
	},
	{
		"eventoid" : 20,
		"funcid" : 14,
		"desc_es" : "Cierre de puerta de cabina",
		"desc_pt" : "Fechamento de porta de motorista",
		"desc_en" : "Cab door locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 15
	},
	{
		"eventoid" : 881,
		"funcid" : 439,
		"desc_es" : "AV 3.0 Configuracion a Esclavo Exitosa",
		"desc_pt" : "AV 3.0 Configurações Do Escravo Bem sucedido",
		"desc_en" : "AV 3.0 Successful Slave Configuration",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2391
	},
	{
		"eventoid" : 880,
		"funcid" : 439,
		"desc_es" : "AV 3.0 Master Modo Programación",
		"desc_pt" : "AV 3.0 Modo de Programação Master",
		"desc_en" : "AV 3.0 Master Programming Mode",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2390
	},
	{
		"eventoid" : 779,
		"funcid" : 404,
		"desc_es" : "Reconexión de Válvula 3",
		"desc_pt" : "Reconexão de Válvula 3",
		"desc_en" : "Valve 3 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2402
	},
	{
		"eventoid" : 780,
		"funcid" : 404,
		"desc_es" : "Reconexión de Válvula 4",
		"desc_pt" : "Reconexão de Válvula 4",
		"desc_en" : "Valve 4 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2403
	},
	{
		"eventoid" : 768,
		"funcid" : 439,
		"desc_es" : "AV 3.0 Esclavo Desactivado",
		"desc_pt" : "AV 3.0 Escravo Desativado",
		"desc_en" : "AV 3.0 Slave Disabled",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2392
	},
	{
		"eventoid" : 1406,
		"funcid" : 127,
		"desc_es" : "Detección de inhibición celular 4G",
		"desc_pt" : "Detecção de inibição de celular 4G",
		"desc_en" : "Detection of cellular inhibition 4G",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2931
	},
	{
		"eventoid" : 890,
		"funcid" : 3,
		"desc_es" : "Reporte en movimiento",
		"desc_pt" : "Reporte en Movemento",
		"desc_en" : "Motion report",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1
	},
	{
		"eventoid" : 769,
		"funcid" : 439,
		"desc_es" : "AV 3.0 Master Desactivado",
		"desc_pt" : "AV 3.0 Master Desativado",
		"desc_en" : "AV 3.0 Master Disabled",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2393
	},
	{
		"eventoid" : 775,
		"funcid" : 441,
		"desc_es" : "Impresión de balanza",
		"desc_pt" : "Impressão em escala",
		"desc_en" : "Balance printing",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2398
	},
	{
		"eventoid" : 781,
		"funcid" : 404,
		"desc_es" : "Reconexión de Válvula 5",
		"desc_pt" : "Reconexão de Válvula 5",
		"desc_en" : "Valve 5 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2404
	},
	{
		"eventoid" : 782,
		"funcid" : 404,
		"desc_es" : "Reconexión de Válvula 6",
		"desc_pt" : "Reconexão de Válvula 6",
		"desc_en" : "Valve 6 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2405
	},
	{
		"eventoid" : 783,
		"funcid" : 404,
		"desc_es" : "Reconexión de Tapa 1",
		"desc_pt" : "Reconexão de Cobertura 1",
		"desc_en" : "Cover 1 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2406
	},
	{
		"eventoid" : 784,
		"funcid" : 404,
		"desc_es" : "Reconexión de Tapa 2",
		"desc_pt" : "Reconexão de Cobertura 2",
		"desc_en" : "Cover 2 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2407
	},
	{
		"eventoid" : 785,
		"funcid" : 404,
		"desc_es" : "Reconexión de Tapa 3",
		"desc_pt" : "Reconexão de Cobertura 3",
		"desc_en" : "Cover 3 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2408
	},
	{
		"eventoid" : 786,
		"funcid" : 404,
		"desc_es" : "Reconexión de Tapa 4",
		"desc_pt" : "Reconexão de Cobertura 4",
		"desc_en" : "Cover 4 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2409
	},
	{
		"eventoid" : 787,
		"funcid" : 404,
		"desc_es" : "Reconexión de Tapa 5",
		"desc_pt" : "Reconexão de Cobertura 5",
		"desc_en" : "Cover 5 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2410
	},
	{
		"eventoid" : 788,
		"funcid" : 404,
		"desc_es" : "Reconexión de Tapa 6",
		"desc_pt" : "Reconexão de Cobertura 6",
		"desc_en" : "Cover 6 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2411
	},
	{
		"eventoid" : 789,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Valvula 1",
		"desc_pt" : "Erro Comunicação de Válvula 1",
		"desc_en" : "Valve 1 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2412
	},
	{
		"eventoid" : 790,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Valvula 2",
		"desc_pt" : "Erro Comunicação de Válvula 2",
		"desc_en" : "Valve 2 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2413
	},
	{
		"eventoid" : 791,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Valvula 3",
		"desc_pt" : "Erro Comunicação de Válvula 3",
		"desc_en" : "Valve 3 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2414
	},
	{
		"eventoid" : 751,
		"funcid" : 216,
		"desc_es" : "Incumplimiento de horario de salida",
		"desc_pt" : "Violação de horário de partida",
		"desc_en" : "Not complied departure time",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2373
	},
	{
		"eventoid" : 237,
		"funcid" : 187,
		"desc_es" : "Apertura de puerta de chofer",
		"desc_pt" : "Abertura porta de motorista",
		"desc_en" : "Driver door opening",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 172
	},
	{
		"eventoid" : 384,
		"funcid" : 275,
		"desc_es" : "Desconexión acelerómetro",
		"desc_pt" : "Acelerômetro Desconectado",
		"desc_en" : "Accelerometer disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 418
	},
	{
		"eventoid" : 409,
		"funcid" : 284,
		"desc_es" : "Velocidad Reducida",
		"desc_pt" : "Velocidade Reduzida",
		"desc_en" : "Reduced speed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 443
	},
	{
		"eventoid" : 651,
		"funcid" : 439,
		"desc_es" : "AV 3.0 Vehículo Bloqueado Motor ON",
		"desc_pt" : "AV 3.0 Vehículo Bloqueado Motor ON",
		"desc_en" : "AV 3.0 locked motor ON",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2273
	},
	{
		"eventoid" : 878,
		"funcid" : 436,
		"desc_es" : "Apertura Puerta de Mensajería",
		"desc_pt" : "Apertura Puerta de Mensajería",
		"desc_en" : "Message door opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2266
	},
	{
		"eventoid" : 879,
		"funcid" : 436,
		"desc_es" : "Cierre Puerta de Mensajería",
		"desc_pt" : "Cierre Puerta de Mensajería",
		"desc_en" : "Message door locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2267
	},
	{
		"eventoid" : 792,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Valvula 4",
		"desc_pt" : "Erro Comunicação de Válvula 4",
		"desc_en" : "Valve 4 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2415
	},
	{
		"eventoid" : 793,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Valvula 5",
		"desc_pt" : "Erro Comunicação de Válvula 5",
		"desc_en" : "Valve 5 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2416
	},
	{
		"eventoid" : 794,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Valvula 6",
		"desc_pt" : "Erro Comunicação de Válvula 6",
		"desc_en" : "Valve 6 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2417
	},
	{
		"eventoid" : 795,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Tapa 1",
		"desc_pt" : "Erro Comunicação de Cobertura 1",
		"desc_en" : "Cover 1 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2418
	},
	{
		"eventoid" : 796,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Tapa 2",
		"desc_pt" : "Erro Comunicação de Cobertura 2",
		"desc_en" : "Cover 2 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2419
	},
	{
		"eventoid" : 797,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Tapa 3",
		"desc_pt" : "Erro Comunicação de Cobertura 3",
		"desc_en" : "Cover 3 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2420
	},
	{
		"eventoid" : 798,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Tapa 4",
		"desc_pt" : "Erro Comunicação de Cobertura 4",
		"desc_en" : "Cover 4 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2421
	},
	{
		"eventoid" : 799,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Tapa 5",
		"desc_pt" : "Erro Comunicação de Cobertura 5",
		"desc_en" : "Cover 5 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2422
	},
	{
		"eventoid" : 800,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Tapa 6",
		"desc_pt" : "Erro Comunicação de Cobertura 6",
		"desc_en" : "Cover 6 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2423
	},
	{
		"eventoid" : 801,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Válvula 1",
		"desc_pt" : "(log) Reconexão de Válvula 1",
		"desc_en" : "(log) Valve 1 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2424
	},
	{
		"eventoid" : 802,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Válvula 2",
		"desc_pt" : "(log) Reconexão de Válvula 2",
		"desc_en" : "(log) Valve 2 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2425
	},
	{
		"eventoid" : 803,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Válvula 3",
		"desc_pt" : "(log) Reconexão de Válvula 3",
		"desc_en" : "(log) Valve 3 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2426
	},
	{
		"eventoid" : 804,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Válvula 4",
		"desc_pt" : "(log) Reconexão de Válvula 4",
		"desc_en" : "(log) Valve 4 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2427
	},
	{
		"eventoid" : 805,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Válvula 5",
		"desc_pt" : "(log) Reconexão de Válvula 5",
		"desc_en" : "(log) Valve 5 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2428
	},
	{
		"eventoid" : 806,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Válvula 6",
		"desc_pt" : "(log) Reconexão de Válvula 6",
		"desc_en" : "(log) Valve 6 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2429
	},
	{
		"eventoid" : 807,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Tapa 1",
		"desc_pt" : "(log) Reconexão de Cobertura 1",
		"desc_en" : "(log) Cover 1 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2430
	},
	{
		"eventoid" : 808,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Tapa 2",
		"desc_pt" : "(log) Reconexão de Cobertura 2",
		"desc_en" : "(log) Cover 2 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2431
	},
	{
		"eventoid" : 809,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Tapa 3",
		"desc_pt" : "(log) Reconexão de Cobertura 3",
		"desc_en" : "(log) Cover 3 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2432
	},
	{
		"eventoid" : 810,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Tapa 4",
		"desc_pt" : "(log) Reconexão de Cobertura 4",
		"desc_en" : "(log) Cover 4 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2433
	},
	{
		"eventoid" : 811,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Tapa 5",
		"desc_pt" : "(log) Reconexão de Cobertura 5",
		"desc_en" : "(log) Cover 5 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2434
	},
	{
		"eventoid" : 812,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Tapa 6",
		"desc_pt" : "(log) Reconexão de Cobertura 6",
		"desc_en" : "(log) Cover 6 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2435
	},
	{
		"eventoid" : 813,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Valvula 1",
		"desc_pt" : "(log) Erro Comunicação de Válvula 1",
		"desc_en" : "(log) Valve 1 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2436
	},
	{
		"eventoid" : 814,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Valvula 2",
		"desc_pt" : "(log) Erro Comunicação de Válvula 2",
		"desc_en" : "(log) Valve 2 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2437
	},
	{
		"eventoid" : 815,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Valvula 3",
		"desc_pt" : "(log) Erro Comunicação de Válvula 3",
		"desc_en" : "(log) Valve 3 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2438
	},
	{
		"eventoid" : 816,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Valvula 4",
		"desc_pt" : "(log) Erro Comunicação de Válvula 4",
		"desc_en" : "(log) Valve 4 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2439
	},
	{
		"eventoid" : 817,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Valvula 5",
		"desc_pt" : "(log) Erro Comunicação de Válvula 5",
		"desc_en" : "(log) Valve 5 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2440
	},
	{
		"eventoid" : 818,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Valvula 6",
		"desc_pt" : "(log) Erro Comunicação de Válvula 6",
		"desc_en" : "(log) Valve 6 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2441
	},
	{
		"eventoid" : 819,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Tapa 1",
		"desc_pt" : "(log) Erro Comunicação de Cobertura 1",
		"desc_en" : "(log) Cover 1 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2442
	},
	{
		"eventoid" : 820,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Tapa 2",
		"desc_pt" : "(log) Erro Comunicação de Cobertura 2",
		"desc_en" : "(log) Cover 2 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2443
	},
	{
		"eventoid" : 821,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Tapa 3",
		"desc_pt" : "(log) Erro Comunicação de Cobertura 3",
		"desc_en" : "(log) Cover 3 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2444
	},
	{
		"eventoid" : 822,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Tapa 4",
		"desc_pt" : "(log) Erro Comunicação de Cobertura 4",
		"desc_en" : "(log) Cover 4 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2445
	},
	{
		"eventoid" : 823,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Tapa 5",
		"desc_pt" : "(log) Erro Comunicação de Cobertura 5",
		"desc_en" : "(log) Cover 5 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2446
	},
	{
		"eventoid" : 824,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Tapa 6",
		"desc_pt" : "(log) Erro Comunicação de Cobertura 6",
		"desc_en" : "(log) Cover 6 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2447
	},
	{
		"eventoid" : 825,
		"funcid" : 404,
		"desc_es" : "Apertura de Caja de Paso",
		"desc_pt" : "Abertura de Step Box",
		"desc_en" : "Opening of Step Box",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2448
	},
	{
		"eventoid" : 826,
		"funcid" : 404,
		"desc_es" : "Cierre de Caja de Paso",
		"desc_pt" : "Fechada de Step Box",
		"desc_en" : "Locking of Step Box",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2449
	},
	{
		"eventoid" : 827,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Caja de Paso",
		"desc_pt" : "(log) Abertura de Step Box",
		"desc_en" : "(log) Opening of Step Box",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2450
	},
	{
		"eventoid" : 828,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Caja de Paso",
		"desc_pt" : "(log) Fechada de Step Box",
		"desc_en" : "(log) Locking of Step Box",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2451
	},
	{
		"eventoid" : 829,
		"funcid" : 404,
		"desc_es" : "Reconexión de Cajón de Válvulas 1",
		"desc_pt" : "Reconexão de Gaveta da Válvula 1",
		"desc_en" : "Valve 1 Box Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2452
	},
	{
		"eventoid" : 830,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Cajón de Válvulas 1",
		"desc_pt" : "Erro Comunicação da Gaveta de Válvula 1",
		"desc_en" : "Valve 1 Box Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2453
	},
	{
		"eventoid" : 831,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Cajón de Válvulas 1",
		"desc_pt" : "(log) Reconexão de Gaveta da Válvula 1",
		"desc_en" : "(log) Valve 1 Box Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2454
	},
	{
		"eventoid" : 882,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Cajón de Válvulas 1",
		"desc_pt" : "(log) Erro Comunicação da Gaveta de Válvula 1",
		"desc_en" : "(log) Valve 1 Box Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2455
	},
	{
		"eventoid" : 883,
		"funcid" : 439,
		"desc_es" : "AV 3.0 Esclavo 2 Desactivado",
		"desc_pt" : "AV 3.0 Escravo 2 Desativado",
		"desc_en" : "AV 3.0 Slave 2 Disabled",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2456
	},
	{
		"eventoid" : 884,
		"funcid" : 439,
		"desc_es" : "AV 3.0 Esclavo 3 Desactivado",
		"desc_pt" : "AV 3.0 Escravo 3 Desativado",
		"desc_en" : "AV 3.0 Slave 3 Disabled",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2457
	},
	{
		"eventoid" : 885,
		"funcid" : 237,
		"desc_es" : "Activación de advertencias de salida de carril",
		"desc_pt" : "Ativação de avisos de saída de pista",
		"desc_en" : "Activation of lane departure warnings",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2458
	},
	{
		"eventoid" : 886,
		"funcid" : 237,
		"desc_es" : "Desactivación de advertencias de salida de carril",
		"desc_pt" : "Desativação de avisos de saída de pista",
		"desc_en" : "Deactivation of lane departure warnings",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2459
	},
	{
		"eventoid" : 1260,
		"funcid" : 363,
		"desc_es" : "Fatiga Nivel 2 Confirmación",
		"desc_pt" : "Fadiga Nível 2 Confirmação",
		"desc_en" : "Fatigue Level 2 Confirmation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2788
	},
	{
		"eventoid" : 1261,
		"funcid" : 404,
		"desc_es" : "Reconexión Sensor Cajón de Válvulas 2",
		"desc_pt" : "Reconexão sensor de gaveta da válvula 2",
		"desc_en" : "Valve 2 box sensor reconnect",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2789
	},
	{
		"eventoid" : 1407,
		"funcid" : 127,
		"desc_es" : "Detección de inhibición celular 5G",
		"desc_pt" : "Detecção de inibição de celular 5G",
		"desc_en" : "Detection of cellular inhibition 5G",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2932
	},
	{
		"eventoid" : 318,
		"funcid" : 10,
		"desc_es" : "Esperando por corte de combustible",
		"desc_pt" : "À espera de corte de combustível",
		"desc_en" : "Waiting for fuel cut",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 141
	},
	{
		"eventoid" : 1234,
		"funcid" : 503,
		"desc_es" : "Inicio de inclinación lateral de volquete",
		"desc_pt" : "Início de inclinação lateral basculante",
		"desc_en" : "Side tilt tipper start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2762
	},
	{
		"eventoid" : 892,
		"funcid" : 444,
		"desc_es" : "Fin de movimiento con volquete levantado",
		"desc_pt" : "Fim de movimento com báscula erguida",
		"desc_en" : "End of movement with raised tipper",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2464
	},
	{
		"eventoid" : 1236,
		"funcid" : 363,
		"desc_es" : "Fatiga Nivel 1",
		"desc_pt" : "Fadiga Nível 1",
		"desc_en" : "Fatigue Level 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2764
	},
	{
		"eventoid" : 894,
		"funcid" : 259,
		"desc_es" : "Desconexión sensor",
		"desc_pt" : "Desligue o sensor",
		"desc_en" : "Disconnect sensor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2466
	},
	{
		"eventoid" : 895,
		"funcid" : 290,
		"desc_es" : "Reporte memoria iCAN",
		"desc_pt" : "Reporte memória iCAN",
		"desc_en" : "Report memory iCAN",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2467
	},
	{
		"eventoid" : 896,
		"funcid" : 288,
		"desc_es" : "Memoria SD defectuosa",
		"desc_pt" : "Memória SD com defeito",
		"desc_en" : "SD memory defective",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2468
	},
	{
		"eventoid" : 897,
		"funcid" : 288,
		"desc_es" : "Memoria SD detectada",
		"desc_pt" : "Memória SD detectada",
		"desc_en" : "SD memory detected",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2469
	},
	{
		"eventoid" : 899,
		"funcid" : 288,
		"desc_es" : "Memoria SD con formato",
		"desc_pt" : "Memória SD com formato",
		"desc_en" : "SD memory with format",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2471
	},
	{
		"eventoid" : 901,
		"funcid" : 3,
		"desc_es" : "Colisión",
		"desc_pt" : "Colisão",
		"desc_en" : "Collision",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2473
	},
	{
		"eventoid" : 898,
		"funcid" : 288,
		"desc_es" : "Memoria SD sin formato",
		"desc_pt" : "Memória SD sem formato",
		"desc_en" : "SD Memory without format",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2470
	},
	{
		"eventoid" : 902,
		"funcid" : 3,
		"desc_es" : "Colisión con GPS Log",
		"desc_pt" : "Colisão com Log GPS",
		"desc_en" : "Collision with GPS Log",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2474
	},
	{
		"eventoid" : 900,
		"funcid" : 290,
		"desc_es" : "Alerta por conducción sin identificación de chofer",
		"desc_pt" : "Alerta de condução sem identificação do motorista",
		"desc_en" : "Driving alert without driver identification",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2472
	},
	{
		"eventoid" : 903,
		"funcid" : 290,
		"desc_es" : "Información porcentual de iCAN",
		"desc_pt" : "Informação percentual do iCAN",
		"desc_en" : "Percentage information of iCAN",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2475
	},
	{
		"eventoid" : 1066,
		"funcid" : 262,
		"desc_es" : "Fin grabación vehículo detenido",
		"desc_pt" : "Fim Gravar veículo parado",
		"desc_en" : "End of Recording stopped vehicle",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2626
	},
	{
		"eventoid" : 908,
		"funcid" : 448,
		"desc_es" : "Humedad máxima camara 1",
		"desc_pt" : "Humedad máxima câmara 1",
		"desc_en" : "Maximum Humidity chamber 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2480
	},
	{
		"eventoid" : 631,
		"funcid" : 125,
		"desc_es" : "Fin sesión",
		"desc_pt" : "Fim de sessão",
		"desc_en" : "Session end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2255
	},
	{
		"eventoid" : 904,
		"funcid" : 110,
		"desc_es" : "Fin de conducción en horario no permitido",
		"desc_pt" : "Fim de condução em horário não permitido",
		"desc_en" : "End driving during unauthorised hours",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2476
	},
	{
		"eventoid" : 905,
		"funcid" : 11,
		"desc_es" : "Desenganche de semirremolque 2",
		"desc_pt" : "Desengate de carreta 2",
		"desc_en" : "Semitrailer uncoupling 2",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2477
	},
	{
		"eventoid" : 906,
		"funcid" : 11,
		"desc_es" : "Enganche de semiremolque 2",
		"desc_pt" : "Engate de carreta 2",
		"desc_en" : "Semitrailer coupling 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2478
	},
	{
		"eventoid" : 909,
		"funcid" : 448,
		"desc_es" : "Humedad mínima camara 1",
		"desc_pt" : "Humedad mínima câmara 1",
		"desc_en" : "Minimum Humidity chamber 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2481
	},
	{
		"eventoid" : 910,
		"funcid" : 449,
		"desc_es" : "Humedad normal camara 2",
		"desc_pt" : "Humedad normal câmara 2",
		"desc_en" : "Normal Humidity chamber 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2482
	},
	{
		"eventoid" : 911,
		"funcid" : 449,
		"desc_es" : "Humedad máxima camara 2",
		"desc_pt" : "Humedad máxima câmara 2",
		"desc_en" : "Maximum Humidity chamber 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2483
	},
	{
		"eventoid" : 912,
		"funcid" : 449,
		"desc_es" : "Humedad mínima camara 2",
		"desc_pt" : "Humedad mínima câmara 2",
		"desc_en" : "Minimum Humidity chamber 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2484
	},
	{
		"eventoid" : 913,
		"funcid" : 3,
		"desc_es" : "Duración del evento",
		"desc_pt" : "Duração do evento",
		"desc_en" : "Event duration",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2485
	},
	{
		"eventoid" : 914,
		"funcid" : 452,
		"desc_es" : "Sabotaje (corte)",
		"desc_pt" : "Sabotagem (corte)",
		"desc_en" : "Sabotage (cut)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2486
	},
	{
		"eventoid" : 915,
		"funcid" : 452,
		"desc_es" : "Sabotaje (puenteo)",
		"desc_pt" : "Sabotagem (ponte)",
		"desc_en" : "Sabotage (bridging)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2487
	},
	{
		"eventoid" : 916,
		"funcid" : 452,
		"desc_es" : "Toma de Fuerza Activado",
		"desc_pt" : "Tomada de Força Ativada",
		"desc_en" : "Activated Force Take",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2488
	},
	{
		"eventoid" : 917,
		"funcid" : 452,
		"desc_es" : "Toma de Fuerza Desactivado",
		"desc_pt" : "Tomada de Força Desativado",
		"desc_en" : "Disabled Force Take",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2489
	},
	{
		"eventoid" : 918,
		"funcid" : 288,
		"desc_es" : "SD Inicializada",
		"desc_pt" : "SD Inicializada",
		"desc_en" : "SD Initialized",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2490
	},
	{
		"eventoid" : 919,
		"funcid" : 288,
		"desc_es" : "SD No Inicializada",
		"desc_pt" : "SD Não Inicializada",
		"desc_en" : "SD Not Initialized",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2491
	},
	{
		"eventoid" : 1067,
		"funcid" : 262,
		"desc_es" : "Inicio toma de fuerza",
		"desc_pt" : "Início da tomada de força",
		"desc_en" : "Power take-off start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2627
	},
	{
		"eventoid" : 419,
		"funcid" : 125,
		"desc_es" : "Chofer no registrado",
		"desc_pt" : "Motorista não cadastrado",
		"desc_en" : "Unregistered Driver",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 449
	},
	{
		"eventoid" : 420,
		"funcid" : 125,
		"desc_es" : "Identificación chofer erronea",
		"desc_pt" : "Erro na identificação do motorista",
		"desc_en" : "ID driver erroneous",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 450
	},
	{
		"eventoid" : 497,
		"funcid" : 125,
		"desc_es" : "Desconexión Buzzer",
		"desc_pt" : "Desligar buzzer",
		"desc_en" : "Disconnecting Buzzer",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 525
	},
	{
		"eventoid" : 925,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Válvula 7",
		"desc_pt" : "(log) Abertura da válvula 7",
		"desc_en" : "(log) Valve 7 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2496
	},
	{
		"eventoid" : 926,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Válvula 7",
		"desc_pt" : "(log) Válvula 7 fechada",
		"desc_en" : "(log) Valve 7 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2497
	},
	{
		"eventoid" : 927,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Válvula 7",
		"desc_pt" : "(log) Falha sensor válvula 7",
		"desc_en" : "(log) Valve 7 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2498
	},
	{
		"eventoid" : 928,
		"funcid" : 404,
		"desc_es" : "(log) Desarme de Válvula 7",
		"desc_pt" : "(log) Desmontagem da válvula 7",
		"desc_en" : "(log) Valve 7 diasamble",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2499
	},
	{
		"eventoid" : 929,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión de Válvula 7",
		"desc_pt" : "(log) Desconexão da válvula 7",
		"desc_en" : "(log) Valve 7 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2500
	},
	{
		"eventoid" : 930,
		"funcid" : 404,
		"desc_es" : "Reconexión de Válvula 7",
		"desc_pt" : "Reconexão de Válvula 7",
		"desc_en" : "Valve 7 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2501
	},
	{
		"eventoid" : 931,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Valvula 7",
		"desc_pt" : "Erro Comunicação de Válvula 7",
		"desc_en" : "Valve 7 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2502
	},
	{
		"eventoid" : 932,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Válvula 7",
		"desc_pt" : "(log) Reconexão de Válvula 7",
		"desc_en" : "(log) Valve 7 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2503
	},
	{
		"eventoid" : 933,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Valvula 7",
		"desc_pt" : "(log) Erro Comunicação de Válvula 7",
		"desc_en" : "(log) Valve 7 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2504
	},
	{
		"eventoid" : 946,
		"funcid" : 125,
		"desc_es" : "Identificación en movimiento",
		"desc_pt" : "Identificação em movimento",
		"desc_en" : "Identification in movement",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2517
	},
	{
		"eventoid" : 947,
		"funcid" : 314,
		"desc_es" : "Sobrevelocidad respecto a señal de tránsito detectada",
		"desc_pt" : "Excesso de velocidade em relação ao sinal de trânsito detectado",
		"desc_en" : "Overspeed with respect to traffic signal detected",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2518
	},
	{
		"eventoid" : 948,
		"funcid" : 454,
		"desc_es" : "Nivel de temperatura alta en batería",
		"desc_pt" : "Nível de Temperatura da Bateria Alto",
		"desc_en" : "High temperature level in battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2519
	},
	{
		"eventoid" : 949,
		"funcid" : 454,
		"desc_es" : "Nivel de temperatura baja en batería",
		"desc_pt" : "Nível de Temperatura da Bateria Baixo",
		"desc_en" : "Low temperature level in battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2520
	},
	{
		"eventoid" : 950,
		"funcid" : 455,
		"desc_es" : "Conexión con el cargador",
		"desc_pt" : "Conexão com o carregador",
		"desc_en" : "Connection with the charger",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2521
	},
	{
		"eventoid" : 951,
		"funcid" : 455,
		"desc_es" : "Desconexión con el cargador",
		"desc_pt" : "Desconexão com o carregador",
		"desc_en" : "Disconnection with the charger",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2522
	},
	{
		"eventoid" : 934,
		"funcid" : 404,
		"desc_es" : "Apertura de Tapa 7",
		"desc_pt" : "Abertura da cobertura 7",
		"desc_en" : "Cover 7 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2505
	},
	{
		"eventoid" : 935,
		"funcid" : 404,
		"desc_es" : "Cierre de Tapa 7",
		"desc_pt" : "Fechada da cobertura 7",
		"desc_en" : "Cover 7 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2506
	},
	{
		"eventoid" : 936,
		"funcid" : 404,
		"desc_es" : "Falla Sensor Tapa 7",
		"desc_pt" : "Falha sensor da cobertura 7",
		"desc_en" : "Cover 7 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2507
	},
	{
		"eventoid" : 937,
		"funcid" : 404,
		"desc_es" : "Desconexión de Tapa 7",
		"desc_pt" : "Desconexão da cobertura 7",
		"desc_en" : "Cover 7 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2508
	},
	{
		"eventoid" : 938,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de Tapa 7",
		"desc_pt" : "(log) Abertura da cobertura 7",
		"desc_en" : "(log) Cover 7 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2509
	},
	{
		"eventoid" : 939,
		"funcid" : 404,
		"desc_es" : "(log) Cierre de Tapa 7",
		"desc_pt" : "(log) Fechada da cobertura 7",
		"desc_en" : "(log) Cover 7 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2510
	},
	{
		"eventoid" : 940,
		"funcid" : 404,
		"desc_es" : "(log) Falla Sensor Tapa 7",
		"desc_pt" : "(log) Falha sensor da cobertura 7",
		"desc_en" : "(log) Cover 7 sensor failure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2511
	},
	{
		"eventoid" : 941,
		"funcid" : 404,
		"desc_es" : "(log) Desconexión de Tapa 7",
		"desc_pt" : "(log) Desconexão da cobertura 7",
		"desc_en" : "(log) Cover 7 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2512
	},
	{
		"eventoid" : 942,
		"funcid" : 404,
		"desc_es" : "Reconexión de Tapa 7",
		"desc_pt" : "Reconexão de Cobertura 7",
		"desc_en" : "Cover 7 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2513
	},
	{
		"eventoid" : 943,
		"funcid" : 404,
		"desc_es" : "Error de comunicación de Tapa 7",
		"desc_pt" : "Erro Comunicação de Cobertura 7",
		"desc_en" : "Cover 7 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2514
	},
	{
		"eventoid" : 944,
		"funcid" : 404,
		"desc_es" : "(log) Reconexión de Tapa 7",
		"desc_pt" : "(log) Reconexão de Cobertura 7",
		"desc_en" : "(log) Cover 7 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2515
	},
	{
		"eventoid" : 945,
		"funcid" : 404,
		"desc_es" : "(log) Error de comunicación de Tapa 7",
		"desc_pt" : "(log) Erro Comunicação de Cobertura 7",
		"desc_en" : "(log) Cover 7 Communication Error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2516
	},
	{
		"eventoid" : 952,
		"funcid" : 456,
		"desc_es" : "Nivel de batería crítica",
		"desc_pt" : "Nível de Bateria Critica",
		"desc_en" : "Critical Battery Level",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2523
	},
	{
		"eventoid" : 953,
		"funcid" : 456,
		"desc_es" : "Nivel de batería baja",
		"desc_pt" : "Nível de Bateria Baixa",
		"desc_en" : "Low battery level",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2524
	},
	{
		"eventoid" : 192,
		"funcid" : 34,
		"desc_es" : "Inicio de exceso tiempo de ralenti",
		"desc_pt" : "Início de excesso tempo ralenti",
		"desc_en" : "Ralenti time exceeded start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1249
	},
	{
		"eventoid" : 1068,
		"funcid" : 262,
		"desc_es" : "Fin toma de fuerza",
		"desc_pt" : "Fim da tomada de força",
		"desc_en" : "Power take-off end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2628
	},
	{
		"eventoid" : 7,
		"funcid" : 5,
		"desc_es" : "Fin de detenido",
		"desc_pt" : "Fim de parada",
		"desc_en" : "Stop end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 4
	},
	{
		"eventoid" : 8,
		"funcid" : 4,
		"desc_es" : "Inicio de sobrevelocidad",
		"desc_pt" : "Início de excesso de velocidade",
		"desc_en" : "Overspeed start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 18
	},
	{
		"eventoid" : 9,
		"funcid" : 4,
		"desc_es" : "Fin de sobrevelocidad",
		"desc_pt" : "Fim de excesso de velocidade",
		"desc_en" : "Overspeed end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 19
	},
	{
		"eventoid" : 10,
		"funcid" : 1,
		"desc_es" : "Desconexion de alimentación principal",
		"desc_pt" : "Destribuição automática",
		"desc_en" : "External power disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 180
	},
	{
		"eventoid" : 15,
		"funcid" : 13,
		"desc_es" : "Apertura de puerta de carga",
		"desc_pt" : "Abertura de porta de carga",
		"desc_en" : "Cargo door opening",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 52
	},
	{
		"eventoid" : 16,
		"funcid" : 13,
		"desc_es" : "Cierre de puerta de carga",
		"desc_pt" : "Fechamento de porta de carga",
		"desc_en" : "Cargo door locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 37
	},
	{
		"eventoid" : 17,
		"funcid" : 13,
		"desc_es" : "Apertura de puerta de carga evento",
		"desc_pt" : "Abertura de porta de carga evento",
		"desc_en" : "Cargo door opening event",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 48
	},
	{
		"eventoid" : 18,
		"funcid" : 13,
		"desc_es" : "Cierre de puerta de carga evento",
		"desc_pt" : "Fechamento de porta de carga evento",
		"desc_en" : "Cargo door locking event",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 181
	},
	{
		"eventoid" : 22,
		"funcid" : 14,
		"desc_es" : "Cierre de puerta de cabina evento",
		"desc_pt" : "Fechamento de porta de motorista evento",
		"desc_en" : "Cab door locking event",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 38
	},
	{
		"eventoid" : 37,
		"funcid" : 31,
		"desc_es" : "Inicio de actividad",
		"desc_pt" : "Início de atividade",
		"desc_en" : "Activity start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1007
	},
	{
		"eventoid" : 38,
		"funcid" : 31,
		"desc_es" : "Fin de actividad",
		"desc_pt" : "Fim de atividade",
		"desc_en" : "Activity end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1008
	},
	{
		"eventoid" : 64,
		"funcid" : 34,
		"desc_es" : "Inicio de exceso de RPM",
		"desc_pt" : "Início de excesso de RPM",
		"desc_en" : "RPM excess start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1189
	},
	{
		"eventoid" : 65,
		"funcid" : 34,
		"desc_es" : "Fin de exceso de RPM",
		"desc_pt" : "Fim de excesso de RPM",
		"desc_en" : "RPM excess end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1190
	},
	{
		"eventoid" : 75,
		"funcid" : 79,
		"desc_es" : "Entrada en zona",
		"desc_pt" : "Entrada em zona",
		"desc_en" : "Zone entry",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 53
	},
	{
		"eventoid" : 76,
		"funcid" : 79,
		"desc_es" : "Salida de zona",
		"desc_pt" : "Saída de zona",
		"desc_en" : "Zone exit",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 100
	},
	{
		"eventoid" : 98,
		"funcid" : 63,
		"desc_es" : "Error sensores hormigon",
		"desc_pt" : "Erro nos sensores de concreto",
		"desc_en" : "Concrete sensors error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1207
	},
	{
		"eventoid" : 99,
		"funcid" : 62,
		"desc_es" : "Inicio descarga de hormigón",
		"desc_pt" : "Início da descarga de concreto",
		"desc_en" : "Concrete unloading start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1208
	},
	{
		"eventoid" : 100,
		"funcid" : 62,
		"desc_es" : "Fin descarga de hormigón",
		"desc_pt" : "Fim descarga de concreto",
		"desc_en" : "Concrete unloading end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1114
	},
	{
		"eventoid" : 101,
		"funcid" : 63,
		"desc_es" : "Inicio mezcla de hormigón",
		"desc_pt" : "Início da mistura de concreto",
		"desc_en" : "Concrete mixing start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1209
	},
	{
		"eventoid" : 102,
		"funcid" : 63,
		"desc_es" : "Fin mezcla de hormigón",
		"desc_pt" : "Fim mistura de concreto",
		"desc_en" : "Concrete mixing end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1140
	},
	{
		"eventoid" : 105,
		"funcid" : 252,
		"desc_es" : "Tensión batería critica (ECU) ",
		"desc_pt" : "Critica tensão da bateria (ECU)",
		"desc_en" : "Battery voltage critical",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2250
	},
	{
		"eventoid" : 146,
		"funcid" : 106,
		"desc_es" : "Apertura de gabinete cuentalitros",
		"desc_pt" : "Abertura de gabinete de conta-litros",
		"desc_en" : "Fuel gauge cabinet opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1133
	},
	{
		"eventoid" : 149,
		"funcid" : 107,
		"desc_es" : "Solenoide Activado",
		"desc_pt" : "Solenoide ativada",
		"desc_en" : "Solenoid Activated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 96
	},
	{
		"eventoid" : 150,
		"funcid" : 107,
		"desc_es" : "Solenoide Desactivado",
		"desc_pt" : "Solenoide desativada",
		"desc_en" : "Solenoid Deactivated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 60
	},
	{
		"eventoid" : 152,
		"funcid" : 108,
		"desc_es" : "Tiempo de conducción continua excedido",
		"desc_pt" : "Tempo de direção contínua excedido",
		"desc_en" : "Continuous driving time exceeded",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 120
	},
	{
		"eventoid" : 153,
		"funcid" : 109,
		"desc_es" : "Tiempo de conducción diaria excedido",
		"desc_pt" : "Tempo de direção diária excedido",
		"desc_en" : "Daily driving time exceeded",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 154
	},
	{
		"eventoid" : 154,
		"funcid" : 110,
		"desc_es" : "Inicio de conducción en horario no permitido",
		"desc_pt" : "Início condução em horário não permitido",
		"desc_en" : "Not allowed driving time start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 145
	},
	{
		"eventoid" : 156,
		"funcid" : 113,
		"desc_es" : "Desconexion Antena GPS",
		"desc_pt" : "Desconexão Antena GPS",
		"desc_en" : "GPS antenna disconnection",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 12
	},
	{
		"eventoid" : 157,
		"funcid" : 113,
		"desc_es" : "Cortocircuito Antena GPS",
		"desc_pt" : "Cortocircuito Antena GPS",
		"desc_en" : "GPS antenna short circuit",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 49
	},
	{
		"eventoid" : 160,
		"funcid" : 118,
		"desc_es" : "Apertura de puerta de pasajero",
		"desc_pt" : "Abertura de porta de passageiro",
		"desc_en" : "Passenger door opening",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 136
	},
	{
		"eventoid" : 161,
		"funcid" : 118,
		"desc_es" : "Apertura de puerta de pasajero evento",
		"desc_pt" : "Abertura de porta de passageiro evento",
		"desc_en" : "Passenger door opening event",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 110
	},
	{
		"eventoid" : 162,
		"funcid" : 118,
		"desc_es" : "Cierre de puerta de pasajero",
		"desc_pt" : "Fechamento de porta de passageiro evento",
		"desc_en" : "Passenger door locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 101
	},
	{
		"eventoid" : 178,
		"funcid" : 52,
		"desc_es" : "Sobrevelocidad en Ruta",
		"desc_pt" : "Excesso de velocidade na rota",
		"desc_en" : "Route overspeed",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 2,
		"esalerta" : "0",
		"orden" : 241
	},
	{
		"eventoid" : 179,
		"funcid" : 70,
		"desc_es" : "Activación Central de Alarma alerta",
		"desc_pt" : "Central de alarme ativada alerta",
		"desc_en" : "Alarm central activation alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1242
	},
	{
		"eventoid" : 180,
		"funcid" : 117,
		"desc_es" : "Contacto ON alerta",
		"desc_pt" : "Contato ON alerta",
		"desc_en" : "Contact ON alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1147
	},
	{
		"eventoid" : 181,
		"funcid" : 117,
		"desc_es" : "Contacto OFF alerta",
		"desc_pt" : "Contato OFF alerta",
		"desc_en" : "Contact OFF alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1243
	},
	{
		"eventoid" : 182,
		"funcid" : 123,
		"desc_es" : "Exceso tiempo detenido con contacto alerta",
		"desc_pt" : "Excesso de tempo parado com ignição ON alerta",
		"desc_en" : "Stop time excess alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2162
	},
	{
		"eventoid" : 183,
		"funcid" : 123,
		"desc_es" : "Exceso tiempo detenido con contacto",
		"desc_pt" : "Excesso de tempo parado com ignição ON",
		"desc_en" : "Stop time excess",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1102
	},
	{
		"eventoid" : 184,
		"funcid" : 124,
		"desc_es" : "Desconexión terminal mensajería",
		"desc_pt" : "Desconexão terminal mensagem",
		"desc_en" : "Message terminal disconnection",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 47
	},
	{
		"eventoid" : 185,
		"funcid" : 124,
		"desc_es" : "Reconexión terminal mensajería",
		"desc_pt" : "Reconexão terminal de mensagem",
		"desc_en" : "Message terminal reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 26
	},
	{
		"eventoid" : 186,
		"funcid" : 79,
		"desc_es" : "Dentro de Zona de Riesgo alerta",
		"desc_pt" : "Dentro da zona de risco alerta",
		"desc_en" : "Withing risk zone alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1244
	},
	{
		"eventoid" : 187,
		"funcid" : 124,
		"desc_es" : "Desconexión terminal mensajería",
		"desc_pt" : "Desconexão terminal mensagem",
		"desc_en" : "Message terminal disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 245
	},
	{
		"eventoid" : 189,
		"funcid" : 4,
		"desc_es" : "Inicio de sobrevelocidad alerta",
		"desc_pt" : "Início de excesso de velocidade alerta",
		"desc_en" : "Overspeed start alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1246
	},
	{
		"eventoid" : 190,
		"funcid" : 34,
		"desc_es" : "Inicio de exceso de conducción",
		"desc_pt" : "Início de excesso de condução",
		"desc_en" : "Continuous driving exceeded start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1247
	},
	{
		"eventoid" : 191,
		"funcid" : 34,
		"desc_es" : "Fin de exceso de conducción",
		"desc_pt" : "Fim de excesso de condução",
		"desc_en" : "Continuous driving exceeded end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1248
	},
	{
		"eventoid" : 193,
		"funcid" : 34,
		"desc_es" : "Fin de exceso tiempo de ralenti",
		"desc_pt" : "Fim de excesso de tempo de ralenti",
		"desc_en" : "Ralenti time exceeded end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1250
	},
	{
		"eventoid" : 194,
		"funcid" : 125,
		"desc_es" : "Identificación chofer",
		"desc_pt" : "Identificação de motorista",
		"desc_en" : "Driver identification",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 42
	},
	{
		"eventoid" : 196,
		"funcid" : 127,
		"desc_es" : "Detección de inhibición celular Baja",
		"desc_pt" : "Detenção de inibição de celular baixa",
		"desc_en" : "Cell inhibition detection low",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 251
	},
	{
		"eventoid" : 197,
		"funcid" : 127,
		"desc_es" : "Detección de inhibición celular Media",
		"desc_pt" : "Detenção de inibição de celular média",
		"desc_en" : "Cell inhibition detection middle",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 252
	},
	{
		"eventoid" : 198,
		"funcid" : 127,
		"desc_es" : "Detección de inhibición celular Alta",
		"desc_pt" : "Detecçao de inibição de celular alta",
		"desc_en" : "Cell inhibition detection high",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 122
	},
	{
		"eventoid" : 202,
		"funcid" : 29,
		"desc_es" : "Fin de Viaje",
		"desc_pt" : "Fim de Viagem",
		"desc_en" : "Trip end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 255
	},
	{
		"eventoid" : 6,
		"funcid" : 5,
		"desc_es" : "Inicio de detenido",
		"desc_pt" : "Início de parada",
		"desc_en" : "Stop",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 3
	},
	{
		"eventoid" : 554,
		"funcid" : 392,
		"desc_es" : "Tiempo de tracción",
		"desc_pt" : "Tempo de movimentação",
		"desc_en" : "Traction time",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2181
	},
	{
		"eventoid" : 226,
		"funcid" : 167,
		"desc_es" : "Rendimiento periodico",
		"desc_pt" : "Desempenho periódico",
		"desc_en" : "Periodic performance",
		"eventotablaid" : 5,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1265
	},
	{
		"eventoid" : 228,
		"funcid" : 179,
		"desc_es" : "Desconexión DMR",
		"desc_pt" : "Desconexão DMR",
		"desc_en" : "DMR disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 266
	},
	{
		"eventoid" : 229,
		"funcid" : 179,
		"desc_es" : "Conexión DMR",
		"desc_pt" : "Conexão DMR",
		"desc_en" : "DMR connection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 267
	},
	{
		"eventoid" : 231,
		"funcid" : 181,
		"desc_es" : "Cerca de seguridad",
		"desc_pt" : "Cerca de segurança",
		"desc_en" : "Security fence",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 268
	},
	{
		"eventoid" : 233,
		"funcid" : 184,
		"desc_es" : "Entrada en zona PPA",
		"desc_pt" : "Entrada em zona PPA",
		"desc_en" : "PPA zone entry",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1269
	},
	{
		"eventoid" : 1069,
		"funcid" : 499,
		"desc_es" : "Apertura de Capot",
		"desc_pt" : "Abertura do capô",
		"desc_en" : "Hood Opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2629
	},
	{
		"eventoid" : 235,
		"funcid" : 184,
		"desc_es" : "Entrada en zona PEC",
		"desc_pt" : "Entrada em zona PEC",
		"desc_en" : "PEC zone entry",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1271
	},
	{
		"eventoid" : 236,
		"funcid" : 184,
		"desc_es" : "Salida de zona PEC",
		"desc_pt" : "Saída de zona PEC",
		"desc_en" : "PEC zone exit",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1272
	},
	{
		"eventoid" : 238,
		"funcid" : 187,
		"desc_es" : "Cierre de puerta de chofer",
		"desc_pt" : "Fechamento de porta de motorista",
		"desc_en" : "Driver door locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 55
	},
	{
		"eventoid" : 240,
		"funcid" : 187,
		"desc_es" : "Apertura de puerta de chofer alerta",
		"desc_pt" : "Abertura porta de porta motorista alerta",
		"desc_en" : "Driver door opening alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1273
	},
	{
		"eventoid" : 250,
		"funcid" : 204,
		"desc_es" : "AutoStart Activado",
		"desc_pt" : "AutoStart Ativado",
		"desc_en" : "Autostart activated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1277
	},
	{
		"eventoid" : 251,
		"funcid" : 205,
		"desc_es" : "Ignición Manual en RUN",
		"desc_pt" : "Igniçãp manual em RUN",
		"desc_en" : "Manual ignition RUN",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1278
	},
	{
		"eventoid" : 254,
		"funcid" : 206,
		"desc_es" : "Electroválvula de acelerador con tensión",
		"desc_pt" : "Eletroválvula de acelerador com tensão",
		"desc_en" : "Throttle solenoid valve with tension",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1281
	},
	{
		"eventoid" : 256,
		"funcid" : 208,
		"desc_es" : "Ventanilla Abierta",
		"desc_pt" : "Ventanilla Abierta",
		"desc_en" : "Hatch opened",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 283
	},
	{
		"eventoid" : 257,
		"funcid" : 208,
		"desc_es" : "Ventanilla Cerrada",
		"desc_pt" : "Ventanilla Cerrada",
		"desc_en" : "Hatch closed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 284
	},
	{
		"eventoid" : 258,
		"funcid" : 209,
		"desc_es" : "Barra de Válvulas Abiertas",
		"desc_pt" : "Barra de Válvulas Abiertas",
		"desc_en" : "Valve bar opened",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 285
	},
	{
		"eventoid" : 259,
		"funcid" : 209,
		"desc_es" : "Barra de Válvulas Cerrada",
		"desc_pt" : "Barra de Válvulas Cerrada",
		"desc_en" : "Valve bar closed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 286
	},
	{
		"eventoid" : 260,
		"funcid" : 91,
		"desc_es" : "Fin de Viaje",
		"desc_pt" : "Fim de Viagem",
		"desc_en" : "Trip end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1287
	},
	{
		"eventoid" : 266,
		"funcid" : 214,
		"desc_es" : "Antena Bloqueada",
		"desc_pt" : "Antena Bloqueada",
		"desc_en" : "Blocked antenna",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 293
	},
	{
		"eventoid" : 269,
		"funcid" : 216,
		"desc_es" : "Demora en base",
		"desc_pt" : "Demora en base",
		"desc_en" : "Base delay",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1294
	},
	{
		"eventoid" : 270,
		"funcid" : 216,
		"desc_es" : "Demora en retorno a base",
		"desc_pt" : "Demora en retorno a base",
		"desc_en" : "Base return delay",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1295
	},
	{
		"eventoid" : 271,
		"funcid" : 216,
		"desc_es" : "Demora en llegar a cliente",
		"desc_pt" : "Demora en llegar a cliente",
		"desc_en" : "Reaching client delay",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1296
	},
	{
		"eventoid" : 272,
		"funcid" : 216,
		"desc_es" : "Demora en partir de cliente",
		"desc_pt" : "Demora en partir de cliente",
		"desc_en" : "Exit from client delay",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1297
	},
	{
		"eventoid" : 273,
		"funcid" : 216,
		"desc_es" : "Secuencia incorrecta",
		"desc_pt" : "Secuencia incorrecta",
		"desc_en" : "Incorrect sequence",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1298
	},
	{
		"eventoid" : 274,
		"funcid" : 216,
		"desc_es" : "Detención no autorizada",
		"desc_pt" : "Detención no autorizada",
		"desc_en" : "Unauthorized detention",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1299
	},
	{
		"eventoid" : 276,
		"funcid" : 216,
		"desc_es" : "Descarga no autorizada",
		"desc_pt" : "Descarga no autorizada",
		"desc_en" : "Unauthorized download",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1301
	},
	{
		"eventoid" : 279,
		"funcid" : 216,
		"desc_es" : "Devolución incorrecta, sin visita a cliente",
		"desc_pt" : "Devolución incorrecta, sin visita a cliente",
		"desc_en" : "Incorrect return, no customer visit",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1304
	},
	{
		"eventoid" : 280,
		"funcid" : 216,
		"desc_es" : "Camión en Panne",
		"desc_pt" : "Camión en Panne",
		"desc_en" : "Truck in Panne",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1305
	},
	{
		"eventoid" : 282,
		"funcid" : 127,
		"desc_es" : "Fin de detección de inhibición celular",
		"desc_pt" : "Fin de detenção de inibição celular",
		"desc_en" : "Cell inhibition end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 126
	},
	{
		"eventoid" : 292,
		"funcid" : 225,
		"desc_es" : "Consumo zona",
		"desc_pt" : "Consumo zona",
		"desc_en" : "Zone consumption",
		"eventotablaid" : 5,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 312
	},
	{
		"eventoid" : 295,
		"funcid" : 184,
		"desc_es" : "Entrada en zona PPA",
		"desc_pt" : "Entrada em zona PPA",
		"desc_en" : "PPA zone entry",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1313
	},
	{
		"eventoid" : 296,
		"funcid" : 184,
		"desc_es" : "Salida de zona PPA",
		"desc_pt" : "Saída de zona PPA",
		"desc_en" : "PPA zone exit",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1314
	},
	{
		"eventoid" : 297,
		"funcid" : 184,
		"desc_es" : "Entrada en zona PEC",
		"desc_pt" : "Entrada em zona PEC",
		"desc_en" : "PEC zone entry",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1315
	},
	{
		"eventoid" : 298,
		"funcid" : 184,
		"desc_es" : "Salida de zona PEC",
		"desc_pt" : "Saída de zona PEC",
		"desc_en" : "PEC zone exit",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1316
	},
	{
		"eventoid" : 302,
		"funcid" : 184,
		"desc_es" : "Entrada en zona PPA",
		"desc_pt" : "Entrada em zona PPA",
		"desc_en" : "PPA zone entry",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1320
	},
	{
		"eventoid" : 303,
		"funcid" : 184,
		"desc_es" : "Salida de zona PPA",
		"desc_pt" : "Saída de zona PPA",
		"desc_en" : "PPA zone exit",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1321
	},
	{
		"eventoid" : 304,
		"funcid" : 184,
		"desc_es" : "Entrada en zona PEC",
		"desc_pt" : "Entrada em zona PEC",
		"desc_en" : "PEC zone entry",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1322
	},
	{
		"eventoid" : 305,
		"funcid" : 184,
		"desc_es" : "Salida de zona PEC",
		"desc_pt" : "Saída de zona PEC",
		"desc_en" : "PEC zone exit",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1323
	},
	{
		"eventoid" : 306,
		"funcid" : 160,
		"desc_es" : "Fuera de ruta evento",
		"desc_pt" : "Fora de rota alerta",
		"desc_en" : "Outside route event",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 324
	},
	{
		"eventoid" : 307,
		"funcid" : 160,
		"desc_es" : "Dentro de ruta evento",
		"desc_pt" : "Dentro de rota alerta",
		"desc_en" : "Inside route event",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 325
	},
	{
		"eventoid" : 308,
		"funcid" : 160,
		"desc_es" : "Cambio de sentido evento",
		"desc_pt" : "Mudança de sentido evento",
		"desc_en" : "Way change event",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 326
	},
	{
		"eventoid" : 311,
		"funcid" : 123,
		"desc_es" : "Fin exceso tiempo detenido con contacto",
		"desc_pt" : "Fim excesso de tempo parado com ignição ON",
		"desc_en" : "Stop time excess with contact end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1327
	},
	{
		"eventoid" : 334,
		"funcid" : 241,
		"desc_es" : "Movimiento con contacto",
		"desc_pt" : "Movimiento con contacto",
		"desc_en" : "Movement with contact",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 159
	},
	{
		"eventoid" : 350,
		"funcid" : 227,
		"desc_es" : "Reset Caudalímetro",
		"desc_pt" : "Reset Caudalímetro",
		"desc_en" : "Caudalimeter reset",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 358
	},
	{
		"eventoid" : 356,
		"funcid" : 255,
		"desc_es" : "Desconexión placa MOP",
		"desc_pt" : "Desconexión placa MOP",
		"desc_en" : "MOP board disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1364
	},
	{
		"eventoid" : 357,
		"funcid" : 256,
		"desc_es" : "Desconexión caudalímetro",
		"desc_pt" : "Desconexión caudalímetro",
		"desc_en" : "Caudalimeter disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1365
	},
	{
		"eventoid" : 358,
		"funcid" : 256,
		"desc_es" : "Reconexión caudalímetro",
		"desc_pt" : "Reconexión caudalímetro",
		"desc_en" : "Caudalimeter reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1366
	},
	{
		"eventoid" : 386,
		"funcid" : 274,
		"desc_es" : "Bloqueo celular y GPS",
		"desc_pt" : "Bloqueo celular y GPS",
		"desc_en" : "GPS and cellular signal blocked",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 420
	},
	{
		"eventoid" : 522,
		"funcid" : 249,
		"desc_es" : "Fin RPM",
		"desc_pt" : "Fin RPM",
		"desc_en" : "RPM end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 545
	},
	{
		"eventoid" : 549,
		"funcid" : 180,
		"desc_es" : "Remolque",
		"desc_pt" : "Remolque",
		"desc_en" : "Trailer",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 33
	},
	{
		"eventoid" : 652,
		"funcid" : 439,
		"desc_es" : "AV 3.0 Vehículo Bloqueado Motor OFF",
		"desc_pt" : "AV 3.0 Vehículo Bloqueado Motor OFF",
		"desc_en" : "AV 3.0 locked motor OFF",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2274
	},
	{
		"eventoid" : 655,
		"funcid" : 404,
		"desc_es" : "Alimentación Semi Normal",
		"desc_pt" : "Alimentação Semi Normal",
		"desc_en" : "Semitrailer power normal",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2277
	},
	{
		"eventoid" : 656,
		"funcid" : 404,
		"desc_es" : "Cortocircuito Alimentación Semi",
		"desc_pt" : "CurtoCircuito Alimentação Semi",
		"desc_en" : "Semitrailer power short circuit",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2278
	},
	{
		"eventoid" : 657,
		"funcid" : 404,
		"desc_es" : "Cortocircuito Comunicación Semi",
		"desc_pt" : "CurtoCircuito Comunicação Semi",
		"desc_en" : "Semitrailer comunication short circuit",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2279
	},
	{
		"eventoid" : 842,
		"funcid" : 186,
		"desc_es" : "Desconexión Garmin",
		"desc_pt" : "Desconexión Garmin",
		"desc_en" : "Garmin disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 399
	},
	{
		"eventoid" : 843,
		"funcid" : 186,
		"desc_es" : "Reconexión Garmin",
		"desc_pt" : "Reconexión Garmin",
		"desc_en" : "Garmin reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 400
	},
	{
		"eventoid" : 848,
		"funcid" : 70,
		"desc_es" : "Disparo de Alarma - Causa: Movimiento",
		"desc_pt" : "Disparo de Alarma - Causa: Movimiento",
		"desc_en" : "Alarm activated - cause: motion",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 405
	},
	{
		"eventoid" : 849,
		"funcid" : 70,
		"desc_es" : "Disparo de Alarma - Causa: Puertas",
		"desc_pt" : "Disparo de Alarma - Causa: Puertas",
		"desc_en" : "Alarm activated - cause: doors",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 406
	},
	{
		"eventoid" : 850,
		"funcid" : 70,
		"desc_es" : "Disparo de Alarma - Causa: Sabotaje",
		"desc_pt" : "Disparo de Alarma - Causa: Sabotaje",
		"desc_en" : "Alarm activated - cause: sabotage",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 407
	},
	{
		"eventoid" : 852,
		"funcid" : 271,
		"desc_es" : "Exceso de tiempo en zona de carga",
		"desc_pt" : "Exceso de tiempo en zona de carga",
		"desc_en" : "Time on loading area excess",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1409
	},
	{
		"eventoid" : 954,
		"funcid" : 458,
		"desc_es" : "Aviso Asistencia Medica",
		"desc_pt" : "Aviso Asistencia Medica",
		"desc_en" : "Medical assistance notice",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2525
	},
	{
		"eventoid" : 955,
		"funcid" : 457,
		"desc_es" : "Aviso Asistencia Mecánica",
		"desc_pt" : "Aviso Asistencia Mecánica",
		"desc_en" : "Mecanical assistance notice",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2526
	},
	{
		"eventoid" : 1070,
		"funcid" : 499,
		"desc_es" : "Cierre de Capot",
		"desc_pt" : "Fechamento do capô",
		"desc_en" : "Bonnet closure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2630
	},
	{
		"eventoid" : 1071,
		"funcid" : 25,
		"desc_es" : "Consumo detallado",
		"desc_pt" : "Consumo detalhado",
		"desc_en" : "Detailed consumption",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2631
	},
	{
		"eventoid" : 275,
		"funcid" : 216,
		"desc_es" : "Sobrevelocidad en viaje",
		"desc_pt" : "Excesso de velocidade em viagem",
		"desc_en" : "Trip overspeed",
		"eventotablaid" : 3,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1300
	},
	{
		"eventoid" : 1073,
		"funcid" : 4,
		"desc_es" : "Alarma tasa de combustible",
		"desc_pt" : "Taxa de combustível",
		"desc_en" : "Fuel rate alarm",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2633
	},
	{
		"eventoid" : 1074,
		"funcid" : 4,
		"desc_es" : "Alarma nivel de aceite",
		"desc_pt" : "Alarme RPMs",
		"desc_en" : "RPMs alarm",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2634
	},
	{
		"eventoid" : 1075,
		"funcid" : 4,
		"desc_es" : "Alarma presión de aceite",
		"desc_pt" : "Alarme pressão do aceite",
		"desc_en" : "Oil pressure alarm",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2635
	},
	{
		"eventoid" : 1076,
		"funcid" : 4,
		"desc_es" : "Alarma horómetro",
		"desc_pt" : "Alarme horometro",
		"desc_en" : "Hourmeter alarm",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2636
	},
	{
		"eventoid" : 1077,
		"funcid" : 4,
		"desc_es" : "Alarma temperatura",
		"desc_pt" : "Alarme temperatura",
		"desc_en" : "Temperature alarm",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2637
	},
	{
		"eventoid" : 1078,
		"funcid" : 4,
		"desc_es" : "Alarma torque",
		"desc_pt" : "Alarme torque",
		"desc_en" : "Torque alarm",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2638
	},
	{
		"eventoid" : 1079,
		"funcid" : 4,
		"desc_es" : "Alarma combustible usado",
		"desc_pt" : "Alarme combustível usado",
		"desc_en" : "Used fuel Alarm",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2639
	},
	{
		"eventoid" : 1080,
		"funcid" : 262,
		"desc_es" : "Inicio detección de obstáculo",
		"desc_pt" : "Início da detecção de obstáculo",
		"desc_en" : "Obstacle detection start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2640
	},
	{
		"eventoid" : 1081,
		"funcid" : 262,
		"desc_es" : "Fin detección de obstáculo",
		"desc_pt" : "Fim da detecção de obstáculo",
		"desc_en" : "Obstacle detection end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2641
	},
	{
		"eventoid" : 1082,
		"funcid" : 505,
		"desc_es" : "Cambio de ubicación",
		"desc_pt" : "Mudança de posição",
		"desc_en" : "Change of position",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2642
	},
	{
		"eventoid" : 1083,
		"funcid" : 505,
		"desc_es" : "Re centrado",
		"desc_pt" : "Re centrado",
		"desc_en" : "Re centering",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2643
	},
	{
		"eventoid" : 1084,
		"funcid" : 162,
		"desc_es" : "Estado no deseado",
		"desc_pt" : "Estado indesejado",
		"desc_en" : "Undesired state",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2644
	},
	{
		"eventoid" : 1087,
		"funcid" : 280,
		"desc_es" : "Tolva abajo",
		"desc_pt" : "Hopper para baixo",
		"desc_en" : "Hopper down",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2647
	},
	{
		"eventoid" : 1088,
		"funcid" : 280,
		"desc_es" : "Tolva desconocido",
		"desc_pt" : "Hopper desconhecido",
		"desc_en" : "Unknown hopper",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2648
	},
	{
		"eventoid" : 989,
		"funcid" : 280,
		"desc_es" : "Vida útil de freno\/Nivel de adblue",
		"desc_pt" : "Vida útil da geladeira\/Nível de adblue",
		"desc_en" : "Brake life\/Level of adblue",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2552
	},
	{
		"eventoid" : 1089,
		"funcid" : 80,
		"desc_es" : "Error de sensor",
		"desc_pt" : "Erro do sensor",
		"desc_en" : "Sensor error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2649
	},
	{
		"eventoid" : 983,
		"funcid" : 280,
		"desc_es" : "Baja vida útil de freno",
		"desc_pt" : "Baixa vida útil do freio",
		"desc_en" : "Low brake life",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2546
	},
	{
		"eventoid" : 1093,
		"funcid" : 280,
		"desc_es" : "Alerta conducción tolva levantada",
		"desc_pt" : "Alerta conducción tolva levantada",
		"desc_en" : "Hopper Raised Driving Alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2653
	},
	{
		"eventoid" : 1414,
		"funcid" : 660,
		"desc_es" : "Conexión WIFI",
		"desc_pt" : "Conexão WIFI",
		"desc_en" : "WIFI connected",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2939
	},
	{
		"eventoid" : 1094,
		"funcid" : 280,
		"desc_es" : "Fin alerta conducción tolva levantada",
		"desc_pt" : "Fin alerta conducción tolva levantada",
		"desc_en" : "Hopper Raised Driving Alert End",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2654
	},
	{
		"eventoid" : 1095,
		"funcid" : 265,
		"desc_es" : "Inicio de Operación",
		"desc_pt" : " Inicio de Operación",
		"desc_en" : "Start of Operation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2655
	},
	{
		"eventoid" : 1096,
		"funcid" : 265,
		"desc_es" : "Fin de Operación ",
		"desc_pt" : "Fin de Operación",
		"desc_en" : "End of Operation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2656
	},
	{
		"eventoid" : 1090,
		"funcid" : 115,
		"desc_es" : "Llegada centro asistencial",
		"desc_pt" : "Llegada centro asistencial",
		"desc_en" : "Healthcare center arrived",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2652
	},
	{
		"eventoid" : 1091,
		"funcid" : 115,
		"desc_es" : "Llegada lugar de emergencia",
		"desc_pt" : "Llegada lugar de emergencia",
		"desc_en" : "Emergency place arrived",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2652
	},
	{
		"eventoid" : 1092,
		"funcid" : 115,
		"desc_es" : "Salida lugar de emergencia",
		"desc_pt" : "Salida  lugar de emergencia",
		"desc_en" : "Emergency place departure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2652
	},
	{
		"eventoid" : 1106,
		"funcid" : 404,
		"desc_es" : "Cierre de Tapa 8",
		"desc_pt" : "Fechada da cobertura 8",
		"desc_en" : "Cover 8 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2664
	},
	{
		"eventoid" : 1097,
		"funcid" : 229,
		"desc_es" : "Exceso de velocidad por asistente de voz",
		"desc_pt" : "Excesso de velocidade por assistente de voz",
		"desc_en" : "Speeding by voice assistant",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2657
	},
	{
		"eventoid" : 1098,
		"funcid" : 108,
		"desc_es" : "Exceso de conducción continua por asistente de voz",
		"desc_pt" : "Overdriving contínuo pelo assistente de voz",
		"desc_en" : "Continuous overdriving by voice assistant",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2658
	},
	{
		"eventoid" : 1099,
		"funcid" : 109,
		"desc_es" : "Exceso de conducción diaria por asistente de voz",
		"desc_pt" : "Excesso diário de condução por assistente de voz",
		"desc_en" : "Daily excess driving by voice assistant",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2659
	},
	{
		"eventoid" : 1100,
		"funcid" : 110,
		"desc_es" : "Conducción fuera de horario por asistente de voz",
		"desc_pt" : "Dirigindo depois do expediente pelo assistente de voz",
		"desc_en" : "Driving after hours by voice assistant",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2660
	},
	{
		"eventoid" : 1231,
		"funcid" : 290,
		"desc_es" : "Tiempo de partículas",
		"desc_pt" : "Tempo de partícula",
		"desc_en" : "Particles time",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2759
	},
	{
		"eventoid" : 1060,
		"funcid" : 262,
		"desc_es" : "Inicio de video contacto on",
		"desc_pt" : "Vídeo iniciar Sensor3",
		"desc_en" : "Video start Sensor3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2620
	},
	{
		"eventoid" : 1151,
		"funcid" : 290,
		"desc_es" : "Desconexión de tablet",
		"desc_pt" : "Desconexão de tablet",
		"desc_en" : "Tablet disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2687
	},
	{
		"eventoid" : 1107,
		"funcid" : 404,
		"desc_es" : "Apertura de Tapa 9",
		"desc_pt" : "Abertura da cobertura 9",
		"desc_en" : "Cover 9 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2665
	},
	{
		"eventoid" : 1108,
		"funcid" : 404,
		"desc_es" : "Cierre de Tapa 9",
		"desc_pt" : "Fechada da cobertura 9",
		"desc_en" : "Cover 9 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2666
	},
	{
		"eventoid" : 1109,
		"funcid" : 404,
		"desc_es" : "Reconexión de Tapa 8",
		"desc_pt" : "Reconexão de Cobertura 8",
		"desc_en" : "Cover 8 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2667
	},
	{
		"eventoid" : 1110,
		"funcid" : 404,
		"desc_es" : "Desconexión de Tapa 8",
		"desc_pt" : "Desconexão da cobertura 8",
		"desc_en" : "Cover 8 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2668
	},
	{
		"eventoid" : 1111,
		"funcid" : 404,
		"desc_es" : "Reconexión de Tapa 9",
		"desc_pt" : "Reconexão de Cobertura 9",
		"desc_en" : "Cover 9 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2669
	},
	{
		"eventoid" : 1112,
		"funcid" : 404,
		"desc_es" : "Desconexión de Tapa 9",
		"desc_pt" : "Desconexão da cobertura 9",
		"desc_en" : "Cover 9 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2670
	},
	{
		"eventoid" : 1113,
		"funcid" : 262,
		"desc_es" : "Inicio video por encendido de cámara",
		"desc_pt" : "Vídeo iniciado da câmera",
		"desc_en" : "Video start by camera",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2671
	},
	{
		"eventoid" : 1114,
		"funcid" : 449,
		"desc_es" : "Humedad máxima camara 3",
		"desc_pt" : "Humedad máxima câmara 3",
		"desc_en" : "Maximum Humidity chamber 3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2672
	},
	{
		"eventoid" : 1115,
		"funcid" : 449,
		"desc_es" : "Humedad normal camara 3",
		"desc_pt" : "Humedad normal câmara 3",
		"desc_en" : "Normal Humidity chamber 3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2673
	},
	{
		"eventoid" : 1116,
		"funcid" : 449,
		"desc_es" : "Humedad mínima camara 3",
		"desc_pt" : "Humedad mínima câmara 3",
		"desc_en" : "Minimum Humidity chamber 3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2674
	},
	{
		"eventoid" : 1117,
		"funcid" : 449,
		"desc_es" : "Humedad máxima camara 4",
		"desc_pt" : "Humedad máxima câmara 4",
		"desc_en" : "Maximum Humidity chamber 4",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2675
	},
	{
		"eventoid" : 1118,
		"funcid" : 449,
		"desc_es" : "Humedad normal camara 4",
		"desc_pt" : "Humedad normal câmara 4",
		"desc_en" : "Normal Humidity chamber 4",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2676
	},
	{
		"eventoid" : 1119,
		"funcid" : 449,
		"desc_es" : "Humedad mínima camara 4",
		"desc_pt" : "Humedad mínima câmara 4",
		"desc_en" : "Minimum Humidity chamber 4",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2677
	},
	{
		"eventoid" : 1232,
		"funcid" : 290,
		"desc_es" : "Conexión de sensor",
		"desc_pt" : "Conexão do sensor",
		"desc_en" : "Sensor connection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2760
	},
	{
		"eventoid" : 1122,
		"funcid" : 101,
		"desc_es" : "Desconexión batería de backup",
		"desc_pt" : "Desconexão da bateria reserva",
		"desc_en" : "Backup battery disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2680
	},
	{
		"eventoid" : 1123,
		"funcid" : 101,
		"desc_es" : "Reconexión batería de backup",
		"desc_pt" : "Reconexão de bateria reserva",
		"desc_en" : "Backup battery reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2681
	},
	{
		"eventoid" : 1124,
		"funcid" : 280,
		"desc_es" : "Mazo sin ID",
		"desc_pt" : "Chicote elétrico sem ID",
		"desc_en" : "Wiring harness without ID",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2682
	},
	{
		"eventoid" : 1125,
		"funcid" : 280,
		"desc_es" : "Cambio de mazo ID",
		"desc_pt" : "Mudança de ID do chicote elétrico",
		"desc_en" : "Wiring harness ID change",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2683
	},
	{
		"eventoid" : 1126,
		"funcid" : 280,
		"desc_es" : "Mazo nuevo con ID",
		"desc_pt" : "ID do chicote elétrico novo",
		"desc_en" : "Wiring harness ID new",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2684
	},
	{
		"eventoid" : 1127,
		"funcid" : 280,
		"desc_es" : "Desconexión de mazo",
		"desc_pt" : "Desconexão do chicote elétrico",
		"desc_en" : "Wiring harness disconexion",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2685
	},
	{
		"eventoid" : 1128,
		"funcid" : 440,
		"desc_es" : "Inicio alerta nivel de aceite",
		"desc_pt" : "Início do alerta de nível de óleo",
		"desc_en" : "Oil level alert start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2686
	},
	{
		"eventoid" : 1129,
		"funcid" : 440,
		"desc_es" : "Fin de alerta de nivel de aceite",
		"desc_pt" : "Fim do alerta de nível de óleo",
		"desc_en" : "End of oil level alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2687
	},
	{
		"eventoid" : 1130,
		"funcid" : 440,
		"desc_es" : "Inicio de alerta de presión de aceite",
		"desc_pt" : "Iniciar alerta de pressão de óleo",
		"desc_en" : "Oil pressure alert start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2688
	},
	{
		"eventoid" : 1131,
		"funcid" : 440,
		"desc_es" : "Fin de alerta de presión de aceite",
		"desc_pt" : "Fim do alerta de pressão de óleo",
		"desc_en" : "End of oil pressure alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2689
	},
	{
		"eventoid" : 1152,
		"funcid" : 290,
		"desc_es" : "Reconexión de tablet",
		"desc_pt" : "Reconexión de tablet",
		"desc_en" : "Tablet reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2688
	},
	{
		"eventoid" : 1121,
		"funcid" : 367,
		"desc_es" : "Fin conducción sin cinturón de seguridad",
		"desc_pt" : "Fim condução sem cinto de segurança",
		"desc_en" : "End of driving without seat belt",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2679
	},
	{
		"eventoid" : 1132,
		"funcid" : 425,
		"desc_es" : "Inicio exceso de torque",
		"desc_pt" : "Início de excesso de torque",
		"desc_en" : "Start of excess torque",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2680
	},
	{
		"eventoid" : 1133,
		"funcid" : 425,
		"desc_es" : "Fin exceso de torque",
		"desc_pt" : "Fim do excesso de torque",
		"desc_en" : "End of excess torque",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2681
	},
	{
		"eventoid" : 1134,
		"funcid" : 425,
		"desc_es" : "Inicio exceso consumo de combustible",
		"desc_pt" : "Comece o consumo de combustível em excesso",
		"desc_en" : "Start excess fuel consumption",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2682
	},
	{
		"eventoid" : 1135,
		"funcid" : 425,
		"desc_es" : "Fin exceso consumo de combustible",
		"desc_pt" : "Fim do consumo de combustível em excesso",
		"desc_en" : "End of excess fuel consumption",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2683
	},
	{
		"eventoid" : 0,
		"funcid" : 1,
		"desc_es" : "No reconocido",
		"desc_pt" : "No reconocido",
		"desc_en" : "Unrecognized event",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 0
	},
	{
		"eventoid" : 1136,
		"funcid" : 31,
		"desc_es" : "Posición pala alta",
		"desc_pt" : "Posição alta da lâmina",
		"desc_en" : "High blade position",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2587
	},
	{
		"eventoid" : 1104,
		"funcid" : 58,
		"desc_es" : "Parada no reconocida",
		"desc_pt" : "Parada não reconhecida",
		"desc_en" : "Stop not recognized",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2691
	},
	{
		"eventoid" : 1062,
		"funcid" : 262,
		"desc_es" : "Apertura de gabinete",
		"desc_pt" : "Abertura de armário",
		"desc_en" : "Cabinet opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2622
	},
	{
		"eventoid" : 1233,
		"funcid" : 290,
		"desc_es" : "Desconexión de sensor",
		"desc_pt" : "Desconexão do sensor",
		"desc_en" : "Sensor disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2761
	},
	{
		"eventoid" : 1137,
		"funcid" : 31,
		"desc_es" : "Posición pala medio",
		"desc_pt" : "Posição média da lâmina",
		"desc_en" : "Middle blade position",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2587
	},
	{
		"eventoid" : 1138,
		"funcid" : 31,
		"desc_es" : "Posición pala baja",
		"desc_pt" : "Posição baixa da lâmina",
		"desc_en" : "Low blade position",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2587
	},
	{
		"eventoid" : 1210,
		"funcid" : 512,
		"desc_es" : "Desactivación remota de viaje completo",
		"desc_pt" : "Desactivación remota de viaje completo",
		"desc_en" : "Desactivación remota de viaje completo",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2738
	},
	{
		"eventoid" : 1153,
		"funcid" : 512,
		"desc_es" : "Activación local de viaje completo",
		"desc_pt" : "Activación local de viaje completo",
		"desc_en" : "Activación local de viaje completo",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2689
	},
	{
		"eventoid" : 1139,
		"funcid" : 386,
		"desc_es" : "Desconexión ican Motor Acompañante",
		"desc_pt" : "Desconexión ican Motor Acompañante",
		"desc_en" : "Desconexión ican Motor Acompañante",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2586
	},
	{
		"eventoid" : 1140,
		"funcid" : 386,
		"desc_es" : "Reconexión ican Motor Acompañante",
		"desc_pt" : "Reconexión ican Motor Acompañante",
		"desc_en" : "Reconexión ican Motor Acompañante",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2586
	},
	{
		"eventoid" : 1141,
		"funcid" : 386,
		"desc_es" : "Contacto ON Motor Acompañante",
		"desc_pt" : "Contacto ON Motor Acompañante",
		"desc_en" : "Contacto ON Motor Acompañante",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2586
	},
	{
		"eventoid" : 1142,
		"funcid" : 386,
		"desc_es" : "Contacto OFF Motor Acompañante",
		"desc_pt" : "Contacto OFF Motor Acompañante",
		"desc_en" : "Contacto OFF Motor Acompañante",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2586
	},
	{
		"eventoid" : 1143,
		"funcid" : 388,
		"desc_es" : "Desconexión ican Motor Conductor",
		"desc_pt" : "Desconexión ican Motor Conductor",
		"desc_en" : "Desconexión ican Motor Conductor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2586
	},
	{
		"eventoid" : 1264,
		"funcid" : 450,
		"desc_es" : "Alerta de fatiga activado",
		"desc_pt" : "Alerta de fadiga ativado",
		"desc_en" : "Fatigue alert activated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2792
	},
	{
		"eventoid" : 1144,
		"funcid" : 388,
		"desc_es" : "Reconexión ican Motor Conductor",
		"desc_pt" : "Reconexión ican Motor Conductor",
		"desc_en" : "Reconexión ican Motor Conductor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2586
	},
	{
		"eventoid" : 1145,
		"funcid" : 388,
		"desc_es" : "Contacto ON Motor Conductor",
		"desc_pt" : "Contacto ON Motor Conductor",
		"desc_en" : "Contacto ON Motor Conductor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2586
	},
	{
		"eventoid" : 1146,
		"funcid" : 388,
		"desc_es" : "Contacto OFF Motor Conductor",
		"desc_pt" : "Contacto OFF Motor Conductor",
		"desc_en" : "Contacto OFF Motor Conductor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2586
	},
	{
		"eventoid" : 1147,
		"funcid" : 389,
		"desc_es" : "Desconexión ican Motor Auxiliar",
		"desc_pt" : "Desconexión ican Motor Auxiliar",
		"desc_en" : "Desconexión ican Motor Auxiliar",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2586
	},
	{
		"eventoid" : 1148,
		"funcid" : 389,
		"desc_es" : "Reconexión ican Motor Auxiliar",
		"desc_pt" : "Reconexión ican Motor Auxiliar",
		"desc_en" : "Reconexión ican Motor Auxiliar",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2586
	},
	{
		"eventoid" : 1149,
		"funcid" : 389,
		"desc_es" : "Contacto ON Motor Auxiliar",
		"desc_pt" : "Contacto ON Motor Auxiliar",
		"desc_en" : "Contacto ON Motor Auxiliar",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2586
	},
	{
		"eventoid" : 1150,
		"funcid" : 389,
		"desc_es" : "Contacto OFF Motor Auxiliar",
		"desc_pt" : "Contacto OFF Motor Auxiliar",
		"desc_en" : "Contacto OFF Motor Auxiliar",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2586
	},
	{
		"eventoid" : 1154,
		"funcid" : 512,
		"desc_es" : "Activación local fallida de viaje Completo",
		"desc_pt" : "Activación local fallida de viaje Completo",
		"desc_en" : "Activación local fallida de viaje Completo",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2690
	},
	{
		"eventoid" : 1103,
		"funcid" : 58,
		"desc_es" : "Parada reconocida",
		"desc_pt" : "Parada reconhecida",
		"desc_en" : "Recognized stop",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2690
	},
	{
		"eventoid" : 1155,
		"funcid" : 512,
		"desc_es" : "Activación local de viaje parcial",
		"desc_pt" : "Activación local de viaje parcial",
		"desc_en" : "Activación local de viaje parcial",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2691
	},
	{
		"eventoid" : 1156,
		"funcid" : 512,
		"desc_es" : "Activación local fallida de viaje parcial",
		"desc_pt" : "Activación local fallida de viaje parcial",
		"desc_en" : "Activación local fallida de viaje parcial",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2692
	},
	{
		"eventoid" : 1157,
		"funcid" : 512,
		"desc_es" : "Activación remota de viaje completo",
		"desc_pt" : "Activación remota de viaje completo",
		"desc_en" : "Activación remota de viaje completo",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2693
	},
	{
		"eventoid" : 1158,
		"funcid" : 512,
		"desc_es" : "Activación remota fallida de viaje completo",
		"desc_pt" : "Activación remota fallida de viaje completo",
		"desc_en" : "Activación remota fallida de viaje completo",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2694
	},
	{
		"eventoid" : 1159,
		"funcid" : 512,
		"desc_es" : "Activación remota de viaje parcial",
		"desc_pt" : "Activación remota de viaje parcial",
		"desc_en" : "Activación remota de viaje parcial",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2695
	},
	{
		"eventoid" : 1160,
		"funcid" : 512,
		"desc_es" : "Activación remota fallida de viaje parcial",
		"desc_pt" : "Activación remota fallida de viaje parcial",
		"desc_en" : "Activación remota fallida de viaje parcial",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2696
	},
	{
		"eventoid" : 1169,
		"funcid" : 189,
		"desc_es" : "Destrabe local de desenganche",
		"desc_pt" : "Destrabe local de desenganche",
		"desc_en" : "Destrabe local de desenganche",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2697
	},
	{
		"eventoid" : 1170,
		"funcid" : 189,
		"desc_es" : "Trabe local de desenganche",
		"desc_pt" : "Trabe local de desenganche",
		"desc_en" : "Trabe local de desenganche",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2698
	},
	{
		"eventoid" : 1171,
		"funcid" : 189,
		"desc_es" : "Destrabe remoto de desenganche",
		"desc_pt" : "Destrabe remoto de desenganche",
		"desc_en" : "Destrabe remoto de desenganche",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2699
	},
	{
		"eventoid" : 1172,
		"funcid" : 189,
		"desc_es" : "Trabe remoto de desenganche",
		"desc_pt" : "Trabe remoto de desenganche",
		"desc_en" : "Trabe remoto de desenganche",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2700
	},
	{
		"eventoid" : 1173,
		"funcid" : 189,
		"desc_es" : "Falla en traba de desenganche",
		"desc_pt" : "Falla en traba de desenganche",
		"desc_en" : "Falla en traba de desenganche",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2701
	},
	{
		"eventoid" : 1174,
		"funcid" : 37,
		"desc_es" : "Destrabe remoto puerta trasera chasis",
		"desc_pt" : "Destrabe remoto puerta trasera chasis",
		"desc_en" : "Destrabe remoto puerta trasera chasis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2702
	},
	{
		"eventoid" : 1175,
		"funcid" : 37,
		"desc_es" : "Trabe remoto puerta trasera chasis",
		"desc_pt" : "Trabe remoto puerta trasera chasis",
		"desc_en" : "Trabe remoto puerta trasera chasis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2703
	},
	{
		"eventoid" : 1176,
		"funcid" : 37,
		"desc_es" : "Destrabe local puerta trasera chasis",
		"desc_pt" : "Destrabe local puerta trasera chasis",
		"desc_en" : "Destrabe local puerta trasera chasis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2704
	},
	{
		"eventoid" : 1177,
		"funcid" : 37,
		"desc_es" : "Trabe local puerta trasera chasis",
		"desc_pt" : "Trabe local puerta trasera chasis",
		"desc_en" : "Trabe local puerta trasera chasis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2705
	},
	{
		"eventoid" : 1178,
		"funcid" : 37,
		"desc_es" : "Destrabe remoto puerta lateral chasis",
		"desc_pt" : "Destrabe remoto puerta lateral chasis",
		"desc_en" : "Destrabe remoto puerta lateral chasis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2706
	},
	{
		"eventoid" : 1179,
		"funcid" : 37,
		"desc_es" : "Trabe remoto puerta lateral chasis",
		"desc_pt" : "Trabe remoto puerta lateral chasis",
		"desc_en" : "Trabe remoto puerta lateral chasis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2707
	},
	{
		"eventoid" : 1180,
		"funcid" : 37,
		"desc_es" : "Destrabe local puerta lateral chasis",
		"desc_pt" : "Destrabe local puerta lateral chasis",
		"desc_en" : "Destrabe local puerta lateral chasis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2708
	},
	{
		"eventoid" : 1181,
		"funcid" : 37,
		"desc_es" : "Trabe local puerta lateral chasis",
		"desc_pt" : "Trabe local puerta lateral chasis",
		"desc_en" : "Trabe local puerta lateral chasis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2709
	},
	{
		"eventoid" : 1182,
		"funcid" : 37,
		"desc_es" : "Destrabe remoto puerta trasera acoplado",
		"desc_pt" : "Destrabe remoto puerta trasera acoplado",
		"desc_en" : "Destrabe remoto puerta trasera acoplado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2710
	},
	{
		"eventoid" : 1183,
		"funcid" : 37,
		"desc_es" : "Trabe remoto puerta trasera acoplado",
		"desc_pt" : "Trabe remoto puerta trasera acoplado",
		"desc_en" : "Trabe remoto puerta trasera acoplado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2711
	},
	{
		"eventoid" : 1184,
		"funcid" : 37,
		"desc_es" : "Destrabe local puerta trasera acoplado",
		"desc_pt" : "Destrabe local puerta trasera acoplado",
		"desc_en" : "Destrabe local puerta trasera acoplado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2712
	},
	{
		"eventoid" : 1185,
		"funcid" : 37,
		"desc_es" : "Trabe local puerta trasera acoplado",
		"desc_pt" : "Trabe local puerta trasera acoplado",
		"desc_en" : "Trabe local puerta trasera acoplado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2713
	},
	{
		"eventoid" : 1186,
		"funcid" : 37,
		"desc_es" : "Destrabe remoto puerta lateral acoplado",
		"desc_pt" : "Destrabe remoto puerta lateral acoplado",
		"desc_en" : "Destrabe remoto puerta lateral acoplado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2714
	},
	{
		"eventoid" : 1187,
		"funcid" : 37,
		"desc_es" : "Trabe remoto puerta lateral acoplado",
		"desc_pt" : "Trabe remoto puerta lateral acoplado",
		"desc_en" : "Trabe remoto puerta lateral acoplado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2715
	},
	{
		"eventoid" : 1188,
		"funcid" : 37,
		"desc_es" : "Destrabe local puerta lateral acoplado",
		"desc_pt" : "Destrabe local puerta lateral acoplado",
		"desc_en" : "Destrabe local puerta lateral acoplado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2716
	},
	{
		"eventoid" : 1189,
		"funcid" : 37,
		"desc_es" : "Trabe local puerta lateral acoplado",
		"desc_pt" : "Trabe local puerta lateral acoplado",
		"desc_en" : "Trabe local puerta lateral acoplado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2717
	},
	{
		"eventoid" : 1190,
		"funcid" : 37,
		"desc_es" : "Falla en traba trasera chasis",
		"desc_pt" : "Falla en traba trasera chasis",
		"desc_en" : "Falla en traba trasera chasis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2718
	},
	{
		"eventoid" : 1191,
		"funcid" : 37,
		"desc_es" : "Falla en traba lateral chasis",
		"desc_pt" : "Falla en traba lateral chasis",
		"desc_en" : "Falla en traba lateral chasis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2719
	},
	{
		"eventoid" : 1192,
		"funcid" : 37,
		"desc_es" : "Falla en traba trasera acoplado",
		"desc_pt" : "Falla en traba trasera acoplado",
		"desc_en" : "Falla en traba trasera acoplado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2720
	},
	{
		"eventoid" : 1193,
		"funcid" : 37,
		"desc_es" : "Falla en traba lateral acoplado",
		"desc_pt" : "Falla en traba lateral acoplado",
		"desc_en" : "Falla en traba lateral acoplado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2721
	},
	{
		"eventoid" : 1194,
		"funcid" : 14,
		"desc_es" : "Apertura de puerta de cabina acompañante",
		"desc_pt" : "Apertura de puerta de cabina acompañante",
		"desc_en" : "Apertura de puerta de cabina acompañante",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2722
	},
	{
		"eventoid" : 1195,
		"funcid" : 14,
		"desc_es" : "Cierre de puerta de cabina acompañante",
		"desc_pt" : "Cierre de puerta de cabina acompañante",
		"desc_en" : "Cierre de puerta de cabina acompañante",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2723
	},
	{
		"eventoid" : 1237,
		"funcid" : 363,
		"desc_es" : "Fatiga Nivel 2",
		"desc_pt" : "Fadiga Nível 2",
		"desc_en" : "Fatigue Level 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2765
	},
	{
		"eventoid" : 1196,
		"funcid" : 14,
		"desc_es" : "Apertura de puerta de cabina conductor",
		"desc_pt" : "Apertura de puerta de cabina conductor",
		"desc_en" : "Apertura de puerta de cabina conductor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2724
	},
	{
		"eventoid" : 1197,
		"funcid" : 14,
		"desc_es" : "Cierre de puerta de cabina conductor",
		"desc_pt" : "Cierre de puerta de cabina conductor",
		"desc_en" : "Cierre de puerta de cabina conductor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2725
	},
	{
		"eventoid" : 1198,
		"funcid" : 13,
		"desc_es" : "Apertura trasera chasis",
		"desc_pt" : "Apertura trasera chasis",
		"desc_en" : "Apertura trasera chasis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2726
	},
	{
		"eventoid" : 1199,
		"funcid" : 13,
		"desc_es" : "Cierre trasera chasis",
		"desc_pt" : "Cierre trasera chasis",
		"desc_en" : "Cierre trasera chasis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2727
	},
	{
		"eventoid" : 1200,
		"funcid" : 13,
		"desc_es" : "Apertura lateral chasis",
		"desc_pt" : "Apertura lateral chasis",
		"desc_en" : "Apertura lateral chasis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2728
	},
	{
		"eventoid" : 1201,
		"funcid" : 13,
		"desc_es" : "Cierre lateral chasis",
		"desc_pt" : "Cierre lateral chasis",
		"desc_en" : "Cierre lateral chasis",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2729
	},
	{
		"eventoid" : 1202,
		"funcid" : 13,
		"desc_es" : "Apertura trasera acoplado",
		"desc_pt" : "Apertura trasera acoplado",
		"desc_en" : "Apertura trasera acoplado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2730
	},
	{
		"eventoid" : 1203,
		"funcid" : 13,
		"desc_es" : "Cierre trasera acoplado",
		"desc_pt" : "Cierre trasera acoplado",
		"desc_en" : "Cierre trasera acoplado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2731
	},
	{
		"eventoid" : 1204,
		"funcid" : 13,
		"desc_es" : "Apertura lateral acoplado",
		"desc_pt" : "Apertura lateral acoplado",
		"desc_en" : "Apertura lateral acoplado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2732
	},
	{
		"eventoid" : 1205,
		"funcid" : 13,
		"desc_es" : "Cierre lateral acoplado",
		"desc_pt" : "Cierre lateral acoplado",
		"desc_en" : "Cierre lateral acoplado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2733
	},
	{
		"eventoid" : 1206,
		"funcid" : 208,
		"desc_es" : "Activación de sensor ventanilla acompañante",
		"desc_pt" : "Activación de sensor ventanilla acompañante",
		"desc_en" : "Activación de sensor ventanilla acompañante",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2734
	},
	{
		"eventoid" : 1207,
		"funcid" : 208,
		"desc_es" : "Desactivación de sensor ventanilla acompañante",
		"desc_pt" : "Desactivación de sensor ventanilla acompañante",
		"desc_en" : "Desactivación de sensor ventanilla acompañante",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2735
	},
	{
		"eventoid" : 1208,
		"funcid" : 208,
		"desc_es" : "Activación de sensor ventanilla conductor",
		"desc_pt" : "Activación de sensor ventanilla conductor",
		"desc_en" : "Activación de sensor ventanilla conductor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2736
	},
	{
		"eventoid" : 1209,
		"funcid" : 208,
		"desc_es" : "Desactivación de sensor ventanilla conductor",
		"desc_pt" : "Desactivación de sensor ventanilla conductor",
		"desc_en" : "Desactivación de sensor ventanilla conductor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2737
	},
	{
		"eventoid" : 1211,
		"funcid" : 512,
		"desc_es" : "Desactivación remota de viaje parcial",
		"desc_pt" : "Desactivación remota de viaje parcial",
		"desc_en" : "Desactivación remota de viaje parcial",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2739
	},
	{
		"eventoid" : 1212,
		"funcid" : 70,
		"desc_es" : "Detección de movimiento",
		"desc_pt" : "Detector de movimento",
		"desc_en" : "Motion detection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2740
	},
	{
		"eventoid" : 1213,
		"funcid" : 199,
		"desc_es" : "Exceso de detenido 1",
		"desc_pt" : "Exceso de detenido 1",
		"desc_en" : "Exceso de detenido 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2741
	},
	{
		"eventoid" : 1214,
		"funcid" : 199,
		"desc_es" : "Exceso de detenido 2",
		"desc_pt" : "Exceso de detenido 2",
		"desc_en" : "Exceso de detenido 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2742
	},
	{
		"eventoid" : 1215,
		"funcid" : 199,
		"desc_es" : "Exceso de detenido 3",
		"desc_pt" : "Exceso de detenido 3",
		"desc_en" : "Exceso de detenido 3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2743
	},
	{
		"eventoid" : 1217,
		"funcid" : 262,
		"desc_es" : "Fin camara obstruida",
		"desc_pt" : "Fim câmera obstruída",
		"desc_en" : "End obstructed camera",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2745
	},
	{
		"eventoid" : 1004,
		"funcid" : 262,
		"desc_es" : "Inicio Camara Obstruida",
		"desc_pt" : "Início Câmera Obstruída",
		"desc_en" : "Start Obstructed camera",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2566
	},
	{
		"eventoid" : 1063,
		"funcid" : 262,
		"desc_es" : "Cierre de gabinete",
		"desc_pt" : "Fechadura de armário",
		"desc_en" : "Cabinet lock",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2623
	},
	{
		"eventoid" : 1223,
		"funcid" : 290,
		"desc_es" : "Inicio de exceso de partículas 6 Micrones",
		"desc_pt" : "Inicio de exceso de partículas 6 Micrones",
		"desc_en" : "Inicio de exceso de partículas 6 Micrones",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2751
	},
	{
		"eventoid" : 1221,
		"funcid" : 290,
		"desc_es" : "Inicio de exceso de partículas 4 Micrones",
		"desc_pt" : "Inicio de exceso de partículas 4 Micrones",
		"desc_en" : "Inicio de exceso de partículas 4 Micrones",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2749
	},
	{
		"eventoid" : 1222,
		"funcid" : 290,
		"desc_es" : "Fin de exceso de partículas 4 Micrones",
		"desc_pt" : "Fin de exceso de partículas 4 Micrones",
		"desc_en" : "Fin de exceso de partículas 4 Micrones",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2750
	},
	{
		"eventoid" : 1224,
		"funcid" : 290,
		"desc_es" : "Fin de exceso de partículas 6 Micrones",
		"desc_pt" : "Fin de exceso de partículas 6 Micrones",
		"desc_en" : "Fin de exceso de partículas 6 Micrones",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2752
	},
	{
		"eventoid" : 1225,
		"funcid" : 290,
		"desc_es" : "Inicio de exceso de partículas 14 Micrones",
		"desc_pt" : "Inicio de exceso de partículas 14 Micrones",
		"desc_en" : "Inicio de exceso de partículas 14 Micrones",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2753
	},
	{
		"eventoid" : 1226,
		"funcid" : 290,
		"desc_es" : "Fin de exceso de partículas 14 Micrones",
		"desc_pt" : "Fin de exceso de partículas 14 Micrones",
		"desc_en" : "Fin de exceso de partículas 14 Micrones",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2754
	},
	{
		"eventoid" : 1120,
		"funcid" : 367,
		"desc_es" : "Inicio conducción sin cinturón de seguridad",
		"desc_pt" : "Início condução sem cinto de segurança",
		"desc_en" : "Start driving without seat belt",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2678
	},
	{
		"eventoid" : 1348,
		"funcid" : 363,
		"desc_es" : "Fatiga Autodetectada",
		"desc_pt" : "Fadiga Autodetectada",
		"desc_en" : "Autodetected Fatigue",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2873
	},
	{
		"eventoid" : 1006,
		"funcid" : 237,
		"desc_es" : "Advertencia de salida de carril",
		"desc_pt" : "Detecção de saída de faixa",
		"desc_en" : "Lane Departure Warning",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2568
	},
	{
		"eventoid" : 1007,
		"funcid" : 236,
		"desc_es" : "Detección de colisión",
		"desc_pt" : "Alerta de risco de colisão frontal",
		"desc_en" : "Collision detection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2569
	},
	{
		"eventoid" : 444,
		"funcid" : 314,
		"desc_es" : "Advertencia de distancia de frenado insuficiente",
		"desc_pt" : "Alerta de risco por distância insegura",
		"desc_en" : "Warning of insufficient braking distance",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1473
	},
	{
		"eventoid" : 1216,
		"funcid" : 262,
		"desc_es" : "Fin perdida de video",
		"desc_pt" : "Fim de perda de vídeo",
		"desc_en" : "End video loss",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2744
	},
	{
		"eventoid" : 1003,
		"funcid" : 262,
		"desc_es" : "Inicio Perdida de video",
		"desc_pt" : "Início de perda de vídeo",
		"desc_en" : "Start Video loss",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2565
	},
	{
		"eventoid" : 1220,
		"funcid" : 262,
		"desc_es" : "Almacenamiento anormal",
		"desc_pt" : "Memória Anormal",
		"desc_en" : "Abnormal storage",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2748
	},
	{
		"eventoid" : 891,
		"funcid" : 444,
		"desc_es" : "Inicio de movimiento con volquete levantado",
		"desc_pt" : "Início de movimento com báscula erguida",
		"desc_en" : "Start of movement with raised tipper",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2463
	},
	{
		"eventoid" : 1235,
		"funcid" : 503,
		"desc_es" : "Fin de inclinación lateral de volquete",
		"desc_pt" : "Fim de inclinação lateral basculante",
		"desc_en" : "Side tilt tipper end",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2763
	},
	{
		"eventoid" : 1238,
		"funcid" : 363,
		"desc_es" : "Fatiga Nivel 3",
		"desc_pt" : "Fadiga Nível 3",
		"desc_en" : "Fatigue Level 3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2766
	},
	{
		"eventoid" : 1240,
		"funcid" : 125,
		"desc_es" : "Checklist mensual no ejecutado",
		"desc_pt" : "Checklist mensal não executado",
		"desc_en" : "Monthly checklist not executed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2768
	},
	{
		"eventoid" : 1241,
		"funcid" : 125,
		"desc_es" : "Checklist semanal no ejecutado",
		"desc_pt" : "Checklist semanal não executado",
		"desc_en" : "Weekly checklist not executed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2769
	},
	{
		"eventoid" : 1242,
		"funcid" : 108,
		"desc_es" : "Tiempo de conducción continua excedido 1",
		"desc_pt" : "Tempo de condução contínuo excedido 1",
		"desc_en" : "Continuous driving time exceeded 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2770
	},
	{
		"eventoid" : 1243,
		"funcid" : 108,
		"desc_es" : "Tiempo de conducción continua excedido 2",
		"desc_pt" : "Tempo de condução contínuo excedido 2",
		"desc_en" : "Continuous driving time exceeded 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2771
	},
	{
		"eventoid" : 1244,
		"funcid" : 108,
		"desc_es" : "Preaviso conducción continua 1",
		"desc_pt" : "Aviso de condução contínua 1",
		"desc_en" : "Continuous driving notice 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2772
	},
	{
		"eventoid" : 1245,
		"funcid" : 108,
		"desc_es" : "Preaviso conducción continua 2",
		"desc_pt" : "Aviso de condução contínua 2",
		"desc_en" : "Continuous driving notice 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2773
	},
	{
		"eventoid" : 1246,
		"funcid" : 108,
		"desc_es" : "Descanso continuo cumplido",
		"desc_pt" : "Descanso contínuo cumprido",
		"desc_en" : "Continuous rest fulfilled",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2774
	},
	{
		"eventoid" : 1239,
		"funcid" : 108,
		"desc_es" : "Descanso proporcional cumplido",
		"desc_pt" : "Resto proporcional cumprido",
		"desc_en" : "Proportional rest fulfilled",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2767
	},
	{
		"eventoid" : 1247,
		"funcid" : 367,
		"desc_es" : "Conducción sin cinturón de seguridad",
		"desc_pt" : "Conduzir sem cinto de segurança",
		"desc_en" : "Driving without a seat belt",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2775
	},
	{
		"eventoid" : 1248,
		"funcid" : 125,
		"desc_es" : "Reconocimiento facial",
		"desc_pt" : "Reconhecimento facial",
		"desc_en" : "Face recognition",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2776
	},
	{
		"eventoid" : 1391,
		"funcid" : 290,
		"desc_es" : "Desconexión de repetidor",
		"desc_pt" : "Desconexão do repetidor",
		"desc_en" : "Repeater disconnection",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2916
	},
	{
		"eventoid" : 1390,
		"funcid" : 290,
		"desc_es" : "Reconexión de modulo serial",
		"desc_pt" : "Reconexão do módulo serial",
		"desc_en" : "Serial module reconnection",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2915
	},
	{
		"eventoid" : 1250,
		"funcid" : 57,
		"desc_es" : "Fin de Exceso de tiempo en zona de Riesgo",
		"desc_pt" : "Fim de Excesso de Tempo em Zona de Risco",
		"desc_en" : "End of Excess Time in Risk Zone",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2778
	},
	{
		"eventoid" : 1251,
		"funcid" : 57,
		"desc_es" : "Dentro de Zona Prohibida",
		"desc_pt" : "Entrada em Zona Proibida",
		"desc_en" : "Inside Prohibited Zone",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2779
	},
	{
		"eventoid" : 1252,
		"funcid" : 57,
		"desc_es" : "Fuera de Zona Prohibida",
		"desc_pt" : "Saída de Zona Proibida",
		"desc_en" : "Outside Prohibited Zone",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2780
	},
	{
		"eventoid" : 1257,
		"funcid" : 382,
		"desc_es" : "Inicio alerta exceso de peso",
		"desc_pt" : "Início alerta excesso de peso",
		"desc_en" : "Start alert weight excess",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2785
	},
	{
		"eventoid" : 1253,
		"funcid" : 290,
		"desc_es" : "Tendencia de exceso de partículas de 4 Micrones",
		"desc_pt" : "Tendencia de exceso de partículas de 4 Micrones",
		"desc_en" : "Tendencia de exceso de partículas de 4 Micrones",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2781
	},
	{
		"eventoid" : 1254,
		"funcid" : 290,
		"desc_es" : "Tendencia de exceso de partículas de 6 Micrones",
		"desc_pt" : "Tendencia de exceso de partículas de 6 Micrones",
		"desc_en" : "Tendencia de exceso de partículas de 6 Micrones",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2782
	},
	{
		"eventoid" : 1255,
		"funcid" : 290,
		"desc_es" : "Tendencia de exceso de partículas de 14 Micrones",
		"desc_pt" : "Tendencia de exceso de partículas de 14 Micrones",
		"desc_en" : "Tendencia de exceso de partículas de 14 Micrones",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2783
	},
	{
		"eventoid" : 1258,
		"funcid" : 382,
		"desc_es" : "Fin alerta exceso de peso",
		"desc_pt" : "Fim alerta excesso de peso",
		"desc_en" : "End alert weight excess",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2786
	},
	{
		"eventoid" : 333,
		"funcid" : 241,
		"desc_es" : "Movimiento sin contacto",
		"desc_pt" : "Movimento sem contato",
		"desc_en" : "Movement without contact",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 343
	},
	{
		"eventoid" : 887,
		"funcid" : 439,
		"desc_es" : "AV 3.0 Esclavo Activado",
		"desc_pt" : "AV 3.0 Escravo Ativado",
		"desc_en" : "AV 3.0 Slave Activated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2460
	},
	{
		"eventoid" : 888,
		"funcid" : 439,
		"desc_es" : "AV 3.0 Esclavo 2 Activado",
		"desc_pt" : "AV 3.0 Escravo 2 Ativado",
		"desc_en" : "AV 3.0 Slave 2 Activated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2461
	},
	{
		"eventoid" : 889,
		"funcid" : 439,
		"desc_es" : "AV 3.0 Esclavo 3 Activado",
		"desc_pt" : "AV 3.0 Escravo 3 Ativado",
		"desc_en" : "AV 3.0 Slave 3 Activated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2462
	},
	{
		"eventoid" : 1389,
		"funcid" : 290,
		"desc_es" : "Desconexión de modulo serial",
		"desc_pt" : "Desconexão do módulo serial",
		"desc_en" : "Serial module disconnection",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2914
	},
	{
		"eventoid" : 1262,
		"funcid" : 563,
		"desc_es" : "Nodriza operando",
		"desc_pt" : "Nodriza operando",
		"desc_en" : "Nodriza operando",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2790
	},
	{
		"eventoid" : 1263,
		"funcid" : 563,
		"desc_es" : "Nodriza en reposo",
		"desc_pt" : "Nodriza en reposo",
		"desc_en" : "Nodriza en reposo",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2791
	},
	{
		"eventoid" : 1265,
		"funcid" : 450,
		"desc_es" : "Alerta de fatiga desactivado",
		"desc_pt" : "Alerta de fadiga desativado",
		"desc_en" : "Fatigue alert off",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2793
	},
	{
		"eventoid" : 1266,
		"funcid" : 565,
		"desc_es" : "Rampa arriba",
		"desc_pt" : "Rampa arriba",
		"desc_en" : "Ramp up",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2794
	},
	{
		"eventoid" : 1267,
		"funcid" : 565,
		"desc_es" : "Rampa abajo",
		"desc_pt" : "Rampa abajo",
		"desc_en" : "Ramp down",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2795
	},
	{
		"eventoid" : 1268,
		"funcid" : 566,
		"desc_es" : "Apertura traba tanque",
		"desc_pt" : "Abertura da fechadura do tanque",
		"desc_en" : "Tank lock opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2796
	},
	{
		"eventoid" : 1269,
		"funcid" : 566,
		"desc_es" : "Cierre traba tanque",
		"desc_pt" : "Fechadura de tanque",
		"desc_en" : "Close tank lock",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2797
	},
	{
		"eventoid" : 1270,
		"funcid" : 4,
		"desc_es" : "Inicio de sobrevelocidad en zona",
		"desc_pt" : "Início da sobrevelocidade na zona",
		"desc_en" : "Overspeed start in zone",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2798
	},
	{
		"eventoid" : 1271,
		"funcid" : 4,
		"desc_es" : "Fin de sobrevelocidad en zona",
		"desc_pt" : "Fim da sobrevelocidade na zona",
		"desc_en" : "Overspeed end in zone.",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2799
	},
	{
		"eventoid" : 1272,
		"funcid" : 284,
		"desc_es" : "Inicio de velocidad reducida en zona",
		"desc_pt" : "Início de velocidade reduzida na zona",
		"desc_en" : "Reduced speed start in zone",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2800
	},
	{
		"eventoid" : 1273,
		"funcid" : 284,
		"desc_es" : "Fin de velocidad reducida en zona",
		"desc_pt" : "Fim da velocidade reduzida na zona",
		"desc_en" : "Reduced speed end in zone",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2801
	},
	{
		"eventoid" : 510,
		"funcid" : 216,
		"desc_es" : "Incumplimiento de encendido de motor en viaje",
		"desc_pt" : "Violação de horário de ignição do motor na viagem",
		"desc_en" : "Not complied trip ignition",
		"eventotablaid" : 3,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1301
	},
	{
		"eventoid" : 486,
		"funcid" : 4,
		"desc_es" : "En sobrevelocidad",
		"desc_pt" : "Em velocidade",
		"desc_en" : "In overspeed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1014
	},
	{
		"eventoid" : 487,
		"funcid" : 251,
		"desc_es" : "En sobrevelocidad (ECU)",
		"desc_pt" : "Em velocidade (ECU)",
		"desc_en" : "In overspeed (ECU)",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1515
	},
	{
		"eventoid" : 1055,
		"funcid" : 440,
		"desc_es" : "Error de sensor",
		"desc_pt" : "Erro do sensor",
		"desc_en" : "Sensor error",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2615
	},
	{
		"eventoid" : 648,
		"funcid" : 29,
		"desc_es" : "Inicio de Viaje",
		"desc_pt" : "Inicio de Viagem",
		"desc_en" : "Trip start",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2271
	},
	{
		"eventoid" : 1278,
		"funcid" : 16,
		"desc_es" : "Encendido equipo de frío",
		"desc_pt" : "Equipamento de frio ligado",
		"desc_en" : "Cold equipment turn on",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2805
	},
	{
		"eventoid" : 1279,
		"funcid" : 16,
		"desc_es" : "Apagado equipo de frío",
		"desc_pt" : "Equipamento de frio desligado",
		"desc_en" : "Cold equipment turn off",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2806
	},
	{
		"eventoid" : 1280,
		"funcid" : 3,
		"desc_es" : "Reporte por tiempo de batería",
		"desc_pt" : "Reporte por tempo de bateria",
		"desc_en" : "Battery report by time",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2807
	},
	{
		"eventoid" : 1281,
		"funcid" : 3,
		"desc_es" : "Detección de fatiga severa",
		"desc_pt" : "Detecção de fadiga severa",
		"desc_en" : "Severe fatigue detection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2808
	},
	{
		"eventoid" : 1282,
		"funcid" : 3,
		"desc_es" : "Detección de ingesta de alimento",
		"desc_pt" : "Detecção de ingestão de alimento",
		"desc_en" : "Feed intake detection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2809
	},
	{
		"eventoid" : 1283,
		"funcid" : 597,
		"desc_es" : "Desconexión en puerto serie",
		"desc_pt" : "Desconexão na porta serial",
		"desc_en" : "Disconnection in serial port",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2810
	},
	{
		"eventoid" : 1284,
		"funcid" : 597,
		"desc_es" : "Reconexión en puerto serie",
		"desc_pt" : "Reconexão na porta serial",
		"desc_en" : "Reconnection in serial port",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2811
	},
	{
		"eventoid" : 1285,
		"funcid" : 12,
		"desc_es" : "Inicio de infracción de bloqueo diferencial",
		"desc_pt" : "Início de infração bloqueio diferencial",
		"desc_en" : "Inicio de infracción de bloqueo diferencial",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1000
	},
	{
		"eventoid" : 1286,
		"funcid" : 12,
		"desc_es" : "Fin de infracción de bloqueo diferencial",
		"desc_pt" : "Fim de infração bloqueio diferencial",
		"desc_en" : "Fin de infracción de bloqueo diferencial",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1000
	},
	{
		"eventoid" : 1287,
		"funcid" : 196,
		"desc_es" : "Fin de batería baja",
		"desc_pt" : "Fim de Bateria baixa",
		"desc_en" : "End of low battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2814
	},
	{
		"eventoid" : 1334,
		"funcid" : 4,
		"desc_es" : "Desbloqueo de emergencia",
		"desc_pt" : "Desbloqueio Emergencial",
		"desc_en" : "Emergency Unlock",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2859
	},
	{
		"eventoid" : 1289,
		"funcid" : 3,
		"desc_es" : "Bloqueo diferencial activado",
		"desc_pt" : "Bloqueio diferencial ativado",
		"desc_en" : "Differential lock activated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2816
	},
	{
		"eventoid" : 1290,
		"funcid" : 3,
		"desc_es" : "Bloqueo diferencial desactivado",
		"desc_pt" : "Bloqueio diferencial desativado",
		"desc_en" : "Differential lock deactivated",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2817
	},
	{
		"eventoid" : 1291,
		"funcid" : 283,
		"desc_es" : "Distancia de conducción continua excedida",
		"desc_pt" : "Distância de condução contínua excedida",
		"desc_en" : "Continuous driving distance exceeded",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2818
	},
	{
		"eventoid" : 1292,
		"funcid" : 420,
		"desc_es" : "Tiempo ralenti excedido",
		"desc_pt" : "Tempo ocioso ultrapassado",
		"desc_en" : "Idle time exceeded",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2819
	},
	{
		"eventoid" : 1293,
		"funcid" : 481,
		"desc_es" : "Detección irregular de anteojos",
		"desc_pt" : "Detecção de óculos irregular",
		"desc_en" : "Irregular detection of eyeglasses",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2820
	},
	{
		"eventoid" : 1294,
		"funcid" : 408,
		"desc_es" : "Conexión de equipo",
		"desc_pt" : "Conexão do equipamento",
		"desc_en" : "Device connection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2821
	},
	{
		"eventoid" : 1295,
		"funcid" : 408,
		"desc_es" : "Desconexión de equipo",
		"desc_pt" : "Desconexão do equipamento",
		"desc_en" : "Device disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2822
	},
	{
		"eventoid" : 1296,
		"funcid" : 610,
		"desc_es" : "Turno confirmado",
		"desc_pt" : "Turno confirmado",
		"desc_en" : "Confirmed shift",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2823
	},
	{
		"eventoid" : 1297,
		"funcid" : 610,
		"desc_es" : "Turno solicitado",
		"desc_pt" : "Turno solicitado",
		"desc_en" : "Requested shift",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2823
	},
	{
		"eventoid" : 1298,
		"funcid" : 508,
		"desc_es" : "Retardador en uso sin freno de motor habilitado",
		"desc_pt" : "Retardador em uso sem freio do motor habilitado",
		"desc_en" : "Retarder in use without engine brake enabled",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2823
	},
	{
		"eventoid" : 1299,
		"funcid" : 508,
		"desc_es" : "Exceso de esfuerzo en retardador",
		"desc_pt" : "Excesso de esforço no retardador",
		"desc_en" : "Excessive retarder effort",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2824
	},
	{
		"eventoid" : 1300,
		"funcid" : 241,
		"desc_es" : "Movimiento en marcha distinta a la primera",
		"desc_pt" : "Movimento em marcha diferente da primeira",
		"desc_en" : "Movement in gear other than first",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2825
	},
	{
		"eventoid" : 1301,
		"funcid" : 404,
		"desc_es" : "Apertura de válvula 8",
		"desc_pt" : "Abertura da válvula 8",
		"desc_en" : "Valve 8 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2826
	},
	{
		"eventoid" : 1302,
		"funcid" : 404,
		"desc_es" : "Cierre de Válvula 8",
		"desc_pt" : "Fechada da válvula 8",
		"desc_en" : "Valve 8 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2827
	},
	{
		"eventoid" : 1303,
		"funcid" : 404,
		"desc_es" : "Apertura de válvula 9",
		"desc_pt" : "Abertura da válvula 9",
		"desc_en" : "Valve 9 opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2828
	},
	{
		"eventoid" : 1304,
		"funcid" : 404,
		"desc_es" : "Cierre de Válvula 9",
		"desc_pt" : "Fechada da válvula 9",
		"desc_en" : "Valve 9 locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2829
	},
	{
		"eventoid" : 1305,
		"funcid" : 404,
		"desc_es" : "Desconexión de Válvula 8",
		"desc_pt" : "Desconexão da válvula 8",
		"desc_en" : "Valve 8 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2830
	},
	{
		"eventoid" : 1306,
		"funcid" : 404,
		"desc_es" : "Reconexión de Válvula 8",
		"desc_pt" : "Reconexão de Válvula 8",
		"desc_en" : "Valve 8 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2831
	},
	{
		"eventoid" : 1307,
		"funcid" : 404,
		"desc_es" : "Desconexión de Válvula 9",
		"desc_pt" : "Desconexão da válvula 9",
		"desc_en" : "Valve 9 disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2832
	},
	{
		"eventoid" : 1308,
		"funcid" : 404,
		"desc_es" : "Reconexión de Válvula 9",
		"desc_pt" : "Reconexão de Válvula 9",
		"desc_en" : "Valve 9 Reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2833
	},
	{
		"eventoid" : 1309,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor de referencia",
		"desc_pt" : "Sensor de referência de bateria fraca",
		"desc_en" : "Low battery reference sensor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2834
	},
	{
		"eventoid" : 1310,
		"funcid" : 404,
		"desc_es" : "Desconexión de sensor de referencia",
		"desc_pt" : "Desconexão do sensor de referência",
		"desc_en" : "Reference sensor disconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2835
	},
	{
		"eventoid" : 1311,
		"funcid" : 404,
		"desc_es" : "Reconexión de sensor de referencia",
		"desc_pt" : "Reconexão do sensor de referência",
		"desc_en" : "Reference sensor reconnection",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2836
	},
	{
		"eventoid" : 1312,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor de cajón",
		"desc_pt" : "Sensor de bateria fraca na gaveta",
		"desc_en" : "Low battery drawer sensor",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2837
	},
	{
		"eventoid" : 1313,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor tapa 1",
		"desc_pt" : "Tampa do sensor de pilha fraca 1",
		"desc_en" : "Low battery sensor cover 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2838
	},
	{
		"eventoid" : 1314,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor tapa 2",
		"desc_pt" : "Tampa do sensor de pilha fraca 2",
		"desc_en" : "Low battery sensor cover 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2839
	},
	{
		"eventoid" : 1315,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor tapa 3",
		"desc_pt" : "Tampa do sensor de pilha fraca 3",
		"desc_en" : "Low battery sensor cover 3",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2840
	},
	{
		"eventoid" : 1316,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor tapa 4",
		"desc_pt" : "Tampa do sensor de pilha fraca 4",
		"desc_en" : "Low battery sensor cover 4",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2841
	},
	{
		"eventoid" : 1317,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor tapa 5",
		"desc_pt" : "Tampa do sensor de pilha fraca 5",
		"desc_en" : "Low battery sensor cover 5",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2842
	},
	{
		"eventoid" : 1318,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor tapa 6",
		"desc_pt" : "Tampa do sensor de pilha fraca 6",
		"desc_en" : "Low battery sensor cover 6",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2843
	},
	{
		"eventoid" : 1319,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor tapa 7",
		"desc_pt" : "Tampa do sensor de pilha fraca 7",
		"desc_en" : "Low battery sensor cover 7",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2844
	},
	{
		"eventoid" : 1320,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor tapa 8",
		"desc_pt" : "Tampa do sensor de pilha fraca 8",
		"desc_en" : "Low battery sensor cover 8",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2845
	},
	{
		"eventoid" : 1321,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor tapa 9",
		"desc_pt" : "Tampa do sensor de pilha fraca 9",
		"desc_en" : "Low battery sensor cover 9",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2846
	},
	{
		"eventoid" : 1322,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor de válvula 1",
		"desc_pt" : "Sensor da válvula de bateria fraca 1",
		"desc_en" : "Valve sensor 1 low battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2847
	},
	{
		"eventoid" : 1323,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor de válvula 2",
		"desc_pt" : "Sensor da válvula de bateria fraca 2",
		"desc_en" : "Valve sensor 2 low battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2848
	},
	{
		"eventoid" : 1324,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor de válvula 3",
		"desc_pt" : "Sensor da válvula de bateria fraca 3",
		"desc_en" : "Valve sensor 3 low battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2849
	},
	{
		"eventoid" : 1325,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor de válvula 4",
		"desc_pt" : "Sensor da válvula de bateria fraca 4",
		"desc_en" : "Valve sensor 4 low battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2850
	},
	{
		"eventoid" : 1326,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor de válvula 5",
		"desc_pt" : "Sensor da válvula de bateria fraca 5",
		"desc_en" : "Valve sensor 5 low battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2851
	},
	{
		"eventoid" : 1327,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor de válvula 6",
		"desc_pt" : "Sensor da válvula de bateria fraca 6",
		"desc_en" : "Valve sensor 6 low battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2852
	},
	{
		"eventoid" : 1328,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor de válvula 7",
		"desc_pt" : "Sensor da válvula de bateria fraca 7",
		"desc_en" : "Valve sensor 7 low battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2853
	},
	{
		"eventoid" : 1329,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor de válvula 8",
		"desc_pt" : "Sensor da válvula de bateria fraca 8",
		"desc_en" : "Valve sensor 8 low battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2854
	},
	{
		"eventoid" : 1330,
		"funcid" : 404,
		"desc_es" : "Batería baja sensor de válvula 9",
		"desc_pt" : "Sensor da válvula de bateria fraca 9",
		"desc_en" : "Valve sensor 9 low battery",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2855
	},
	{
		"eventoid" : 1331,
		"funcid" : 440,
		"desc_es" : "Apertura de válvula",
		"desc_pt" : "Abertura da válvula",
		"desc_en" : "Valve opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2856
	},
	{
		"eventoid" : 1332,
		"funcid" : 440,
		"desc_es" : "Cierre de Válvula",
		"desc_pt" : "Fechada da válvula",
		"desc_en" : "Valve locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2857
	},
	{
		"eventoid" : 1333,
		"funcid" : 440,
		"desc_es" : "Reporte de nivel",
		"desc_pt" : "Relatório de nível",
		"desc_en" : "Level report",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2858
	},
	{
		"eventoid" : 1288,
		"funcid" : 456,
		"desc_es" : "Reporte de batería",
		"desc_pt" : "Relatório da bateria",
		"desc_en" : "Battery report",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2815
	},
	{
		"eventoid" : 1335,
		"funcid" : 70,
		"desc_es" : "Detección de Humo",
		"desc_pt" : "Detecção de fumaça",
		"desc_en" : "Smoke Detection",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2860
	},
	{
		"eventoid" : 1336,
		"funcid" : 510,
		"desc_es" : "Acelerador bloqueado",
		"desc_pt" : "Acelerador bloqueado",
		"desc_en" : "Accelerator blocked",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2861
	},
	{
		"eventoid" : 1341,
		"funcid" : 4,
		"desc_es" : "Inicio alerta en cabina",
		"desc_pt" : "Início do alerta de cabina",
		"desc_en" : "Start cabin alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "1",
		"orden" : 2866
	},
	{
		"eventoid" : 1342,
		"funcid" : 4,
		"desc_es" : "Fin alerta en cabina",
		"desc_pt" : "Fim do alerta de cabina",
		"desc_en" : "End cabin alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "1",
		"orden" : 2867
	},
	{
		"eventoid" : 1344,
		"funcid" : 287,
		"desc_es" : "Pérdida datos CAN",
		"desc_pt" : "CAN perda de dados",
		"desc_en" : "CAN data loss",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2869
	},
	{
		"eventoid" : 1337,
		"funcid" : 510,
		"desc_es" : "Acelerador desbloqueado",
		"desc_pt" : "Acelerador desbloqueado",
		"desc_en" : "Accelerator unlocked",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2862
	},
	{
		"eventoid" : 1338,
		"funcid" : 32,
		"desc_es" : "Desactivación de Sirena",
		"desc_pt" : "Desativação da sirene",
		"desc_en" : "Siren deactivation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2863
	},
	{
		"eventoid" : 1345,
		"funcid" : 287,
		"desc_es" : "Recupero datos CAN",
		"desc_pt" : "Recupero dados CAN",
		"desc_en" : "Recover CAN data",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2870
	},
	{
		"eventoid" : 1346,
		"funcid" : 440,
		"desc_es" : "Reporte de sobrellenado",
		"desc_pt" : "Reporte de sobrellenado",
		"desc_en" : "Reporte de sobrellenado",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2871
	},
	{
		"eventoid" : 1339,
		"funcid" : 612,
		"desc_es" : "Válvula de freno activa",
		"desc_pt" : "Válvula de freio ativa",
		"desc_en" : "Brake valve active",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2864
	},
	{
		"eventoid" : 1340,
		"funcid" : 612,
		"desc_es" : "Válvula de freno inactiva",
		"desc_pt" : "Válvula de freio inativa",
		"desc_en" : "Brake valve inactive",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2865
	},
	{
		"eventoid" : 1218,
		"funcid" : 4,
		"desc_es" : "Apagado anormal",
		"desc_pt" : "Desconexão da alimentação do equipamento",
		"desc_en" : "Illegal shutdown",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2746
	},
	{
		"eventoid" : 1349,
		"funcid" : 379,
		"desc_es" : "Violación de bloqueo",
		"desc_pt" : "Violação de bloqueio",
		"desc_en" : "Lockout violation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "1",
		"orden" : 2874
	},
	{
		"eventoid" : 324,
		"funcid" : 236,
		"desc_es" : "Advertencia de riesgo de colisión frontal",
		"desc_pt" : "Aviso de risco de colisão frontal",
		"desc_en" : "Forward collision risk warning",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1336
	},
	{
		"eventoid" : 325,
		"funcid" : 236,
		"desc_es" : "Advertencia de riesgo de colisión frontal urbano",
		"desc_pt" : "Aviso de risco de colisão frontal urbana",
		"desc_en" : "Urban forward collision risk warning",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1337
	},
	{
		"eventoid" : 772,
		"funcid" : 290,
		"desc_es" : "Reinicio de ICAN",
		"desc_pt" : "Reinício de telemetria",
		"desc_en" : "ICAN restart",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2396
	},
	{
		"eventoid" : 440,
		"funcid" : 236,
		"desc_es" : "Fin de riesgo de colisión frontal",
		"desc_pt" : "Fim de risco de colisão frontal",
		"desc_en" : "End of forward collision risk",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1469
	},
	{
		"eventoid" : 13,
		"funcid" : 15,
		"desc_es" : "Bloqueo desactivado manualmente",
		"desc_pt" : "Bloqueio desativado manualmente",
		"desc_en" : "Manually deactivated locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 29
	},
	{
		"eventoid" : 14,
		"funcid" : 15,
		"desc_es" : "Bloqueo activado manualmente",
		"desc_pt" : "Bloqueio ativado manualmente",
		"desc_en" : "Manually activated locking",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 25
	},
	{
		"eventoid" : 1388,
		"funcid" : 290,
		"desc_es" : "Temperatura alta de neumático",
		"desc_pt" : "Temperatura alta do pneu",
		"desc_en" : "High tire temperature",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2913
	},
	{
		"eventoid" : 1387,
		"funcid" : 290,
		"desc_es" : "Estado de neumáticos del trailer 2",
		"desc_pt" : "Estado dos pneus do reboque 2",
		"desc_en" : "Tire condition of trailer 2",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2912
	},
	{
		"eventoid" : 1386,
		"funcid" : 290,
		"desc_es" : "Estado de neumáticos del trailer 1",
		"desc_pt" : "Estado dos pneus do reboque 1",
		"desc_en" : "Tire condition of trailer 1",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2911
	},
	{
		"eventoid" : 1385,
		"funcid" : 290,
		"desc_es" : "Estado de neumáticos del tracto",
		"desc_pt" : "Estado dos pneus do trato",
		"desc_en" : "State of the tract tires",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2910
	},
	{
		"eventoid" : 1384,
		"funcid" : 439,
		"desc_es" : "AV 5.0 esclavo 2 desactivado",
		"desc_pt" : "AV 5.0 escravo 2 desativado",
		"desc_en" : "AV 5.0 slave 2 disabled",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2909
	},
	{
		"eventoid" : 1383,
		"funcid" : 439,
		"desc_es" : "AV 5.0 esclavo desactivado",
		"desc_pt" : "AV 5.0 escravo desativado",
		"desc_en" : "AV 5.0 slave disabled",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2908
	},
	{
		"eventoid" : 1382,
		"funcid" : 439,
		"desc_es" : "AV 5.0 master desactivado",
		"desc_pt" : "AV 5.0 master desativado",
		"desc_en" : "AV 5.0 master disabled",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2907
	},
	{
		"eventoid" : 1381,
		"funcid" : 439,
		"desc_es" : "AV 5.0 esclavo 2 saboteado",
		"desc_pt" : "AV 5.0 escravo 2 sabotado",
		"desc_en" : "AV 5.0 slave 2 sabotaged",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2906
	},
	{
		"eventoid" : 1380,
		"funcid" : 439,
		"desc_es" : "AV 5.0 esclavo saboteado",
		"desc_pt" : "AV 5.0 escravo sabotado",
		"desc_en" : "AV 5.0 slave sabotaged",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2905
	},
	{
		"eventoid" : 1367,
		"funcid" : 290,
		"desc_es" : "Alta corriente de motor",
		"desc_pt" : "Corrente alta do motor",
		"desc_en" : "High engine current",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2892
	},
	{
		"eventoid" : 1365,
		"funcid" : 290,
		"desc_es" : "Alta tensión de motor",
		"desc_pt" : "Alta tensão do motor",
		"desc_en" : "High engine voltage",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2890
	},
	{
		"eventoid" : 1350,
		"funcid" : 290,
		"desc_es" : "Inicio de carga de batería",
		"desc_pt" : "Início do carregamento da bateria",
		"desc_en" : "Start battery charging",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2875
	},
	{
		"eventoid" : 1351,
		"funcid" : 290,
		"desc_es" : "Fin de carga de batería",
		"desc_pt" : "Fim do carregamento da bateria",
		"desc_en" : "End battery charge",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2876
	},
	{
		"eventoid" : 1352,
		"funcid" : 290,
		"desc_es" : "Alerta de SOC bajo",
		"desc_pt" : "Alerta de SOC baixo",
		"desc_en" : "Low SOC alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2877
	},
	{
		"eventoid" : 1353,
		"funcid" : 290,
		"desc_es" : "Alta tensión de celda",
		"desc_pt" : "Tensão elevada da célula",
		"desc_en" : "High cell voltage",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2878
	},
	{
		"eventoid" : 1354,
		"funcid" : 290,
		"desc_es" : "Baja tensión de celda",
		"desc_pt" : "Baixa tensão da célula",
		"desc_en" : "Low cell voltage",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2879
	},
	{
		"eventoid" : 1355,
		"funcid" : 290,
		"desc_es" : "Alta tensión de pack",
		"desc_pt" : "Tensão alta do pacote",
		"desc_en" : "High pack voltage",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2880
	},
	{
		"eventoid" : 1356,
		"funcid" : 290,
		"desc_es" : "Baja tensión de pack",
		"desc_pt" : "Tensão baixa do pacote",
		"desc_en" : "Low pack voltage",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2881
	},
	{
		"eventoid" : 1357,
		"funcid" : 290,
		"desc_es" : "Alta corriente de pack",
		"desc_pt" : "Corrente alta do pacote",
		"desc_en" : "High pack current",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2882
	},
	{
		"eventoid" : 1358,
		"funcid" : 290,
		"desc_es" : "Baja corriente de pack",
		"desc_pt" : "Corrente baixa do pacote",
		"desc_en" : "Low pack current",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2883
	},
	{
		"eventoid" : 1359,
		"funcid" : 290,
		"desc_es" : "Alta temperatura de celda",
		"desc_pt" : "Temperatura alta da célula",
		"desc_en" : "High cell temperature",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2884
	},
	{
		"eventoid" : 1360,
		"funcid" : 290,
		"desc_es" : "Baja temperatura de celda",
		"desc_pt" : "Baixa temperatura da célula",
		"desc_en" : "Low cell temperature",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2885
	},
	{
		"eventoid" : 1362,
		"funcid" : 290,
		"desc_es" : "Baja temperatura de refrigerante en entrada",
		"desc_pt" : "Baixa temperatura do refrigerante em entrada",
		"desc_en" : "Low inlet coolant temperature",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2887
	},
	{
		"eventoid" : 1363,
		"funcid" : 290,
		"desc_es" : "Alta temperatura de refrigerante en salida",
		"desc_pt" : "Alta temperatura do refrigerante em saída",
		"desc_en" : "High outlet coolant temperature",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2888
	},
	{
		"eventoid" : 1364,
		"funcid" : 290,
		"desc_es" : "Baja temperatura de refrigerante en salida",
		"desc_pt" : "Baixa temperatura do refrigerante em saída",
		"desc_en" : "Low outlet coolant temperature",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2889
	},
	{
		"eventoid" : 1368,
		"funcid" : 290,
		"desc_es" : "Baja corriente de motor",
		"desc_pt" : "Corrente baixa do motor",
		"desc_en" : "Low engine current",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2893
	},
	{
		"eventoid" : 1415,
		"funcid" : 660,
		"desc_es" : "Desconexión WIFI",
		"desc_pt" : "Desconexão WIFI",
		"desc_en" : "WIFI disconnected",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2940
	},
	{
		"eventoid" : 1416,
		"funcid" : 656,
		"desc_es" : "Emergencia Baúl",
		"desc_pt" : "Emergência Porta-malas",
		"desc_en" : "Trunk emergency",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2941
	},
	{
		"eventoid" : 1379,
		"funcid" : 439,
		"desc_es" : "AV 5.0 esclavo 2 bloqueado OFF",
		"desc_pt" : "AV 5.0 escravo 2 bloqueado OFF",
		"desc_en" : "AV 5.0 slave 2 locked OFF",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2904
	},
	{
		"eventoid" : 1378,
		"funcid" : 439,
		"desc_es" : "AV 5.0 esclavo bloqueado OFF",
		"desc_pt" : "AV 5.0 escravo bloqueado OFF",
		"desc_en" : "AV 5.0 slave locked OFF",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2903
	},
	{
		"eventoid" : 1377,
		"funcid" : 439,
		"desc_es" : "AV 5.0 esclavo 2 bloqueado ON",
		"desc_pt" : "AV 5.0 escravo 2 bloqueado ON",
		"desc_en" : "AV 5.0 slave 2 locked ON",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2902
	},
	{
		"eventoid" : 1376,
		"funcid" : 439,
		"desc_es" : "AV 5.0 esclavo bloqueado ON",
		"desc_pt" : "AV 5.0 escravo bloqueado ON",
		"desc_en" : "AV 5.0 slave locked ON",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2901
	},
	{
		"eventoid" : 1375,
		"funcid" : 439,
		"desc_es" : "AV 5.0 esclavo 2 OFF",
		"desc_pt" : "AV 5.0 escravo 2 OFF",
		"desc_en" : "AV 5.0 escravo 2 OFF",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2900
	},
	{
		"eventoid" : 1374,
		"funcid" : 439,
		"desc_es" : "AV 5.0 esclavo OFF",
		"desc_pt" : "AV 5.0 escravo OFF",
		"desc_en" : "AV 5.0 slave OFF",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2899
	},
	{
		"eventoid" : 1373,
		"funcid" : 439,
		"desc_es" : "AV 5.0 esclavo 2 ON",
		"desc_pt" : "AV 3.0 escravo 2 ON",
		"desc_en" : "AV 3.0 slave 2 ON",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2898
	},
	{
		"eventoid" : 1372,
		"funcid" : 439,
		"desc_es" : "AV 5.0 esclavo ON",
		"desc_pt" : "AV 5.0 escravo ON",
		"desc_en" : "AV 5.0 slave ON",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2897
	},
	{
		"eventoid" : 1371,
		"funcid" : 439,
		"desc_es" : "AV 5.0 vehículo bloqueado motor OFF",
		"desc_pt" : "AV 5.0 vehículo bloqueado motor OFF",
		"desc_en" : "AV 5.0 locked motor OFF",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2896
	},
	{
		"eventoid" : 1370,
		"funcid" : 439,
		"desc_es" : "AV 5.0 vehículo bloqueado motor ON",
		"desc_pt" : "AV 5.0 vehículo bloqueado motor ON",
		"desc_en" : "AV 5.0 locked motor ON",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2895
	},
	{
		"eventoid" : 1395,
		"funcid" : 6,
		"desc_es" : "Alerta de pánico activada",
		"desc_pt" : "Alerta de pânico ativado",
		"desc_en" : "Panic alert activated",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2920
	},
	{
		"eventoid" : 1396,
		"funcid" : 125,
		"desc_es" : "Intento de conducción bloqueado",
		"desc_pt" : "Tentativa de condução bloqueada",
		"desc_en" : "Driving attempt blocked",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2921
	},
	{
		"eventoid" : 1397,
		"funcid" : 79,
		"desc_es" : "Entrada en zona segura de autoresguardo",
		"desc_pt" : "Entrada em zona de autossalvamento",
		"desc_en" : "Self-rescue zone arrival",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2922
	},
	{
		"eventoid" : 1398,
		"funcid" : 79,
		"desc_es" : "Salida de zona segura de autoresguardo",
		"desc_pt" : "Saída de zona de autossalvamento",
		"desc_en" : "Self-rescue zone departure",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2923
	},
	{
		"eventoid" : 1402,
		"funcid" : 508,
		"desc_es" : "Accionamiento de freno retardador",
		"desc_pt" : "Aviso para acionar freio retarder",
		"desc_en" : "Retarder brake in use",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2927
	},
	{
		"eventoid" : 855,
		"funcid" : 267,
		"desc_es" : "Enganche de unidad identificada",
		"desc_pt" : "Engate de unidade identificada",
		"desc_en" : "Identified unit coupling",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 412
	},
	{
		"eventoid" : 856,
		"funcid" : 267,
		"desc_es" : "Desenganche de unidad identificada",
		"desc_pt" : "Desengate de unidade identificada",
		"desc_en" : "Identified unit uncoupling",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 413
	},
	{
		"eventoid" : 1408,
		"funcid" : 127,
		"desc_es" : "Fin de detección de inhibición celular 4G",
		"desc_pt" : "Fim de detenção de inibição de celular 4G",
		"desc_en" : "End of 4G cell inhibition detection",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2933
	},
	{
		"eventoid" : 1403,
		"funcid" : 262,
		"desc_es" : "Activación manual de video",
		"desc_pt" : "Ativação manual de vídeo",
		"desc_en" : "Manual video activation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2928
	},
	{
		"eventoid" : 1404,
		"funcid" : 262,
		"desc_es" : "Desactivación manual de video",
		"desc_pt" : "Desativação manual de vídeo",
		"desc_en" : "Manual video deactivation",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2929
	},
	{
		"eventoid" : 1409,
		"funcid" : 127,
		"desc_es" : "Fin de detección de inhibición celular 5G",
		"desc_pt" : "Fim de detenção de inibição de celular 5G",
		"desc_en" : "End of 5G cell inhibition detection",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2934
	},
	{
		"eventoid" : 326,
		"funcid" : 236,
		"desc_es" : "Advertencia de colisión de obstáculos",
		"desc_pt" : "Alerta de risco de colisão com pessoa",
		"desc_en" : "Pedestrian collision risk alert",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1338
	},
	{
		"eventoid" : 441,
		"funcid" : 236,
		"desc_es" : "Fin de Advertencia de colisión de obstáculos",
		"desc_pt" : "Fim de risco de colisão com pessoa",
		"desc_en" : "End of pedestrian collision risk",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1470
	},
	{
		"eventoid" : 1405,
		"funcid" : 648,
		"desc_es" : "Condición anormal",
		"desc_pt" : "Condição anormal",
		"desc_en" : "Abnormal condition",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2930
	},
	{
		"eventoid" : 1411,
		"funcid" : 653,
		"desc_es" : "Unidad disponible",
		"desc_pt" : "Unidade disponível",
		"desc_en" : "Available unit",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2936
	},
	{
		"eventoid" : 1366,
		"funcid" : 290,
		"desc_es" : "Baja tensión de motor",
		"desc_pt" : "Baixa tensão do motor",
		"desc_en" : "Low engine voltage",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2891
	},
	{
		"eventoid" : 1399,
		"funcid" : 381,
		"desc_es" : "Bloqueo por emociograma malo",
		"desc_pt" : "Emociograma ruim",
		"desc_en" : "Blocked for bad emotiogram",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2924
	},
	{
		"eventoid" : 1400,
		"funcid" : 381,
		"desc_es" : "Bloqueo por emociograma regular",
		"desc_pt" : "Emociograma regular",
		"desc_en" : "Blocked for regular emotiogram",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2925
	},
	{
		"eventoid" : 1401,
		"funcid" : 381,
		"desc_es" : "Emociograma ok",
		"desc_pt" : "Emociograma ok",
		"desc_en" : "Emotiogram ok",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2926
	},
	{
		"eventoid" : 1361,
		"funcid" : 290,
		"desc_es" : "Alta temperatura de refrigerante en entrada",
		"desc_pt" : "Alta temperatura do refrigerante em entrada",
		"desc_en" : "High inlet coolant temperature",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2886
	},
	{
		"eventoid" : 1417,
		"funcid" : 656,
		"desc_es" : "Emergencia habitáculo",
		"desc_pt" : "Emergência habitáculo",
		"desc_en" : "Cabin emergency",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2942
	},
	{
		"eventoid" : 1418,
		"funcid" : 667,
		"desc_es" : "Baja señal celular",
		"desc_pt" : "Baixa sinal celular",
		"desc_en" : "Low cellular signal",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2943
	},
	{
		"eventoid" : 766,
		"funcid" : 423,
		"desc_es" : "Sabotaje Caja Recaudadora",
		"desc_pt" : "Sabotagem da Caixa do Coletor",
		"desc_en" : "Sabotage Collector Box",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2388
	},
	{
		"eventoid" : 1420,
		"funcid" : 670,
		"desc_es" : "Descanso en zona no cumplido",
		"desc_pt" : "Descanso na zona não cumprido",
		"desc_en" : "Rest in area not completed",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2945
	},
	{
		"eventoid" : 628,
		"funcid" : 404,
		"desc_es" : "Apertura de gabinete",
		"desc_pt" : "Abertura de gabinete",
		"desc_en" : "Cabinet opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2252
	},
	{
		"eventoid" : 724,
		"funcid" : 404,
		"desc_es" : "(log) Apertura de gabinete",
		"desc_pt" : "(log) Abertura de gabinete",
		"desc_en" : "(log) Cabinet opening",
		"eventotablaid" : 1,
		"esalarma" : "0",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 2346
	},
	{
		"eventoid" : 133,
		"funcid" : 95,
		"desc_es" : "Apertura de gabinete",
		"desc_pt" : "Abertura de gabinete",
		"desc_en" : "Cabinet opening",
		"eventotablaid" : 1,
		"esalarma" : "1",
		"mapaid" : 1,
		"esalerta" : "0",
		"orden" : 1224
	}
]}
